import { jsxs as w, jsx as t, Fragment as Se } from "react/jsx-runtime";
import * as _r from "react";
import V, { forwardRef as He, cloneElement as Fr, useState as J, useEffect as le, useCallback as H, useRef as ce, useMemo as ze, createContext as Sr, useContext as Nr, useReducer as w0, useImperativeHandle as v0 } from "react";
import O from "clsx";
import { twMerge as Mr } from "tailwind-merge";
import { Root as Er, Thumb as Ir } from "@radix-ui/react-switch";
import { ImSpinner2 as Lr } from "react-icons/im";
import * as Lt from "@radix-ui/react-avatar";
import { useImage as Ar } from "react-image";
import { Root as r0, Indicator as Br } from "@radix-ui/react-checkbox";
import At from "react-player";
import Tr from "date-fns/format";
import Zr from "markdown-to-jsx";
import Rr from "sanitize-html-react";
import { keyframes as ye, styled as Ne } from "@stitches/react";
import { createPortal as Pr } from "react-dom";
import { Root as Or, Trigger as Dr, Value as $r, Icon as jr, Portal as Vr, Content as Wr, Viewport as Hr, Group as zr, Item as Ur, ItemText as qr } from "@radix-ui/react-select";
import Gr from "react-otp-input";
import * as ut from "@radix-ui/react-dialog";
import * as Ve from "@radix-ui/react-toast";
import gt from "lodash-es/debounce";
import { Splide as Yr, SplideSlide as Xr, SplideTrack as Kr } from "@splidejs/react-splide";
import * as rt from "@radix-ui/react-accordion";
import x0 from "date-fns/differenceInCalendarDays";
import C0 from "date-fns/differenceInHours";
import Qr from "date-fns/differenceInMinutes";
const o0 = (e) => {
  switch (e) {
    case "sm":
      return 12;
    case "lg":
      return 16;
    default:
      return 12;
  }
}, y0 = He(
  ({ color: e, children: r, className: o, size: n = "md", icon: i }, s) => /* @__PURE__ */ w(
    "div",
    {
      className: O(
        "inline-flex h-fit w-fit rounded-cr-xl  items-center",
        n === "sm" && "text-body-xs-700-capps py-cr-half px-cr-2",
        n === "md" && "text-body-sm-700-capps py-cr-1 px-cr-2",
        n === "lg" && "text-body-md-700-capps py-cr-1 px-cr-3",
        e === "purple-soft" && "bg-purple-100 text-purple-500",
        e === "purple-strong" && "bg-purple-300 text-white",
        e === "lime-soft" && "bg-lime-200 text-neutral-500",
        e === "lime-strong" && "bg-lime-500 text-neutral-500",
        e === "sky-soft" && "bg-sky-200 text-neutral-500",
        e === "sky-strong" && "bg-sky-500 text-neutral-500",
        e === "flamingo-soft" && "bg-flamingo-200 text-neutral-500",
        e === "flamingo-strong" && "bg-flamingo-500 text-white",
        e === "neutral-soft" && "bg-neutral-100 text-neutral-400",
        e === "neutral-strong" && "bg-neutral-300 text-white",
        e === "transparent-dark-50" && "bg-transparent-dark-50 text-white",
        e === "transparent-dark-50" && "bg-transparent-dark-50 text-white",
        e === "error-soft" && "bg-error-100 text-error-500",
        e === "error-strong" && "bg-error-500 text-white",
        e === "alert-soft" && "bg-alert-100 text-neutral-500",
        e === "alert-strong" && "bg-alert-500 text-neutral-500",
        e === "success-soft" && "bg-success-100 text-success-600",
        e === "success-strong" && "bg-success-500 text-neutral-500",
        // Deprecation
        e === "success-dark" && "bg-success-500",
        e === "success" && "bg-lime-500",
        e === "danger" && "bg-flamingo-100 text-flamingo-600",
        e === "warning" && "bg-orange-200 text-orange-600",
        e === "neutral" && "bg-neutral-100",
        e === "sky" && "bg-sky-200",
        e === "dark" && "bg-neutral-900 bg-opacity-50 text-white",
        o
      ),
      children: [
        i && Fr(i, {
          height: o0(n),
          width: o0(n),
          strokecolor: "currentcolor"
        }),
        /* @__PURE__ */ t("span", { ref: s, className: O("flex-grow", i && "pl-cr-1"), children: r })
      ]
    }
  )
);
y0.displayName = "Badge";
const kt = y0;
function C(...e) {
  return Mr(O(...e));
}
const k0 = V.forwardRef(
  ({
    buttonHeight: e = 20,
    buttonWidth: r = 36,
    thumbHeight: o = 16,
    thumbWidth: n = 16,
    label: i,
    ...s
  }, a) => /* @__PURE__ */ t(
    Er,
    {
      className: C(
        i && "bg-neutral-200 dark:bg-neutral-200 relative inline-flex flex-shrink-0 cursor-pointer rounded-full border items-center",
        i && "data-[state=checked]:bg-primary-500 data-[state=checked]:border-blue-500 data-[state=checked]:transition-colors data-[state=checked]:duration-200 data-[state=checked]:ease-in-out data-[state=checked]:ring-offset-0 data-[state=checked]:ring-2 data-[state=checked]:ring-blue-500",
        !i && "bg-neutral-200 dark:bg-neutral-200 relative inline-flex flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-opacity-75 items-center",
        !i && "data-[state=checked]:bg-primary-500",
        e
      ),
      id: "toggle-thumb",
      ...s,
      ref: a,
      style: {
        height: e,
        width: r
      },
      children: /* @__PURE__ */ t(
        Ir,
        {
          className: C(
            "pointer-events-none inline-block transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out",
            "data-[state=checked]:translate-x-4"
          ),
          style: {
            height: o,
            width: n
          }
        }
      )
    }
  )
);
k0.displayName = "Toggle";
const Ss = k0, Jr = ({
  strokecolor: e = "currentColor",
  height: r = "32",
  width: o = "32",
  ...n
}) => /* @__PURE__ */ t(
  "svg",
  {
    width: o,
    height: r,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M12 28L24 16L12 4.00002",
        stroke: e,
        strokeWidth: "1.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), _0 = Jr, eo = ({
  strokecolor: e = "currentColor",
  width: r = "32",
  height: o = "32",
  ...n
}) => /* @__PURE__ */ t(
  "svg",
  {
    width: r,
    height: o,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M20 28L8 16L20 4.00002",
        stroke: e,
        strokeWidth: "1.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), F0 = eo, to = (e) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    className: "download_svg__h-6 download_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    ...e,
    children: /* @__PURE__ */ t(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
      }
    )
  }
), ro = to, oo = ({
  width: e = "16",
  height: r = "16",
  ...o
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    ...o,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "circle",
        {
          cx: "3.5",
          cy: "3.5",
          r: "1.5",
          stroke: "currentColor",
          strokeWidth: "1.25",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "circle",
        {
          cx: "8",
          cy: "8",
          r: "1.5",
          stroke: "currentColor",
          strokeWidth: "1.25",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "circle",
        {
          cx: "12.5",
          cy: "12.5",
          r: "1.5",
          stroke: "currentColor",
          strokeWidth: "1.25",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5 3.5H14",
          stroke: "currentColor",
          strokeWidth: "1.25",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2 12.5H11",
          stroke: "currentColor",
          strokeWidth: "1.25",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2 8L6.5 8",
          stroke: "currentColor",
          strokeWidth: "1.25",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9.5 8L14 8",
          stroke: "currentColor",
          strokeWidth: "1.25",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), no = oo, io = ({
  height: e = 24,
  width: r = 24,
  strokecolor: o = "#282828",
  ...n
}) => /* @__PURE__ */ w(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: r,
    height: e,
    viewBox: "0 0 32 32",
    ...n,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M3 3L29 29",
          stroke: o,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M3 29L29 3",
          stroke: o,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), ao = io, so = ({
  width: e = 16,
  height: r = 16,
  ...o
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...o,
    children: [
      /* @__PURE__ */ t(
        "circle",
        {
          cx: 8,
          cy: 8,
          r: 2,
          stroke: "#868686",
          strokeWidth: 1.25,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M14.71 8A7.003 7.003 0 0 0 1.29 8a7.003 7.003 0 0 0 13.42 0Z",
          stroke: "#868686",
          strokeWidth: 1.25,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), lo = so, co = ({
  width: e = 16,
  height: r = 16,
  ...o
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...o,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M10 8a2 2 0 0 1-2 2M6 8a2 2 0 0 1 2-2",
          stroke: "#868686",
          strokeWidth: 1.25,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.41 5.607c.565.7.997 1.51 1.26 2.393A7.003 7.003 0 0 1 6 12.722m4-9.42A7.003 7.003 0 0 0 1.25 8c.291.978.79 1.866 1.446 2.614M13.96 2l-12 12",
          stroke: "#868686",
          strokeWidth: 1.25,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), uo = co, fo = ({
  height: e = 13,
  width: r = 14,
  fillcolor: o = "#6222B2",
  ...n
}) => /* @__PURE__ */ t(
  "svg",
  {
    width: r,
    height: e,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: o,
    ...n,
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M1 5.75C1 3.67893 2.67893 2 4.75 2C5.98409 2 7.07895 2.59613 7.76233 3.51614C7.87709 3.67064 8.12291 3.67064 8.23767 3.51614C8.92105 2.59613 10.0159 2 11.25 2C13.3211 2 15 3.67893 15 5.75C15 6.79347 14.566 7.74513 13.8782 8.42494L8.71866 13.7573C8.32564 14.1635 7.67436 14.1635 7.28134 13.7573L2.12185 8.42494C1.43404 7.74513 1 6.79347 1 5.75Z",
        className: "fill-current hover:opacity-80"
      }
    )
  }
), Dt = fo, po = ({
  height: e = 13,
  width: r = 14,
  strokecolor: o = "#868686",
  className: n,
  ...i
}) => /* @__PURE__ */ t(
  "svg",
  {
    color: o,
    stroke: o,
    width: r,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M2.25 8.925C2.25 6.06693 4.58851 3.75 7.47321 3.75C9.17614 3.75 10.6887 4.55742 11.6422 5.80695C11.8166 6.03539 12.1834 6.03539 12.3578 5.80695C13.3113 4.55742 14.8239 3.75 16.5268 3.75C19.4115 3.75 21.75 6.06693 21.75 8.925C21.75 10.365 21.1454 11.6783 20.1874 12.6164L13.0731 19.9011C12.4846 20.5038 11.5154 20.5038 10.9269 19.9011L3.81257 12.6164C2.85455 11.6783 2.25 10.365 2.25 8.925Z",
        className: C(
          "stroke-current stroke-[1.5px] hover:fill-current",
          n
        )
      }
    )
  }
), $t = po, mo = ({
  height: e = "32",
  width: r = "32",
  ...o
}) => /* @__PURE__ */ t(
  "svg",
  {
    width: r,
    height: e,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...o,
    children: /* @__PURE__ */ t(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M32.5 60C47.964 60 60.5 47.464 60.5 32C60.5 16.536 47.964 4 32.5 4C17.036 4 4.5 16.536 4.5 32C4.5 47.464 17.036 60 32.5 60ZM27.8353 20.3067C26.3906 19.4841 24.5 20.4127 24.5 21.9449V42.0551C24.5 43.5873 26.3906 44.5159 27.8353 43.6933L45.4949 33.6382C46.835 32.8752 46.835 31.1249 45.4949 30.3618L27.8353 20.3067Z",
        fill: "white"
      }
    )
  }
), ho = mo, go = ({
  width: e = 16,
  height: r = 16,
  ...o
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ...o,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M7.981.535s4.401-.196 6.735 4.212h-7.11S6.266 4.704 5.12 6.325c-.33.681-.683 1.382-.286 2.764-.572-.966-3.037-5.242-3.037-5.242S3.534.71 7.98.535Z",
          fill: "#EF3F36"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M14.487 11.726s-2.03 3.897-7.027 3.705c.618-1.064 3.556-6.135 3.556-6.135s.71-1.136-.128-2.936c-.426-.625-.86-1.28-2.259-1.628 1.126-.01 6.074 0 6.074 0s1.854 3.07-.216 6.994Z",
          fill: "#FCD900"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M1.506 11.757S-.867 8.056 1.8 3.84c.615 1.065 3.553 6.135 3.553 6.135s.634 1.18 2.616 1.357c.755-.055 1.54-.102 2.545-1.134-.554.976-3.037 5.24-3.037 5.24s-3.597.066-5.971-3.681Z",
          fill: "#61BC5B"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "m7.458 15.467 1-4.158s1.1-.086 2.021-1.092c-.572 1.002-3.02 5.25-3.02 5.25Z",
          fill: "#5AB055"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M4.631 8.047a3.326 3.326 0 0 1 3.332-3.319 3.326 3.326 0 0 1 3.33 3.32 3.326 3.326 0 0 1-3.33 3.319 3.327 3.327 0 0 1-3.332-3.32Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.189 8.048a2.769 2.769 0 0 1 2.773-2.764 2.769 2.769 0 0 1 2.774 2.764 2.769 2.769 0 0 1-2.774 2.763A2.77 2.77 0 0 1 5.19 8.048Z",
          fill: "url(#a)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "m14.701 4.734-4.117 1.204s-.622-.908-1.957-1.204c1.159-.006 6.074 0 6.074 0Z",
          fill: "#EACA05"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "m4.753 8.937-2.957-5.09 3.05 3.005s-.314.642-.196 1.56l.103.525Z",
          fill: "#DF3A32"
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ w(
        "linearGradient",
        {
          id: "a",
          x1: 7.962,
          y1: 5.323,
          x2: 7.962,
          y2: 10.645,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ t("stop", { stopColor: "#86BBE5" }),
            /* @__PURE__ */ t("stop", { offset: 1, stopColor: "#1072BA" })
          ]
        }
      ) })
    ]
  }
), bo = go, wo = ({
  width: e = 16,
  height: r = 16,
  ...o
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...o,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M8 15.467A7.467 7.467 0 1 0 8 .533a7.467 7.467 0 0 0 0 14.934Z",
          fill: "url(#a)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M8 14.907A6.907 6.907 0 1 0 8 1.093a6.907 6.907 0 0 0 0 13.814Z",
          fill: "url(#b)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M8.012 2.773c-.047 0-.088-.035-.088-.081v-1.22c0-.046.041-.081.088-.081.046 0 .087.035.087.082v1.219c-.006.046-.04.081-.087.081Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M8.012 2.78c-.053 0-.094-.042-.094-.088v-1.22c0-.046.041-.087.094-.087.052 0 .093.04.093.087v1.22c0 .046-.047.087-.093.087Zm0-1.383c-.041 0-.082.035-.082.075v1.22c0 .04.035.076.082.076.04 0 .081-.036.081-.076v-1.22c-.005-.04-.04-.075-.081-.075Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M8.595 2.12c-.047-.006-.082-.04-.082-.087l.041-.543a.085.085 0 0 1 .094-.076c.046.006.081.041.081.088l-.04.542a.085.085 0 0 1-.094.076Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M8.595 2.126a.095.095 0 0 1-.087-.094l.04-.542c.006-.047.047-.088.1-.082a.095.095 0 0 1 .087.094l-.04.542c-.007.053-.047.088-.1.082Zm.053-.706c-.041 0-.082.03-.082.07l-.041.543c0 .04.03.075.076.081.04 0 .082-.029.082-.07l.04-.542c0-.041-.035-.076-.075-.082Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9.033 2.878a.09.09 0 0 1-.07-.099l.239-1.196c.011-.046.052-.075.099-.064a.09.09 0 0 1 .07.1l-.24 1.195c-.005.041-.052.07-.099.064Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9.033 2.884a.095.095 0 0 1-.076-.105l.239-1.196a.094.094 0 0 1 .11-.07.095.095 0 0 1 .077.105l-.24 1.196c-.011.047-.058.076-.11.07Zm.274-1.359a.084.084 0 0 0-.094.058L8.974 2.78a.083.083 0 0 0 .064.094.084.084 0 0 0 .094-.059l.239-1.196c.006-.046-.023-.081-.064-.093Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9.732 2.353a.087.087 0 0 1-.064-.105l.146-.525c.012-.046.058-.07.105-.058a.087.087 0 0 1 .064.105l-.146.525c-.011.047-.058.07-.105.058Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9.733 2.36c-.047-.012-.082-.065-.065-.112l.146-.525c.012-.046.064-.075.111-.064.047.012.082.064.064.111l-.146.525c-.011.047-.058.076-.11.064Zm.192-.683c-.04-.012-.087.011-.1.052l-.145.525c-.012.041.012.082.058.094.041.011.088-.012.1-.053l.145-.525a.084.084 0 0 0-.058-.093Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M10.018 3.176c-.046-.018-.064-.07-.046-.111l.466-1.126c.018-.04.07-.064.111-.04.047.017.064.07.047.11l-.467 1.126c-.017.04-.07.064-.11.04Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M10.018 3.182a.09.09 0 0 1-.052-.117l.466-1.126c.018-.046.07-.064.123-.046a.09.09 0 0 1 .053.116l-.467 1.126c-.024.047-.076.07-.123.047Zm.531-1.278a.08.08 0 0 0-.105.041l-.466 1.126c-.018.04.005.082.046.1a.08.08 0 0 0 .105-.042l.467-1.126a.083.083 0 0 0-.047-.099Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M10.806 2.802c-.041-.023-.059-.07-.041-.11l.245-.485a.085.085 0 0 1 .117-.035c.04.024.058.07.04.111l-.245.484a.085.085 0 0 1-.116.035Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M10.806 2.808a.09.09 0 0 1-.041-.122l.245-.484a.09.09 0 0 1 .123-.041.09.09 0 0 1 .04.122l-.245.485a.09.09 0 0 1-.122.04Zm.32-.635c-.04-.018-.087-.006-.104.035l-.245.484c-.018.035 0 .081.035.105.04.017.087.006.105-.035l.245-.484c.017-.035 0-.082-.035-.105Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M10.923 3.666c-.041-.03-.053-.082-.024-.117l.677-1.009c.023-.04.076-.047.117-.023.04.029.052.081.023.116l-.677 1.01a.079.079 0 0 1-.116.023Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M10.923 3.672a.1.1 0 0 1-.03-.129l.677-1.009a.092.092 0 0 1 .128-.023.1.1 0 0 1 .03.128l-.677 1.01a.093.093 0 0 1-.128.023Zm.77-1.15c-.035-.023-.088-.017-.111.018l-.677 1.01a.076.076 0 0 0 .023.104c.035.024.088.018.111-.017l.677-1.004a.083.083 0 0 0-.023-.11Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M11.774 3.45c-.035-.03-.046-.082-.017-.117l.338-.425a.083.083 0 0 1 .117-.012c.035.029.046.082.017.117l-.338.425a.083.083 0 0 1-.117.012Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M11.768 3.456c-.04-.03-.046-.088-.017-.129l.338-.425c.03-.041.088-.047.128-.012.041.03.047.087.018.128l-.338.426c-.03.041-.088.047-.129.012Zm.438-.554c-.035-.03-.082-.024-.111.011l-.338.426a.083.083 0 0 0 .017.11c.035.03.082.024.111-.01l.338-.427c.024-.035.018-.087-.017-.11Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M11.716 4.325c-.035-.035-.035-.087 0-.117l.863-.857a.083.083 0 0 1 .117 0c.029.03.035.087 0 .117l-.858.857a.085.085 0 0 1-.122 0Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M11.71 4.33a.091.091 0 0 1 0-.127l.863-.858a.092.092 0 0 1 .129 0 .092.092 0 0 1 0 .128l-.864.858a.092.092 0 0 1-.128 0Zm.986-.98a.081.081 0 0 0-.111 0l-.863.858a.08.08 0 0 0 0 .111c.029.03.081.03.11 0l.864-.857c.029-.03.029-.076 0-.111Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12.59 4.278c-.028-.035-.028-.087.007-.116l.414-.35a.083.083 0 0 1 .117.011c.029.035.029.088-.006.117l-.415.35a.083.083 0 0 1-.116-.012Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12.585 4.284c-.035-.04-.03-.099.006-.128l.414-.35c.035-.035.093-.03.128.011.035.041.03.1-.005.129l-.415.35c-.035.035-.093.029-.128-.012Zm.537-.46c-.03-.036-.076-.036-.111-.012l-.414.35a.081.081 0 0 0-.006.11c.029.035.076.035.11.012l.415-.35c.035-.029.035-.076.006-.11Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12.358 5.118a.079.079 0 0 1 .023-.116l1.015-.677c.04-.023.093-.012.116.023.03.041.018.094-.023.117l-1.015.677c-.035.023-.087.011-.116-.024Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12.352 5.118a.093.093 0 0 1 .023-.128l1.015-.677a.09.09 0 0 1 .128.03c.03.04.018.099-.023.128l-1.015.677a.09.09 0 0 1-.128-.03Zm1.155-.764a.076.076 0 0 0-.105-.023l-1.015.677c-.035.023-.047.07-.018.11.023.035.07.047.105.024l1.015-.677a.083.083 0 0 0 .018-.11Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.227 5.24a.085.085 0 0 1 .029-.116l.472-.268c.041-.023.094-.006.117.035a.085.085 0 0 1-.03.117l-.472.268c-.04.023-.093.006-.116-.035Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.221 5.247c-.023-.047-.012-.1.03-.123l.472-.268c.04-.023.099-.006.122.035.023.047.012.1-.029.122l-.473.269c-.04.023-.099.006-.122-.035Zm.618-.35c-.023-.041-.07-.053-.105-.03l-.472.269a.084.084 0 0 0-.03.105c.024.04.07.052.106.03L13.81 5c.035-.017.047-.063.03-.104Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12.836 6.017c-.018-.047 0-.094.046-.111l1.126-.467c.041-.017.094.006.111.047.018.047 0 .093-.047.11l-1.125.467a.084.084 0 0 1-.111-.046Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12.83 6.022c-.017-.046 0-.099.047-.122l1.126-.467a.09.09 0 0 1 .116.053c.018.046 0 .099-.046.122l-1.126.467a.09.09 0 0 1-.117-.053Zm1.278-.53a.083.083 0 0 0-.1-.047l-1.125.467a.08.08 0 0 0-.041.105c.017.04.064.058.099.046l1.126-.466c.04-.018.058-.065.04-.105Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.658 6.308c-.017-.046.006-.093.053-.11l.513-.17c.041-.017.094.012.105.053.018.047-.006.093-.052.11l-.514.17c-.04.017-.087-.006-.105-.053Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.652 6.314a.089.089 0 0 1 .059-.116l.513-.17c.047-.017.1.012.117.059a.09.09 0 0 1-.059.116l-.513.17a.1.1 0 0 1-.117-.059Zm.677-.221c-.012-.041-.058-.065-.1-.053l-.512.17c-.041.01-.059.057-.047.098.012.041.058.065.1.053l.512-.17a.08.08 0 0 0 .047-.098Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.133 7.002c-.011-.046.018-.093.065-.099l1.195-.233c.047-.012.088.023.1.07.011.047-.018.093-.065.1l-1.196.232c-.046.006-.093-.023-.099-.07Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.122 7.003a.094.094 0 0 1 .07-.111l1.195-.234c.047-.011.094.024.105.076a.094.094 0 0 1-.07.111l-1.195.233c-.047.012-.094-.023-.105-.075Zm1.359-.263a.078.078 0 0 0-.088-.064l-1.196.233c-.04.006-.07.053-.058.094.006.04.047.07.088.064l1.195-.234c.041-.011.07-.052.059-.093Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.88 7.452c-.006-.047.023-.088.07-.094l.537-.064a.085.085 0 0 1 .093.076c.006.047-.023.087-.07.093l-.537.064c-.04.006-.087-.029-.093-.075Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.874 7.452c-.006-.053.03-.1.076-.105l.537-.065a.09.09 0 0 1 .099.082c.006.053-.03.1-.076.105l-.537.064a.09.09 0 0 1-.099-.081Zm.706-.082c-.006-.04-.047-.076-.088-.07l-.536.064a.078.078 0 0 0-.064.088c.006.04.046.075.087.07l.537-.065a.078.078 0 0 0 .064-.087Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.227 8.018c0-.047.035-.088.082-.088h1.219c.046 0 .081.04.081.088 0 .046-.035.087-.081.087h-1.22c-.046 0-.081-.04-.081-.087Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.22 8.018c0-.053.042-.094.088-.094h1.22c.046 0 .087.041.087.094 0 .052-.04.093-.087.093h-1.22c-.046 0-.087-.041-.087-.093Zm1.383.005c0-.04-.035-.081-.075-.081h-1.22c-.04 0-.075.035-.075.081 0 .041.035.082.075.082h1.22c.04-.006.075-.04.075-.082Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.874 8.607c.006-.047.041-.082.088-.082l.542.04a.085.085 0 0 1 .076.094c-.006.047-.04.082-.088.082L13.95 8.7c-.04-.006-.076-.047-.076-.093Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.868 8.607a.095.095 0 0 1 .094-.088l.542.041c.047.006.088.047.082.1a.095.095 0 0 1-.094.087l-.542-.041c-.047-.006-.082-.053-.082-.1Zm.712.052a.074.074 0 0 0-.07-.081l-.543-.041c-.04 0-.075.029-.081.076-.006.04.029.081.07.081l.542.041c.041 0 .076-.035.082-.076Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.122 9.033a.09.09 0 0 1 .099-.07l1.196.239c.046.011.076.052.064.099a.09.09 0 0 1-.1.07l-1.195-.24c-.04-.005-.07-.052-.064-.098Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.116 9.032a.095.095 0 0 1 .105-.075l1.196.239a.094.094 0 0 1 .07.11.095.095 0 0 1-.105.076l-1.196-.239c-.047-.011-.076-.058-.07-.11Zm1.36.275a.084.084 0 0 0-.06-.094l-1.195-.239a.083.083 0 0 0-.094.064.084.084 0 0 0 .059.094l1.196.239c.046.006.081-.024.093-.064Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.647 9.732a.086.086 0 0 1 .07-.065.087.087 0 0 1 .035.001l.525.146c.046.012.07.059.058.105a.086.086 0 0 1-.071.066.087.087 0 0 1-.034-.002l-.525-.146c-.047-.011-.07-.058-.058-.105Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.64 9.733c.012-.047.065-.082.112-.065l.525.146a.093.093 0 0 1 .064.111c-.012.047-.064.082-.111.064l-.525-.146c-.047-.011-.076-.058-.064-.11Zm.683.192c.012-.04-.011-.087-.052-.1l-.525-.145c-.041-.012-.082.012-.094.058-.011.041.012.088.053.1l.525.145a.084.084 0 0 0 .093-.058Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12.824 10.012c.018-.046.07-.064.11-.046l1.127.466c.04.018.064.07.046.111a.083.083 0 0 1-.11.047l-1.126-.467a.083.083 0 0 1-.047-.11Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12.818 10.007a.091.091 0 0 1 .117-.053l1.126.467c.046.017.064.07.046.122a.09.09 0 0 1-.116.053l-1.126-.467a.097.097 0 0 1-.047-.122Zm1.278.53a.08.08 0 0 0-.041-.104l-1.126-.467c-.04-.018-.081.006-.099.047a.08.08 0 0 0 .04.105l1.127.466c.04.012.087-.006.099-.046Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.203 10.8c.024-.04.07-.058.111-.04l.484.244c.041.018.059.07.035.117-.023.04-.07.058-.11.04l-.485-.244c-.04-.024-.058-.076-.035-.117Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M13.197 10.794a.09.09 0 0 1 .123-.04l.484.244a.09.09 0 0 1 .041.123.089.089 0 0 1-.122.04l-.485-.244c-.046-.018-.064-.076-.04-.123Zm.63.321c.018-.04.006-.088-.034-.105l-.485-.245c-.035-.018-.081 0-.105.035-.017.04-.005.087.035.105l.485.245c.04.018.087.006.105-.035Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12.346 10.91c.03-.04.076-.052.117-.023l1.015.677c.04.024.046.076.023.117-.03.04-.076.052-.117.023l-1.015-.677c-.04-.029-.052-.081-.023-.116Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12.34 10.905a.1.1 0 0 1 .128-.03l1.015.677c.041.03.053.082.024.129a.1.1 0 0 1-.129.029l-1.015-.677c-.046-.029-.052-.087-.023-.128Zm1.15.77c.022-.035.017-.088-.018-.11l-1.015-.678a.076.076 0 0 0-.105.024c-.024.035-.018.087.017.11l1.015.677a.076.076 0 0 0 .105-.023Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12.562 11.757c.029-.035.081-.047.116-.018l.426.333c.035.029.041.081.012.116-.03.035-.082.047-.117.018l-.426-.333a.083.083 0 0 1-.011-.116Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12.556 11.75c.029-.04.087-.046.128-.017l.426.333c.04.029.047.087.018.128-.03.041-.088.047-.129.018l-.426-.333c-.04-.029-.046-.087-.017-.128Zm.56.438c.029-.035.023-.081-.012-.11l-.426-.333a.083.083 0 0 0-.11.017c-.03.035-.024.082.011.111l.426.333a.083.083 0 0 0 .11-.018Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M11.693 11.698c.034-.035.087-.035.116 0l.864.858a.083.083 0 0 1 0 .117c-.036.034-.088.034-.117 0l-.863-.858c-.03-.03-.03-.088 0-.117Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M11.693 11.693a.092.092 0 0 1 .128 0l.863.857a.092.092 0 0 1 0 .128.092.092 0 0 1-.128 0l-.863-.857a.083.083 0 0 1 0-.128Zm.98.974a.081.081 0 0 0 0-.111l-.864-.858a.081.081 0 0 0-.11 0 .081.081 0 0 0 0 .111l.863.858c.029.035.076.035.11 0Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M11.745 12.568c.035-.03.087-.03.117.005l.355.409a.083.083 0 0 1-.011.116c-.035.03-.088.03-.117-.005l-.356-.409c-.029-.029-.023-.081.012-.116Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M11.74 12.568a.092.092 0 0 1 .127.005l.356.409c.035.035.03.093-.011.128a.091.091 0 0 1-.129-.006l-.356-.408c-.029-.04-.029-.1.012-.128Zm.466.53c.035-.029.035-.075.011-.11l-.355-.409a.08.08 0 0 0-.111-.006c-.035.03-.035.076-.012.111l.356.409c.03.034.076.034.11.005Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M10.905 12.346a.079.079 0 0 1 .117.023l.676 1.01c.024.04.012.093-.023.116a.08.08 0 0 1-.117-.023l-.676-1.01c-.024-.04-.012-.093.023-.116Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M10.905 12.34c.04-.03.1-.017.128.023l.677 1.01c.03.04.017.099-.03.128-.04.029-.098.017-.127-.024l-.677-1.009a.089.089 0 0 1 .03-.128Zm.77 1.15a.076.076 0 0 0 .023-.106l-.676-1.009c-.024-.035-.07-.04-.111-.017a.076.076 0 0 0-.023.105l.676 1.009c.024.029.076.04.111.017Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M10.782 13.21a.085.085 0 0 1 .117.028l.268.473c.024.04.006.093-.035.117a.085.085 0 0 1-.116-.03l-.268-.472c-.018-.041-.006-.094.034-.117Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M10.783 13.203c.046-.023.099-.011.122.03l.268.472c.024.04.012.1-.035.123-.046.023-.099.011-.122-.03l-.268-.472c-.024-.041-.012-.094.034-.123Zm.35.619c.035-.024.052-.07.029-.105l-.269-.473a.084.084 0 0 0-.105-.03c-.035.024-.052.071-.029.106l.268.473c.018.035.07.052.105.029Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M10.007 12.824c.046-.017.093 0 .11.041l.473 1.126c.018.04-.006.093-.047.11-.04.018-.093 0-.11-.04l-.473-1.126c-.017-.04.006-.093.047-.11Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M10.007 12.818c.046-.017.099 0 .122.047l.473 1.126a.09.09 0 0 1-.053.117c-.046.017-.099 0-.122-.047l-.473-1.126c-.017-.04.006-.093.053-.117Zm.53 1.278c.041-.018.059-.064.041-.1l-.472-1.125c-.018-.04-.064-.058-.105-.04-.04.017-.058.063-.04.098l.471 1.126c.024.04.065.058.105.04Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9.72 13.652c.047-.017.094.006.112.053l.169.513c.017.041-.012.094-.053.105-.046.018-.093-.005-.11-.052l-.17-.514c-.017-.04.006-.087.053-.104Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9.715 13.647a.09.09 0 0 1 .117.052l.169.514c.017.046-.012.099-.058.116a.09.09 0 0 1-.117-.052l-.17-.514a.1.1 0 0 1 .06-.116Zm.228.67c.04-.011.064-.058.052-.099l-.17-.513c-.01-.04-.057-.058-.098-.047-.041.012-.064.059-.053.1l.17.513a.073.073 0 0 0 .039.045.074.074 0 0 0 .06.002Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9.033 13.122c.046-.012.093.017.099.064l.245 1.196c.011.046-.024.087-.07.099-.047.012-.094-.018-.1-.064l-.245-1.196a.093.093 0 0 1 .07-.1Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9.033 13.116c.052-.012.099.023.11.07l.245 1.196c.012.046-.023.099-.07.105a.094.094 0 0 1-.11-.07l-.246-1.196c-.011-.047.018-.094.07-.105Zm.274 1.36c.04-.007.07-.048.064-.094l-.245-1.196c-.006-.041-.053-.07-.094-.059-.04.006-.07.047-.064.094l.245 1.196c.012.04.053.064.094.058Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M8.59 13.88a.09.09 0 0 1 .098.07l.07.537a.085.085 0 0 1-.076.093.09.09 0 0 1-.099-.07l-.07-.537a.085.085 0 0 1 .076-.093Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M8.59 13.874c.052-.006.098.03.104.076l.07.537a.09.09 0 0 1-.082.099c-.052.006-.099-.03-.105-.076l-.07-.537a.09.09 0 0 1 .082-.099Zm.087.7c.04-.006.076-.046.07-.087l-.07-.537a.078.078 0 0 0-.088-.064c-.04.006-.076.046-.07.087l.07.537c.006.04.047.07.088.064Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M7.988 13.227c.047 0 .088.035.088.081v1.22c0 .046-.04.081-.088.081-.046 0-.087-.035-.087-.082v-1.219c.006-.046.04-.081.087-.081Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M7.988 13.22c.053 0 .094.041.094.088v1.22c0 .046-.041.087-.094.087-.052 0-.093-.041-.093-.088v-1.219c0-.046.047-.087.093-.087Zm0 1.383c.041 0 .082-.035.082-.076v-1.219c0-.04-.035-.076-.082-.076-.04 0-.081.035-.081.076v1.22c.006.04.04.075.081.075Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M7.405 13.88c.047.006.082.04.082.087l-.041.543a.085.085 0 0 1-.094.076c-.046-.006-.081-.041-.081-.088l.04-.542a.085.085 0 0 1 .094-.076Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M7.405 13.874a.095.095 0 0 1 .087.093l-.04.543c-.006.047-.047.088-.1.082a.095.095 0 0 1-.087-.094l.04-.542c.007-.053.047-.088.1-.082Zm-.053.706c.041 0 .082-.03.082-.07l.041-.543c0-.04-.03-.075-.076-.081-.04 0-.082.029-.082.07l-.04.542c0 .041.035.076.076.082Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M6.967 13.122a.09.09 0 0 1 .07.099l-.239 1.196c-.011.046-.052.076-.099.064a.09.09 0 0 1-.07-.1l.24-1.195c.005-.041.052-.07.098-.064Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M6.968 13.116a.095.095 0 0 1 .075.105l-.239 1.196a.094.094 0 0 1-.11.07.095.095 0 0 1-.076-.105l.239-1.196c.011-.047.058-.076.11-.07Zm-.275 1.359a.084.084 0 0 0 .094-.058l.239-1.196a.083.083 0 0 0-.064-.094.084.084 0 0 0-.094.059l-.239 1.196c-.006.046.024.081.064.093Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M6.268 13.647a.087.087 0 0 1 .064.105l-.146.525c-.012.046-.058.07-.105.058a.086.086 0 0 1-.054-.04.087.087 0 0 1-.01-.065l.146-.525c.011-.047.058-.07.105-.058Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M6.267 13.64c.047.013.082.065.065.112l-.146.525a.093.093 0 0 1-.111.064c-.047-.012-.082-.064-.064-.11l.146-.526c.011-.047.058-.076.11-.064Zm-.192.683c.04.012.087-.011.1-.052l.145-.525c.012-.04-.012-.082-.058-.093-.041-.012-.088.011-.1.052l-.145.525a.084.084 0 0 0 .058.093Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.982 12.824c.046.018.064.07.046.111l-.466 1.126c-.018.04-.07.064-.111.04-.041-.023-.064-.07-.047-.11l.467-1.126c.017-.04.07-.064.11-.04Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.982 12.818a.091.091 0 0 1 .052.117l-.467 1.126c-.017.046-.07.064-.122.046a.09.09 0 0 1-.053-.116l.467-1.126c.023-.047.076-.07.123-.047Zm-.531 1.278a.08.08 0 0 0 .105-.041l.466-1.126c.018-.04-.005-.082-.046-.099a.08.08 0 0 0-.105.04l-.467 1.127a.083.083 0 0 0 .047.099Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.194 13.198c.041.023.059.07.041.11l-.245.485a.085.085 0 0 1-.117.035c-.04-.024-.058-.07-.04-.111l.245-.484a.085.085 0 0 1 .116-.035Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.194 13.192a.09.09 0 0 1 .041.122l-.245.484a.09.09 0 0 1-.122.041.09.09 0 0 1-.041-.122l.245-.484a.09.09 0 0 1 .122-.041Zm-.32.636c.04.017.087.005.104-.035l.245-.485c.018-.035 0-.081-.035-.105-.04-.017-.087-.005-.105.035l-.245.484c-.017.036 0 .082.035.105Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.077 12.334c.041.03.053.082.024.117l-.677 1.01c-.023.04-.076.046-.117.022-.04-.029-.052-.081-.023-.116l.677-1.01a.079.079 0 0 1 .116-.023Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.078 12.328a.1.1 0 0 1 .029.129l-.677 1.009a.092.092 0 0 1-.128.023.1.1 0 0 1-.03-.128l.677-1.01a.093.093 0 0 1 .129-.023Zm-.77 1.15c.035.023.087.017.11-.018l.677-1.01a.076.076 0 0 0-.023-.104c-.035-.024-.088-.018-.111.017l-.677 1.004a.083.083 0 0 0 .024.11Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M4.226 12.55c.035.03.047.082.017.117l-.338.425a.083.083 0 0 1-.117.012c-.035-.029-.046-.081-.017-.116l.338-.426a.083.083 0 0 1 .117-.012Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M4.232 12.544c.04.03.046.088.017.129l-.338.425c-.03.041-.088.047-.128.012-.041-.03-.047-.087-.018-.128l.338-.426c.03-.041.088-.047.129-.012Zm-.438.554c.035.03.082.024.111-.011l.338-.426a.083.083 0 0 0-.017-.11c-.035-.03-.082-.024-.11.01l-.34.427c-.023.035-.017.087.018.11Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M4.284 11.675c.035.035.035.088 0 .117l-.863.857a.083.083 0 0 1-.117 0c-.029-.029-.035-.087 0-.116l.858-.858a.084.084 0 0 1 .122 0Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M4.29 11.67a.091.091 0 0 1 0 .127l-.863.858a.092.092 0 0 1-.129 0 .092.092 0 0 1 0-.128l.864-.858a.092.092 0 0 1 .128 0Zm-.986.98c.03.028.082.028.111 0l.863-.858a.081.081 0 0 0 0-.111.081.081 0 0 0-.11 0l-.864.857c-.029.03-.029.076 0 .111Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M3.41 11.722c.028.035.028.087-.007.116l-.414.35a.083.083 0 0 1-.116-.011c-.03-.035-.03-.088.005-.117l.414-.35a.083.083 0 0 1 .117.012Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M3.415 11.716c.035.04.03.099-.006.128l-.414.35c-.035.035-.093.03-.128-.011-.035-.041-.03-.1.005-.129l.415-.35c.035-.035.093-.029.128.012Zm-.537.46c.03.036.076.036.111.012l.414-.35a.081.081 0 0 0 .006-.11c-.03-.035-.076-.035-.11-.012l-.415.35c-.035.029-.035.076-.006.11Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M3.643 10.882c.029.04.017.093-.024.116l-1.015.677c-.04.023-.093.012-.116-.023a.079.079 0 0 1 .023-.117l1.015-.677c.035-.023.087-.011.117.024Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M3.648 10.882c.03.04.018.099-.023.128l-1.015.677a.09.09 0 0 1-.128-.03.093.093 0 0 1 .023-.128l1.015-.677a.09.09 0 0 1 .128.03Zm-1.155.764c.024.035.07.046.105.023l1.015-.677c.035-.023.047-.07.018-.11a.076.076 0 0 0-.105-.024l-1.015.677a.082.082 0 0 0-.018.11Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.773 10.76a.085.085 0 0 1-.029.116l-.472.268c-.041.023-.094.006-.117-.035a.085.085 0 0 1 .03-.117l.472-.268c.04-.023.093-.006.117.035Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.78 10.753c.023.047.011.1-.03.123l-.472.268c-.041.024-.1.006-.123-.035-.023-.046-.012-.099.03-.122l.472-.269c.04-.023.099-.005.122.035Zm-.62.35c.024.041.071.053.106.03l.472-.269a.084.084 0 0 0 .03-.105c-.024-.04-.07-.052-.105-.029l-.473.268c-.035.018-.047.065-.029.105Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M3.164 9.983c.018.047 0 .094-.046.111l-1.126.467c-.041.017-.094-.006-.111-.047-.018-.046 0-.093.047-.11l1.125-.467c.041-.018.094 0 .111.046Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M3.17 9.978c.017.046 0 .099-.047.122l-1.125.467a.09.09 0 0 1-.117-.053c-.018-.046 0-.099.047-.122l1.125-.467a.09.09 0 0 1 .117.053Zm-1.278.53c.018.041.065.059.1.047l1.126-.467a.079.079 0 0 0 .04-.105.083.083 0 0 0-.099-.046l-1.126.466a.08.08 0 0 0-.04.105Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.342 9.692c.017.046-.006.093-.053.11l-.513.17c-.04.017-.093-.012-.105-.053-.018-.047.006-.093.052-.11l.514-.17c.04-.017.087.006.105.053Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.347 9.686a.09.09 0 0 1-.058.117l-.513.169c-.047.017-.1-.012-.117-.059a.09.09 0 0 1 .059-.116l.513-.17a.1.1 0 0 1 .116.059Zm-.676.222c.012.04.058.064.099.052l.513-.17c.041-.01.059-.057.047-.098-.012-.041-.058-.064-.1-.053l-.512.17a.08.08 0 0 0-.047.099Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.867 8.998c.011.046-.018.093-.064.099l-1.196.233c-.047.012-.088-.023-.1-.07-.011-.047.018-.093.065-.1l1.196-.232c.046-.006.093.023.099.07Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.878 8.998a.094.094 0 0 1-.07.11l-1.196.234c-.046.011-.093-.024-.105-.076a.094.094 0 0 1 .07-.11l1.196-.234c.047-.012.094.023.105.076ZM1.52 9.26c.006.04.047.07.088.064l1.195-.233c.041-.006.07-.053.059-.093a.078.078 0 0 0-.088-.065l-1.196.234c-.04.011-.07.052-.058.093Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.12 8.548c.006.047-.023.088-.07.094l-.537.064a.085.085 0 0 1-.093-.076.08.08 0 0 1 .07-.093l.537-.064c.04-.006.087.029.093.075Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.126 8.548c.006.053-.03.1-.076.105l-.537.065a.09.09 0 0 1-.099-.082c-.006-.053.03-.1.076-.105l.537-.064a.09.09 0 0 1 .099.081Zm-.706.082c.006.04.047.076.087.07l.537-.064a.078.078 0 0 0 .064-.088c-.006-.04-.046-.075-.087-.07l-.537.065a.078.078 0 0 0-.064.087Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.773 7.983c0 .046-.035.087-.081.087h-1.22c-.046 0-.081-.04-.081-.087 0-.047.035-.088.082-.088h1.219c.046 0 .081.04.081.088Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.78 7.982c0 .053-.042.094-.088.094h-1.22c-.046 0-.087-.041-.087-.094 0-.052.041-.093.088-.093h1.219c.046 0 .087.041.087.093Zm-1.383-.005c0 .04.035.081.076.081h1.219c.04 0 .076-.035.076-.081 0-.041-.035-.082-.076-.082h-1.22c-.04.006-.075.04-.075.082Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.126 7.393c-.006.047-.041.082-.088.082l-.542-.04a.085.085 0 0 1-.076-.094c.006-.047.04-.082.088-.082l.542.041c.04.006.076.047.076.093Z",
          fill: "#E2E2E2"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.132 7.393a.095.095 0 0 1-.094.088l-.542-.04c-.047-.007-.088-.048-.082-.1a.095.095 0 0 1 .093-.088l.543.041c.047.006.082.053.082.1Zm-.712-.052c-.006.04.03.082.07.082l.542.04c.041 0 .076-.029.082-.075a.074.074 0 0 0-.07-.082l-.542-.04c-.041 0-.076.034-.082.075Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.878 6.968a.09.09 0 0 1-.099.07l-1.196-.245c-.046-.012-.076-.053-.064-.1a.09.09 0 0 1 .1-.07l1.195.24c.041.011.07.058.064.105Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.884 6.968a.095.095 0 0 1-.105.075l-1.196-.239a.094.094 0 0 1-.07-.11.095.095 0 0 1 .105-.076l1.196.239c.047.011.076.058.07.11Zm-1.359-.275a.084.084 0 0 0 .058.094l1.196.239a.083.083 0 0 0 .094-.064.084.084 0 0 0-.059-.094L1.618 6.63c-.046-.006-.081.024-.093.064Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.353 6.268a.087.087 0 0 1-.105.064l-.525-.146c-.046-.012-.07-.058-.058-.105a.087.087 0 0 1 .105-.064l.525.146c.047.011.07.058.058.105Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.36 6.268c-.013.046-.065.081-.112.064l-.525-.146a.093.093 0 0 1-.064-.111c.012-.047.064-.082.11-.064l.526.146c.047.011.076.058.064.11Zm-.683-.193c-.012.04.011.087.052.1l.525.145c.041.012.082-.012.093-.058.012-.041-.011-.088-.052-.1l-.525-.145a.084.084 0 0 0-.093.058Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M3.176 5.988a.083.083 0 0 1-.111.046l-1.126-.466c-.04-.018-.064-.07-.047-.111a.083.083 0 0 1 .111-.047l1.126.467c.047.017.064.07.047.11Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M3.182 5.993a.09.09 0 0 1-.117.053l-1.126-.467c-.047-.017-.064-.07-.047-.122a.09.09 0 0 1 .117-.053l1.126.467a.097.097 0 0 1 .047.122Zm-1.278-.53a.08.08 0 0 0 .041.104l1.126.467c.04.018.081-.006.099-.047a.08.08 0 0 0-.04-.104l-1.127-.467c-.04-.012-.087.006-.099.047Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.797 5.2c-.024.04-.07.058-.111.04l-.484-.244c-.041-.018-.059-.07-.035-.117.023-.04.07-.058.11-.04l.485.244c.04.024.058.076.035.117Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.803 5.206a.09.09 0 0 1-.123.04l-.484-.244a.09.09 0 0 1-.04-.123.09.09 0 0 1 .122-.04l.484.244c.046.018.064.076.04.123Zm-.63-.321c-.018.04-.006.087.035.105l.484.245c.035.017.081 0 .105-.035.017-.04.006-.088-.035-.105l-.49-.245a.072.072 0 0 0-.1.035Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M3.654 5.09c-.03.04-.076.052-.117.023l-1.009-.671c-.04-.024-.046-.076-.023-.117a.079.079 0 0 1 .117-.023l1.015.676c.035.024.046.076.017.111Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M3.66 5.095a.1.1 0 0 1-.128.03l-1.01-.678A.092.092 0 0 1 2.5 4.32a.1.1 0 0 1 .129-.029l1.009.677c.046.029.052.087.023.128Zm-1.15-.77c-.022.035-.017.087.018.11l1.015.678a.076.076 0 0 0 .105-.024c.024-.035.018-.087-.017-.11l-1.015-.677a.076.076 0 0 0-.105.023Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M3.438 4.243c-.029.035-.081.047-.116.018l-.426-.333a.083.083 0 0 1-.012-.116c.03-.035.082-.047.117-.018l.426.333c.035.029.04.081.011.116Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M3.444 4.25c-.029.04-.087.046-.128.017l-.426-.333c-.04-.029-.047-.087-.017-.128.029-.041.087-.047.128-.018l.426.333c.04.029.046.087.017.128Zm-.56-.438c-.029.035-.023.081.012.11l.426.333a.083.083 0 0 0 .11-.018c.03-.035.024-.081-.011-.11l-.426-.333a.083.083 0 0 0-.11.018Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M4.308 4.302c-.035.035-.088.035-.117 0l-.87-.858a.083.083 0 0 1 0-.117c.036-.034.088-.034.117 0l.864.858c.035.03.035.087.006.117Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M4.308 4.307a.092.092 0 0 1-.129 0l-.863-.857a.092.092 0 0 1 0-.128.092.092 0 0 1 .128 0l.864.857c.04.035.04.093 0 .128Zm-.98-.974a.081.081 0 0 0 0 .111l.863.858c.03.029.082.029.11 0a.081.081 0 0 0 0-.111l-.863-.864c-.029-.029-.075-.029-.11.006Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M4.255 3.433c-.035.029-.088.029-.117-.006l-.356-.409a.083.083 0 0 1 .012-.116c.035-.03.088-.03.117.006l.356.408c.029.029.023.082-.012.117Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M4.26 3.433a.092.092 0 0 1-.128-.006l-.355-.409c-.035-.035-.03-.093.011-.128a.091.091 0 0 1 .129.006l.356.408c.029.041.029.1-.012.129Zm-.466-.531c-.035.029-.035.076-.012.11l.356.409a.08.08 0 0 0 .111.006c.035-.03.035-.076.012-.111l-.356-.408c-.03-.035-.076-.035-.11-.006Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.095 3.654a.079.079 0 0 1-.117-.023l-.682-1.01c-.023-.04-.012-.093.023-.116a.079.079 0 0 1 .117.023l.677 1.01c.029.04.017.093-.018.116Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.095 3.66c-.04.03-.1.017-.128-.023l-.677-1.01a.09.09 0 0 1 .03-.128c.04-.029.098-.017.128.024l.676 1.009c.03.046.018.099-.029.128Zm-.77-1.15a.076.076 0 0 0-.023.106l.676 1.009c.024.035.07.04.111.018a.076.076 0 0 0 .023-.105l-.676-1.004a.083.083 0 0 0-.11-.023h-.001Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.218 2.79a.085.085 0 0 1-.117-.028l-.268-.473c-.024-.04-.006-.093.035-.116a.085.085 0 0 1 .116.029l.269.472c.017.041.005.094-.035.117Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.218 2.797c-.047.023-.1.011-.123-.03l-.268-.472c-.024-.04-.012-.1.035-.122.046-.024.099-.012.122.029l.268.472c.024.041.012.094-.034.123Zm-.35-.619c-.036.024-.053.07-.03.105l.269.473c.023.035.07.047.105.029.035-.023.052-.07.029-.105l-.269-.472c-.017-.035-.07-.053-.104-.03Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.993 3.176c-.046.017-.093 0-.11-.041L5.41 2.009c-.017-.04.006-.093.047-.11.046-.018.093 0 .11.04l.473 1.126c.018.04-.006.093-.047.11Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.993 3.182c-.046.017-.099 0-.122-.047l-.473-1.126a.09.09 0 0 1 .053-.116c.047-.018.1 0 .122.046l.473 1.126c.017.04-.006.093-.053.117Zm-.53-1.278c-.041.018-.059.064-.041.1l.472 1.125c.018.041.064.058.105.041.041-.018.059-.064.041-.1l-.472-1.125c-.024-.04-.065-.058-.105-.04Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M6.28 2.348c-.048.017-.094-.006-.112-.053L6 1.782c-.017-.041.012-.094.053-.105.04-.012.093.006.11.052l.17.514c.017.04-.006.087-.053.105Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M6.285 2.353a.09.09 0 0 1-.117-.052L6 1.787c-.017-.046.012-.099.059-.116a.09.09 0 0 1 .116.052l.17.514a.1.1 0 0 1-.059.116Zm-.228-.67c-.04.011-.064.058-.052.099l.17.513c.01.04.057.058.098.047.041-.012.065-.059.053-.1l-.17-.513a.074.074 0 0 0-.099-.047Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M6.968 2.878c-.047.012-.094-.017-.1-.064l-.245-1.196c-.011-.046.024-.087.07-.099.047-.011.094.018.1.064l.245 1.196a.093.093 0 0 1-.07.1Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M6.968 2.884a.094.094 0 0 1-.111-.07l-.245-1.196c-.012-.046.023-.099.07-.105.052-.011.099.024.11.07l.246 1.196c.011.047-.018.094-.07.105Zm-.275-1.359c-.04.006-.07.047-.064.093l.245 1.196c.006.041.053.07.094.059.04-.006.07-.047.064-.094l-.245-1.196a.084.084 0 0 0-.094-.058Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M7.41 2.12a.09.09 0 0 1-.098-.07l-.07-.537a.085.085 0 0 1 .076-.093.09.09 0 0 1 .099.07l.07.537a.085.085 0 0 1-.076.093Z",
          fill: "#F3F3F3"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M7.41 2.126c-.052.006-.098-.03-.104-.076l-.07-.537a.09.09 0 0 1 .082-.099c.052-.006.099.03.105.076l.07.537a.09.09 0 0 1-.082.099Zm-.087-.7c-.04.006-.075.047-.07.087l.07.537c.006.04.047.07.088.064.04-.006.076-.046.07-.087l-.07-.537a.078.078 0 0 0-.088-.064Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M8.04 14.9a6.907 6.907 0 1 0 0-13.813 6.907 6.907 0 0 0 0 13.814Z",
          fill: "url(#c)",
          fillOpacity: 0.2
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "m12.824 3.613-5.57 3.57h-.007v.006l-.005.006-3.477 5.734 5.11-4.112.006-.006v-.006l3.943-5.192Z",
          fill: "#000",
          fillOpacity: 0.05
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12.72 3.28 7.212 7.196l1.633 1.622 3.873-5.536Z",
          fill: "#CD151E"
        }
      ),
      /* @__PURE__ */ t("path", { d: "m7.218 7.183.823.811 4.678-4.713-5.5 3.902Z", fill: "#FA5153" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "m7.218 7.183 1.634 1.622-5.507 3.914 3.873-5.536Z",
          fill: "#ACACAC"
        }
      ),
      /* @__PURE__ */ t("path", { d: "m3.345 12.72 4.696-4.726-.823-.81-3.873 5.535Z", fill: "#EEE" }),
      /* @__PURE__ */ w("defs", { children: [
        /* @__PURE__ */ w(
          "linearGradient",
          {
            id: "a",
            x1: 8,
            y1: 15.467,
            x2: 8,
            y2: 0.533,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", { offset: 0.25, stopColor: "#DBDBDA" }),
              /* @__PURE__ */ t("stop", { offset: 1, stopColor: "#fff" })
            ]
          }
        ),
        /* @__PURE__ */ w(
          "linearGradient",
          {
            id: "c",
            x1: 7.91,
            y1: 6.019,
            x2: 4.686,
            y2: 11.803,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", { stopOpacity: 0 }),
              /* @__PURE__ */ t("stop", { offset: 1 })
            ]
          }
        ),
        /* @__PURE__ */ w(
          "radialGradient",
          {
            id: "b",
            cx: 0,
            cy: 0,
            r: 1,
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(8.97 6.483) scale(8.43055)",
            children: [
              /* @__PURE__ */ t("stop", { stopColor: "#2ABCE1" }),
              /* @__PURE__ */ t("stop", { offset: 0.114, stopColor: "#2ABBE1" }),
              /* @__PURE__ */ t("stop", { offset: 1, stopColor: "#3375F8" })
            ]
          }
        )
      ] })
    ]
  }
), vo = wo, xo = ({
  width: e = 16,
  height: r = 16,
  ...o
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ...o,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M14.928 5.187c-.325-.783-.983-1.629-1.5-1.896.421.826.664 1.655.757 2.274l.002.012c-.845-2.112-2.279-2.963-3.45-4.817a7.764 7.764 0 0 1-.176-.288 2.193 2.193 0 0 1-.082-.156 1.366 1.366 0 0 1-.116-.308A.02.02 0 0 0 10.35 0a.027.027 0 0 0-.014 0 .017.017 0 0 0-.003.002l-.006.003.004-.004C8.452 1.104 7.815 3.144 7.757 4.164a3.737 3.737 0 0 0-2.06.795 2.21 2.21 0 0 0-.193-.147 3.48 3.48 0 0 1-.02-1.831c-.769.35-1.366.904-1.8 1.394H3.68c-.296-.376-.276-1.618-.259-1.877-.003-.016-.22.113-.249.133a5.44 5.44 0 0 0-.73.627c-.256.26-.49.54-.698.84A6.332 6.332 0 0 0 .74 6.367l-.01.05c-.014.065-.064.395-.073.467v.017a7.158 7.158 0 0 0-.124 1.034v.038c0 4.138 3.348 7.493 7.477 7.493 3.698 0 6.768-2.691 7.37-6.225.012-.096.022-.193.033-.29.149-1.285-.016-2.635-.485-3.765Zm-8.617 5.866c.035.016.068.035.103.05l.005.004a5.262 5.262 0 0 1-.108-.054Zm7.877-5.472v-.007.008-.001Z",
          fill: "url(#a)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M14.928 5.187c-.325-.783-.983-1.629-1.5-1.896.421.826.664 1.655.757 2.274v.015c.706 1.917.321 3.866-.232 5.057-.857 1.843-2.931 3.732-6.178 3.64-3.505-.1-6.596-2.71-7.173-6.125-.105-.54 0-.813.053-1.25-.064.337-.089.434-.12 1.034v.038c0 4.138 3.347 7.493 7.476 7.493 3.698 0 6.768-2.691 7.37-6.225.012-.096.022-.193.033-.29.148-1.285-.017-2.635-.486-3.765Z",
          fill: "url(#b)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M14.928 5.187c-.325-.783-.983-1.629-1.5-1.896.421.826.664 1.655.757 2.274v.015c.706 1.917.321 3.866-.232 5.057-.857 1.843-2.931 3.732-6.178 3.64-3.505-.1-6.596-2.71-7.173-6.125-.105-.54 0-.813.053-1.25-.064.337-.089.434-.12 1.034v.038c0 4.138 3.347 7.493 7.476 7.493 3.698 0 6.768-2.691 7.37-6.225.012-.096.022-.193.033-.29.148-1.285-.017-2.635-.486-3.765Z",
          fill: "url(#c)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M11.295 6.068c.017.011.031.023.047.035a4.068 4.068 0 0 0-.695-.908c-2.324-2.33-.609-5.05-.32-5.19l.003-.003C8.452 1.104 7.815 3.144 7.757 4.164c.087-.006.173-.013.262-.013 1.402 0 2.622.772 3.276 1.917Z",
          fill: "url(#d)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M8.024 6.533c-.012.187-.67.83-.9.83-2.125 0-2.47 1.288-2.47 1.288.093 1.086.848 1.98 1.76 2.453l.125.06c.073.031.147.063.22.09.313.11.64.174.973.187 3.726.175 4.448-4.465 1.759-5.813.688-.12 1.403.158 1.803.44A3.772 3.772 0 0 0 8.018 4.15c-.09 0-.176.007-.263.013-.75.052-1.467.33-2.057.796.114.097.243.226.514.494.508.502 1.809 1.02 1.812 1.08Z",
          fill: "url(#e)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M8.024 6.533c-.012.187-.67.83-.9.83-2.125 0-2.47 1.288-2.47 1.288.093 1.086.848 1.98 1.76 2.453l.125.06c.073.031.147.063.22.09.313.11.64.174.973.187 3.726.175 4.448-4.465 1.759-5.813.688-.12 1.403.158 1.803.44A3.772 3.772 0 0 0 8.018 4.15c-.09 0-.176.007-.263.013-.75.052-1.467.33-2.057.796.114.097.243.226.514.494.508.502 1.809 1.02 1.812 1.08Z",
          fill: "url(#f)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "m5.35 4.71.156.102a3.48 3.48 0 0 1-.021-1.831c-.768.35-1.366.904-1.8 1.394.035-.001 1.12-.02 1.665.335Z",
          fill: "url(#g)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M.603 8.152c.577 3.415 3.667 6.025 7.174 6.125 3.247.092 5.32-1.797 6.178-3.64.554-1.19.939-3.14.233-5.057v-.014l.002.012c.265 1.736-.616 3.418-1.993 4.555l-.004.01c-2.683 2.189-5.25 1.32-5.77.966a4.22 4.22 0 0 1-.11-.054c-1.564-.749-2.21-2.178-2.072-3.403-1.32 0-1.77-1.117-1.77-1.117s1.185-.847 2.748-.11c1.448.682 2.807.11 2.807.11-.002-.06-1.304-.58-1.81-1.08-.272-.268-.4-.397-.515-.494a2.21 2.21 0 0 0-.193-.147l-.156-.102c-.545-.356-1.63-.336-1.666-.335h-.003C3.387 4 3.407 2.759 3.424 2.5c-.003-.016-.22.113-.249.133a5.44 5.44 0 0 0-.73.627c-.256.26-.49.54-.699.84A6.332 6.332 0 0 0 .743 6.37c-.006.014-.272 1.178-.14 1.782Z",
          fill: "url(#h)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M10.647 5.195c.273.268.507.574.694.908.04.029.077.06.113.093 1.694 1.564.808 3.778.74 3.937 1.377-1.137 2.258-2.819 1.993-4.554-.845-2.114-2.279-2.965-3.45-4.82a7.764 7.764 0 0 1-.176-.287 2.193 2.193 0 0 1-.082-.156 1.366 1.366 0 0 1-.116-.308A.02.02 0 0 0 10.35 0a.027.027 0 0 0-.014 0 .017.017 0 0 0-.003.002l-.006.003c-.289.138-2.004 2.86.32 5.189Z",
          fill: "url(#i)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M11.453 6.195a1.47 1.47 0 0 0-.112-.094l-.047-.035c-.399-.28-1.114-.558-1.802-.438 2.689 1.347 1.967 5.988-1.76 5.813a3.317 3.317 0 0 1-.972-.187 4.062 4.062 0 0 1-.344-.15l.005.003c.52.355 3.087 1.224 5.77-.967l.004-.01c.067-.156.954-2.37-.742-3.935Z",
          fill: "url(#j)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M4.654 8.651s.345-1.289 2.47-1.289c.23 0 .888-.643.9-.829.012-.186-1.36.572-2.807-.11-1.563-.737-2.75.11-2.75.11S2.919 7.65 4.24 7.65c-.139 1.225.508 2.653 2.072 3.403.035.016.068.035.104.05-.913-.471-1.667-1.366-1.761-2.452Z",
          fill: "url(#k)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M14.928 5.187c-.325-.783-.983-1.629-1.5-1.896.421.826.664 1.655.757 2.274l.002.012c-.845-2.112-2.279-2.963-3.45-4.817a7.764 7.764 0 0 1-.176-.288 2.193 2.193 0 0 1-.082-.156 1.366 1.366 0 0 1-.116-.308A.02.02 0 0 0 10.35 0a.027.027 0 0 0-.014 0 .017.017 0 0 0-.003.002l-.006.003.004-.004C8.452 1.104 7.815 3.144 7.757 4.164c.087-.006.174-.013.262-.013 1.402 0 2.623.772 3.276 1.917-.399-.28-1.114-.559-1.802-.439 2.689 1.348 1.967 5.988-1.76 5.813a3.32 3.32 0 0 1-.972-.187 4.145 4.145 0 0 1-.344-.15l.005.003a4.204 4.204 0 0 1-.109-.054c.035.016.068.035.104.05-.915-.472-1.67-1.367-1.763-2.453 0 0 .345-1.289 2.47-1.289.23 0 .888-.642.9-.829-.003-.06-1.304-.58-1.812-1.08-.27-.268-.4-.397-.513-.494a2.212 2.212 0 0 0-.194-.147 3.48 3.48 0 0 1-.02-1.831c-.769.35-1.366.904-1.8 1.394H3.68c-.296-.376-.276-1.618-.259-1.877-.003-.016-.22.113-.249.133a5.44 5.44 0 0 0-.73.627c-.256.26-.49.54-.699.84a6.332 6.332 0 0 0-1.003 2.27l-.01.05c-.014.065-.077.4-.086.472 0 .005 0-.005 0 0a8.712 8.712 0 0 0-.112 1.046v.038c0 4.138 3.348 7.493 7.477 7.493 3.698 0 6.768-2.691 7.37-6.225.012-.096.022-.193.033-.29.149-1.285-.016-2.635-.485-3.765Zm-.741.385v.008-.008Z",
          fill: "url(#l)"
        }
      ),
      /* @__PURE__ */ w("defs", { children: [
        /* @__PURE__ */ w(
          "radialGradient",
          {
            id: "b",
            cx: 0,
            cy: 0,
            r: 1,
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "matrix(15.5865 0 0 15.6207 13.365 1.717)",
            children: [
              /* @__PURE__ */ t("stop", { offset: 0.13, stopColor: "#FFBD4F" }),
              /* @__PURE__ */ t("stop", { offset: 0.19, stopColor: "#FFAC31" }),
              /* @__PURE__ */ t("stop", { offset: 0.25, stopColor: "#FF9D17" }),
              /* @__PURE__ */ t("stop", { offset: 0.28, stopColor: "#FF980E" }),
              /* @__PURE__ */ t("stop", { offset: 0.4, stopColor: "#FF563B" }),
              /* @__PURE__ */ t("stop", { offset: 0.47, stopColor: "#FF3750" }),
              /* @__PURE__ */ t("stop", { offset: 0.71, stopColor: "#F5156C" }),
              /* @__PURE__ */ t("stop", { offset: 0.78, stopColor: "#EB0878" }),
              /* @__PURE__ */ t("stop", { offset: 0.86, stopColor: "#E50080" })
            ]
          }
        ),
        /* @__PURE__ */ w(
          "radialGradient",
          {
            id: "c",
            cx: 0,
            cy: 0,
            r: 1,
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "matrix(15.5865 0 0 15.6207 7.67 8.103)",
            children: [
              /* @__PURE__ */ t("stop", { offset: 0.3, stopColor: "#960E18" }),
              /* @__PURE__ */ t("stop", { offset: 0.35, stopColor: "#B11927", stopOpacity: 0.74 }),
              /* @__PURE__ */ t("stop", { offset: 0.43, stopColor: "#DB293D", stopOpacity: 0.34 }),
              /* @__PURE__ */ t("stop", { offset: 0.5, stopColor: "#F5334B", stopOpacity: 0.09 }),
              /* @__PURE__ */ t("stop", { offset: 0.53, stopColor: "#FF3750", stopOpacity: 0 })
            ]
          }
        ),
        /* @__PURE__ */ w(
          "radialGradient",
          {
            id: "d",
            cx: 0,
            cy: 0,
            r: 1,
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "matrix(11.2917 0 0 11.3165 9.55 -1.828)",
            children: [
              /* @__PURE__ */ t("stop", { offset: 0.13, stopColor: "#FFF44F" }),
              /* @__PURE__ */ t("stop", { offset: 0.25, stopColor: "#FFDC3E" }),
              /* @__PURE__ */ t("stop", { offset: 0.51, stopColor: "#FF9D12" }),
              /* @__PURE__ */ t("stop", { offset: 0.53, stopColor: "#FF980E" })
            ]
          }
        ),
        /* @__PURE__ */ w(
          "radialGradient",
          {
            id: "e",
            cx: 0,
            cy: 0,
            r: 1,
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "matrix(7.42132 0 0 7.4376 5.946 12.183)",
            children: [
              /* @__PURE__ */ t("stop", { offset: 0.35, stopColor: "#3A8EE6" }),
              /* @__PURE__ */ t("stop", { offset: 0.47, stopColor: "#5C79F0" }),
              /* @__PURE__ */ t("stop", { offset: 0.67, stopColor: "#9059FF" }),
              /* @__PURE__ */ t("stop", { offset: 1, stopColor: "#C139E6" })
            ]
          }
        ),
        /* @__PURE__ */ w(
          "radialGradient",
          {
            id: "f",
            cx: 0,
            cy: 0,
            r: 1,
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "matrix(3.81676 -.94643 1.11398 4.49249 7.894 6.246)",
            children: [
              /* @__PURE__ */ t("stop", { offset: 0.21, stopColor: "#9059FF", stopOpacity: 0 }),
              /* @__PURE__ */ t("stop", { offset: 0.28, stopColor: "#8C4FF3", stopOpacity: 0.06 }),
              /* @__PURE__ */ t("stop", { offset: 0.75, stopColor: "#7716A8", stopOpacity: 0.45 }),
              /* @__PURE__ */ t("stop", { offset: 0.97, stopColor: "#6E008B", stopOpacity: 0.6 })
            ]
          }
        ),
        /* @__PURE__ */ w(
          "radialGradient",
          {
            id: "g",
            cx: 0,
            cy: 0,
            r: 1,
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "matrix(5.33912 0 0 5.35083 7.473 1.078)",
            children: [
              /* @__PURE__ */ t("stop", { stopColor: "#FFE226" }),
              /* @__PURE__ */ t("stop", { offset: 0.12, stopColor: "#FFDB27" }),
              /* @__PURE__ */ t("stop", { offset: 0.3, stopColor: "#FFC82A" }),
              /* @__PURE__ */ t("stop", { offset: 0.5, stopColor: "#FFA930" }),
              /* @__PURE__ */ t("stop", { offset: 0.73, stopColor: "#FF7E37" }),
              /* @__PURE__ */ t("stop", { offset: 0.79, stopColor: "#FF7139" })
            ]
          }
        ),
        /* @__PURE__ */ w(
          "radialGradient",
          {
            id: "h",
            cx: 0,
            cy: 0,
            r: 1,
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "matrix(22.7791 0 0 22.8291 11.67 -2.316)",
            children: [
              /* @__PURE__ */ t("stop", { offset: 0.11, stopColor: "#FFF44F" }),
              /* @__PURE__ */ t("stop", { offset: 0.46, stopColor: "#FF980E" }),
              /* @__PURE__ */ t("stop", { offset: 0.62, stopColor: "#FF5634" }),
              /* @__PURE__ */ t("stop", { offset: 0.72, stopColor: "#FF3647" }),
              /* @__PURE__ */ t("stop", { offset: 0.9, stopColor: "#E31587" })
            ]
          }
        ),
        /* @__PURE__ */ w(
          "radialGradient",
          {
            id: "i",
            cx: 0,
            cy: 0,
            r: 1,
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "matrix(1.66864 16.55592 -10.85401 1.09396 9.468 .178)",
            children: [
              /* @__PURE__ */ t("stop", { stopColor: "#FFF44F" }),
              /* @__PURE__ */ t("stop", { offset: 0.06, stopColor: "#FFE847" }),
              /* @__PURE__ */ t("stop", { offset: 0.17, stopColor: "#FFC830" }),
              /* @__PURE__ */ t("stop", { offset: 0.3, stopColor: "#FF980E" }),
              /* @__PURE__ */ t("stop", { offset: 0.36, stopColor: "#FF8B16" }),
              /* @__PURE__ */ t("stop", { offset: 0.45, stopColor: "#FF672A" }),
              /* @__PURE__ */ t("stop", { offset: 0.57, stopColor: "#FF3647" }),
              /* @__PURE__ */ t("stop", { offset: 0.74, stopColor: "#E31587" })
            ]
          }
        ),
        /* @__PURE__ */ w(
          "radialGradient",
          {
            id: "j",
            cx: 0,
            cy: 0,
            r: 1,
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "matrix(14.221 0 0 14.2523 7.347 3.06)",
            children: [
              /* @__PURE__ */ t("stop", { offset: 0.14, stopColor: "#FFF44F" }),
              /* @__PURE__ */ t("stop", { offset: 0.48, stopColor: "#FF980E" }),
              /* @__PURE__ */ t("stop", { offset: 0.59, stopColor: "#FF5634" }),
              /* @__PURE__ */ t("stop", { offset: 0.66, stopColor: "#FF3647" }),
              /* @__PURE__ */ t("stop", { offset: 0.9, stopColor: "#E31587" })
            ]
          }
        ),
        /* @__PURE__ */ w(
          "radialGradient",
          {
            id: "k",
            cx: 0,
            cy: 0,
            r: 1,
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "matrix(15.565 0 0 15.5992 11.101 3.893)",
            children: [
              /* @__PURE__ */ t("stop", { offset: 0.09, stopColor: "#FFF44F" }),
              /* @__PURE__ */ t("stop", { offset: 0.23, stopColor: "#FFE141" }),
              /* @__PURE__ */ t("stop", { offset: 0.51, stopColor: "#FFAF1E" }),
              /* @__PURE__ */ t("stop", { offset: 0.63, stopColor: "#FF980E" })
            ]
          }
        ),
        /* @__PURE__ */ w(
          "linearGradient",
          {
            id: "a",
            x1: 13.939,
            y1: 2.396,
            x2: 1.501,
            y2: 14.37,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", { offset: 0.05, stopColor: "#FFF44F" }),
              /* @__PURE__ */ t("stop", { offset: 0.11, stopColor: "#FFE847" }),
              /* @__PURE__ */ t("stop", { offset: 0.22, stopColor: "#FFC830" }),
              /* @__PURE__ */ t("stop", { offset: 0.37, stopColor: "#FF980E" }),
              /* @__PURE__ */ t("stop", { offset: 0.4, stopColor: "#FF8B16" }),
              /* @__PURE__ */ t("stop", { offset: 0.46, stopColor: "#FF672A" }),
              /* @__PURE__ */ t("stop", { offset: 0.53, stopColor: "#FF3647" }),
              /* @__PURE__ */ t("stop", { offset: 0.7, stopColor: "#E31587" })
            ]
          }
        ),
        /* @__PURE__ */ w(
          "linearGradient",
          {
            id: "l",
            x1: 13.789,
            y1: 2.332,
            x2: 3.206,
            y2: 12.893,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ t("stop", { offset: 0.17, stopColor: "#FFF44F", stopOpacity: 0.8 }),
              /* @__PURE__ */ t("stop", { offset: 0.27, stopColor: "#FFF44F", stopOpacity: 0.63 }),
              /* @__PURE__ */ t("stop", { offset: 0.49, stopColor: "#FFF44F", stopOpacity: 0.22 }),
              /* @__PURE__ */ t("stop", { offset: 0.6, stopColor: "#FFF44F", stopOpacity: 0 })
            ]
          }
        )
      ] })
    ]
  }
), Co = xo, yo = ({
  width: e = 25,
  height: r = 24,
  fillcolor: o = "#000",
  disabled: n = !1,
  ...i
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: r,
    viewBox: "0 0 25 24",
    fill: "none",
    ...i,
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M21.1479 7.50391C21.0429 7.56519 18.5422 8.85841 18.5422 11.7258C18.6601 14.9959 21.6979 16.1427 21.75 16.1427C21.6979 16.2039 21.2914 17.7049 20.0872 19.2783C19.1315 20.6336 18.0708 22 16.4601 22C14.9279 22 14.3779 21.0967 12.6101 21.0967C10.7115 21.0967 10.1743 22 8.72077 22C7.11006 22 5.97077 20.5603 4.963 19.2178C3.65376 17.4606 2.54094 14.703 2.50166 12.0553C2.47518 10.6522 2.76385 9.27304 3.49661 8.10158C4.53086 6.46614 6.37729 5.35595 8.39368 5.31935C9.93863 5.2708 11.3136 6.30777 12.2565 6.30777C13.1601 6.30777 14.8494 5.31935 16.7607 5.31935C17.5857 5.32014 19.7857 5.55173 21.1479 7.50391ZM12.1258 5.03921C11.8508 3.75792 12.6101 2.47663 13.3172 1.65931C14.2208 0.670887 15.6479 0 16.8786 0C16.9571 1.28129 16.4592 2.53791 15.5693 3.45312C14.7708 4.44154 13.3958 5.18565 12.1258 5.03921Z",
        fill: n ? "#BDBDBD" : o
      }
    )
  }
), ko = yo, _o = ({
  width: e = 25,
  height: r = 24,
  fillcolor: o = "#3A5CA9",
  disabled: n = !1,
  ...i
}) => /* @__PURE__ */ t(
  "svg",
  {
    width: e,
    height: r,
    fill: "none",
    viewBox: `0 0 ${e} ${r}`,
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M24.5 12.073C24.5 5.40365 19.129 0 12.5 0C5.87097 0 0.5 5.40365 0.5 12.073C0.5 18.0988 4.88823 23.0935 10.625 24V15.563H7.57661V12.073H10.625V9.41306C10.625 6.38751 12.4153 4.71627 15.1574 4.71627C16.4706 4.71627 17.8439 4.95189 17.8439 4.95189V7.92146H16.3303C14.84 7.92146 14.375 8.85225 14.375 9.8069V12.073H17.7031L17.1708 15.563H14.375V24C20.1118 23.0935 24.5 18.0988 24.5 12.073Z",
        fill: n ? "#BDBDBD" : o
      }
    )
  }
), Fo = _o, So = ({
  width: e = 25,
  height: r = 24,
  disabled: o = !1,
  ...n
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    ...n,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M23.001 12.2332C23.001 11.3699 22.9296 10.7399 22.7748 10.0865H12.7153V13.9832H18.62C18.501 14.9515 17.8582 16.4099 16.4296 17.3898L16.4096 17.5203L19.5902 19.935L19.8106 19.9565C21.8343 18.1249 23.001 15.4298 23.001 12.2332Z",
          fill: o ? "#BDBDBD" : "#4285F4"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12.7147 22.5C15.6075 22.5 18.0361 21.5666 19.8099 19.9566L16.429 17.3899C15.5242 18.0082 14.3099 18.4399 12.7147 18.4399C9.88142 18.4399 7.47669 16.6083 6.61947 14.0766L6.49382 14.087L3.18656 16.5954L3.14331 16.7132C4.90519 20.1432 8.52423 22.5 12.7147 22.5Z",
          fill: o ? "#BDBDBD" : "#34A853"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M6.6201 14.0766C6.39391 13.4233 6.26301 12.7233 6.26301 12C6.26301 11.2766 6.39391 10.5766 6.6082 9.92329L6.6022 9.78415L3.25349 7.23552L3.14393 7.28659C2.41777 8.70994 2.0011 10.3083 2.0011 12C2.0011 13.6916 2.41777 15.2899 3.14393 16.7133L6.6201 14.0766Z",
          fill: o ? "#BDBDBD" : "#FBBC05"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12.7148 5.55997C14.7267 5.55997 16.0838 6.41163 16.8576 7.12335L19.8814 4.23C18.0243 2.53834 15.6076 1.5 12.7148 1.5C8.52426 1.5 4.9052 3.85665 3.14331 7.28662L6.60759 9.92332C7.47672 7.39166 9.88146 5.55997 12.7148 5.55997Z",
          fill: o ? "#BDBDBD" : "#EB4335"
        }
      )
    ]
  }
), No = So, Mo = ({
  width: e = "45",
  height: r = "28",
  ...o
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    viewBox: "0 0 45 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...o,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M28.8354 3.30957H16.9376V24.6903H28.8354V3.30957Z",
          fill: "#FF5F00"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M17.6931 13.9998C17.6913 11.9407 18.1579 9.90816 19.0576 8.05604C19.9574 6.20391 21.2668 4.58078 22.8866 3.30949C20.8807 1.7328 18.4716 0.752282 15.9348 0.480003C13.398 0.207723 10.8357 0.654661 8.54091 1.76975C6.24609 2.88484 4.3113 4.62309 2.95768 6.7858C1.60406 8.94851 0.88623 11.4484 0.88623 13.9998C0.88623 16.5512 1.60406 19.0511 2.95768 21.2139C4.3113 23.3766 6.24609 25.1148 8.54091 26.2299C10.8357 27.345 13.398 27.7919 15.9348 27.5197C18.4716 27.2474 20.8807 26.2669 22.8866 24.6902C21.2668 23.4189 19.9574 21.7957 19.0577 19.9436C18.1579 18.0915 17.6913 16.0589 17.6931 13.9998Z",
          fill: "#EB001B"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M44.8863 13.9998C44.8864 16.5512 44.1686 19.0511 42.8151 21.2138C41.4615 23.3765 39.5268 25.1148 37.232 26.2299C34.9372 27.345 32.375 27.7919 29.8382 27.5197C27.3015 27.2474 24.8925 26.2669 22.8866 24.6902C24.505 23.4176 25.8133 21.7942 26.7129 19.9424C27.6126 18.0905 28.08 16.0586 28.08 13.9998C28.08 11.941 27.6126 9.90912 26.7129 8.05729C25.8133 6.20546 24.505 4.58206 22.8866 3.30949C24.8925 1.7328 27.3015 0.752275 29.8382 0.479999C32.375 0.207723 34.9372 0.65468 37.232 1.76978C39.5268 2.88488 41.4615 4.62313 42.8151 6.78585C44.1686 8.94856 44.8864 11.4485 44.8863 13.9998Z",
          fill: "#F79E1B"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M43.5889 22.4257V21.988H43.7654V21.8988H43.3159V21.988H43.4925V22.4257H43.5889ZM44.4616 22.4257V21.8979H44.3238L44.1654 22.261L44.0068 21.8979H43.869V22.4257H43.9663V22.0276L44.1149 22.3708H44.2158L44.3644 22.0267V22.4257H44.4616Z",
          fill: "#F79E1B"
        }
      )
    ]
  }
), Eo = Mo, Io = ({
  width: e = "44",
  height: r = "16",
  ...o
}) => /* @__PURE__ */ t(
  "svg",
  {
    fill: "none",
    height: r,
    viewBox: "0 0 44 16",
    width: e,
    xmlns: "http://www.w3.org/2000/svg",
    ...o,
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "m16.7062 1.14618-5.7606 13.74402h-3.75828l-2.83478-10.96836c-.1721-.67558-.32175-.92308-.84516-1.2077-.85456-.46361-2.26576-.89856-3.50738-1.16852l.0843327-.39943h6.0497373c.77114 0 1.46437.51333 1.63945 1.40134l1.49714 7.95297 3.70014-9.35454h3.7354zm14.7257 9.25672c.0151-3.62749-5.016-3.82733-4.9814-5.44776.0108-.49316.4803-1.01749 1.5081-1.15132.5095-.06669 1.9131-.11757 3.5051.61508l.6245-2.91453c-.8555-.31052-1.9561-.60935-3.3256-.60935-3.5143 0-5.9874 1.86816-6.0083 4.5432-.0227 1.97862 1.7653 3.08274 3.1123 3.74021 1.3858.67329 1.8507 1.10597 1.8455 1.70817-.0099.922-1.1053 1.329-2.129 1.345-1.787.0275-2.824-.4835-3.6506-.8678l-.6444 3.011c.8307.3811 2.3641.7136 3.9538.7303 3.7352 0 6.1785-1.845 6.19-4.7022zm9.2798 4.4873h3.2883l-2.8703-13.74402h-3.0351c-.6824 0-1.2581.39738-1.5129 1.00833l-5.3352 12.73569h3.7333l.7411-2.0529h4.5616zm-3.9671-4.8698 1.8714-5.16036 1.0771 5.16036zm-14.9585-8.87422-2.94 13.74402h-3.5553l2.9411-13.74401z",
        fill: "#1434cb"
      }
    )
  }
), Lo = Io, Ao = ({
  width: e = "32",
  height: r = "32",
  ...o
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...o,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M17.936 3.60865C14.8191 5.03206 12.7118 7.75731 12.7118 10.8864C12.7118 14.8351 16.349 18.0365 20.8354 18.0365C22.8946 18.0365 24.3427 17.5609 26.0355 16.5425C26.2153 16.435 26.4181 16.3538 26.5509 16.5224C26.6271 16.6187 26.5951 16.7358 26.5369 16.8428C24.6877 20.2352 20.925 22.5941 16.7024 22.5941C10.4632 22.5941 5.4054 17.5363 5.4054 11.2971C5.4054 7.73434 7.05455 4.55703 9.63136 2.48606C11.5668 0.930454 16.419 0.715906 17.936 3.60865Z",
          fill: "url(#paint0_linear_1541_95095)"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M26.4058 7.98362C26.4058 11.7362 22.8218 14.778 18.4009 14.778C17.7578 14.778 16.0157 14.6895 14.7693 14.1091C14.4147 13.9439 14.4511 13.7366 14.6948 13.6358C15.2611 13.4022 19.7039 12.5496 19.7039 7.98306C19.7039 3.41651 14.9889 0.0778643 9.63081 2.4855C11.5668 0.930451 14.0259 0 16.7019 0C21.9485 0 26.4053 3.57448 26.4053 7.98362H26.4058Z",
          fill: "#E50056"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M3.57641 25.5283C1.73904 25.5283 0.755371 26.6341 0.755371 28.0648V28.1057C0.755371 29.5448 1.5357 30.4881 3.49519 30.4881C4.90963 30.4881 5.86137 30.0327 6.26749 28.9594H4.90179C4.69844 29.3089 4.3164 29.5044 3.58482 29.5044C2.5849 29.5044 2.08859 29.1386 1.95863 28.472H6.33304V27.9763C6.33304 26.5613 5.38186 25.5289 3.57697 25.5289L3.57641 25.5283ZM1.97487 27.5449C2.13732 26.8862 2.67397 26.5041 3.60106 26.5041C4.52815 26.5041 4.96677 26.8374 5.08889 27.5449H1.97487Z",
          fill: "#1F0038"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M11.8536 24.4063H10.7965C10.7965 24.6175 10.7887 24.9592 10.7478 25.1788C10.6744 25.5692 10.5769 25.6516 10.2274 25.684C10.0078 25.7003 9.7641 25.7003 9.52827 25.7003H8.69921V25.5042C8.69921 24.7967 8.83757 24.6668 9.45544 24.6668H9.86493V23.6584H9.31708C7.96762 23.6584 7.5038 24.1139 7.5038 25.4555V25.7003H6.40641V26.7562H7.5038V30.3497H8.69081L8.69865 26.7562H10.666V28.22C10.666 29.8052 11.0889 30.3503 12.6417 30.3503H13.5279V29.2367H12.9666C12.007 29.2367 11.853 29.0983 11.853 28.0172V26.7568H13.5279V25.7008H11.853V24.4068L11.8536 24.4063Z",
          fill: "#1F0038"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M17.2441 25.5446C16.3333 25.5446 15.6342 25.9188 15.2762 26.5607L15.1726 25.6997H14.1055V32H15.3334V29.6098C15.6667 30.1626 16.2767 30.4713 17.2116 30.4713C18.5286 30.4713 19.6181 29.6747 19.6181 28.0726V28.0317C19.6181 26.414 18.7073 25.544 17.2441 25.544V25.5446ZM18.3415 28.0648C18.3415 28.951 17.8782 29.4389 16.8212 29.4389C15.8213 29.4389 15.3087 28.9431 15.3087 28.0569V28.0245C15.3087 27.1058 15.8863 26.5607 16.8374 26.5607C17.8373 26.5607 18.3415 27.0649 18.3415 28.0323V28.0648Z",
          fill: "#1F0038"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M22.8952 25.5283C21.2286 25.5283 20.0982 26.4632 20.0982 28.0245V28.0732C20.0982 29.5935 20.9357 30.4881 22.8705 30.4881C24.8054 30.4881 25.7 29.5532 25.7 28.0732V28.0245C25.7 26.447 24.5942 25.5283 22.8946 25.5283H22.8952ZM24.4239 28.0648C24.4239 28.951 23.9606 29.4389 22.8952 29.4389C21.8297 29.4389 21.3748 28.9594 21.3748 28.0648V28.0239C21.3748 27.0643 21.9277 26.5602 22.9114 26.5602C23.8951 26.5602 24.4239 27.0806 24.4239 28.0239V28.0648Z",
          fill: "#1F0038"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M28.9361 27.504C27.7244 27.4228 27.3911 27.3416 27.3911 26.9999C27.3911 26.7153 27.627 26.4716 28.4969 26.4716C29.261 26.4716 29.7327 26.6503 29.8385 27.1142H31.1718C30.9197 26.0655 30.0906 25.5289 28.5132 25.5289C26.9357 25.5289 26.1716 26.1955 26.1716 27.0979C26.1716 28.0653 26.9844 28.3746 28.4319 28.4558C29.6352 28.5208 30.0094 28.5942 30.0094 28.9437C30.0094 29.2933 29.717 29.4966 28.8386 29.4966C27.9603 29.4966 27.5295 29.3017 27.3995 28.8053H25.9845C26.1879 29.9274 27.0657 30.4881 28.7893 30.4881C30.4234 30.4881 31.2446 29.8215 31.2446 28.8944C31.2446 27.8945 30.5455 27.6015 28.9355 27.504H28.9361Z",
          fill: "#1F0038"
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ w(
        "linearGradient",
        {
          id: "paint0_linear_1541_95095",
          x1: "16.0991",
          y1: "14.5349",
          x2: "11.2269",
          y2: "-9.01791",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ t("stop", { offset: "0.14", stopColor: "#E50056" }),
            /* @__PURE__ */ t("stop", { offset: "0.75", stopColor: "#1F0038" })
          ]
        }
      ) })
    ]
  }
), Bo = Ao, To = ({
  width: e = 15,
  height: r = 15,
  ...o
}) => /* @__PURE__ */ t(
  "svg",
  {
    width: e,
    height: r,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...o,
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M6.85355 3.14645C7.04882 3.34171 7.04882 3.65829 6.85355 3.85355L3.70711 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H3.70711L6.85355 11.1464C7.04882 11.3417 7.04882 11.6583 6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645L6.14645 3.14645C6.34171 2.95118 6.65829 2.95118 6.85355 3.14645Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
      }
    )
  }
), Zo = To, Ro = ({
  width: e = 15,
  height: r = 15,
  ...o
}) => /* @__PURE__ */ t(
  "svg",
  {
    width: e,
    height: r,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...o,
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M12.8536 2.85355C13.0488 2.65829 13.0488 2.34171 12.8536 2.14645C12.6583 1.95118 12.3417 1.95118 12.1464 2.14645L7.5 6.79289L2.85355 2.14645C2.65829 1.95118 2.34171 1.95118 2.14645 2.14645C1.95118 2.34171 1.95118 2.65829 2.14645 2.85355L6.79289 7.5L2.14645 12.1464C1.95118 12.3417 1.95118 12.6583 2.14645 12.8536C2.34171 13.0488 2.65829 13.0488 2.85355 12.8536L7.5 8.20711L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L8.20711 7.5L12.8536 2.85355Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
      }
    )
  }
), jt = Ro, Po = ({
  strokecolor: e = "#868686",
  ...r
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...r,
    children: [
      /* @__PURE__ */ w("g", { clipPath: "url(#clip0_3521_50925)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M0.9375 5L4.77903 1.15847C4.90107 1.03643 5.09893 1.03643 5.22097 1.15847L9.0625 5",
            stroke: e,
            strokeWidth: "0.78125",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M1.875 4.0625V8.4375C1.875 8.78268 2.15482 9.0625 2.5 9.0625H7.5C7.84518 9.0625 8.125 8.78268 8.125 8.4375V4.0625",
            stroke: e,
            strokeWidth: "0.78125",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M3.75 9.0625V6.25C3.75 5.90482 4.02982 5.625 4.375 5.625H5.625C5.97018 5.625 6.25 5.90482 6.25 6.25V9.0625",
            stroke: e,
            strokeWidth: "0.78125",
            strokeLinecap: "round"
          }
        )
      ] }),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "clip0_3521_50925", children: /* @__PURE__ */ t("rect", { width: "10", height: "10", fill: "white" }) }) })
    ]
  }
), S0 = Po, Oo = ({
  width: e = 9,
  height: r = 10,
  fillcolor: o = "none",
  strokecolor: n = "inherit",
  ...i
}) => /* @__PURE__ */ t(
  "svg",
  {
    fill: o,
    viewBox: "0 0 10 9",
    width: e,
    height: r,
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "m9.125.625-5.25 7.125-3-3.75",
        stroke: n,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Do = Oo, $o = ({
  width: e = 10,
  height: r = 2,
  fillcolor: o = "none",
  strokecolor: n = "inherit",
  ...i
}) => /* @__PURE__ */ t(
  "svg",
  {
    fill: o,
    height: r,
    viewBox: "0 0 10 2",
    width: e,
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "m.5 1h8.99999",
        stroke: n,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), jo = $o, Vo = ({
  width: e = 20,
  height: r = 20,
  fillcolor: o = "none",
  pathstrokecolor: n = "#8840D7",
  pathstrokecolor2: i = "#F8F2FF",
  ...s
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    fill: o,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ...s,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          stroke: n,
          strokeWidth: "3",
          d: "M10 1.5a8.5 8.5 0 110 17 8.5 8.5 0 010-17h0z"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          stroke: i,
          strokeLinecap: "round",
          strokeWidth: "3",
          d: "M10 1.5a8.5 8.5 0 017.853 11.753"
        }
      )
    ]
  }
), Wo = Vo, Ho = ({
  width: e = 20,
  height: r = 20,
  fillcolor: o = "none",
  pathstrokecolor: n = "#EEDEFF",
  pathstrokecolor2: i = "#6222B2",
  ...s
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    fill: o,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ...s,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          stroke: n,
          strokeWidth: "3",
          d: "M10 1.5a8.5 8.5 0 110 17 8.5 8.5 0 010-17h0z"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          stroke: i,
          strokeLinecap: "round",
          strokeWidth: "3",
          d: "M10 1.5a8.5 8.5 0 017.853 11.753"
        }
      )
    ]
  }
), zo = Ho, Uo = ({
  width: e = 24,
  height: r = 24,
  fillcolor: o = "none",
  strokecolor: n = "#E52E5C",
  pathfillcolor: i = "#fff",
  strokeWidth: s = 1.25,
  ...a
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    fill: o,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ...a,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Z",
          fill: i
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "m10.424 5.576-4.848 4.848M5.576 5.576l4.848 4.848",
          stroke: n,
          strokeWidth: s,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), qo = Uo, Go = ({
  width: e = 24,
  height: r = 24,
  fillcolor: o = "none",
  strokecolor: n = "#E52E5C",
  ...i
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    viewBox: "0 0 12 12",
    fill: o,
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ w("g", { clipPath: "url(#clip0_12021_74)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M1.125 1.125L10.875 10.875",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M1.125 10.875L10.875 1.125",
            stroke: n,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ] }),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "clip0_12021_74", children: /* @__PURE__ */ t("rect", { width: "12", height: "12", fill: "white" }) }) })
    ]
  }
), Yo = Go, Xo = ({
  width: e = 24,
  height: r = 24,
  strokecolor: o = "#ffffff",
  pathfillcolor: n = "#E52E5C",
  strokeWidth: i = 1.25,
  ...s
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...s,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M0.571289 8.00084C0.571289 9.97102 1.35394 11.8605 2.74707 13.2536C4.14019 14.6468 6.02968 15.4294 7.99986 15.4294C9.97004 15.4294 11.8595 14.6468 13.2527 13.2536C14.6458 11.8605 15.4284 9.97102 15.4284 8.00084C15.4284 6.03066 14.6458 4.14117 13.2527 2.74804C11.8595 1.35492 9.97004 0.572266 7.99986 0.572266C6.02968 0.572266 4.14019 1.35492 2.74707 2.74804C1.35394 4.14117 0.571289 6.03066 0.571289 8.00084V8.00084Z",
          fill: n,
          strokeWidth: "1.25",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "m10.424 5.576-4.848 4.848M5.576 5.576l4.848 4.848",
          stroke: o,
          strokeWidth: i,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), Ko = Xo, Qo = ({
  width: e = 24,
  height: r = 24,
  fillcolor: o = "none",
  strokecolor: n = "#5975FF",
  ...i
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    fill: o,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ t("path", { d: "M1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Z", fill: "#fff" }),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M8 12V8",
          stroke: n,
          strokeWidth: 1.25,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "circle",
        {
          cx: 8,
          cy: 4.5,
          transform: "rotate(180 8 4.5)",
          stroke: n,
          strokeWidth: 1.25,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          r: 0.5
        }
      )
    ]
  }
), Jo = Qo, en = ({
  width: e = 24,
  height: r = 24,
  fillcolor: o = "none",
  strokecolor: n = "#FFB800",
  ...i
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    fill: o,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.645 14.25h10.71a1 1 0 0 0 .888-1.46L8.888 2.462a1 1 0 0 0-1.776 0L1.757 12.79a1 1 0 0 0 .888 1.46Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M8 5.5V9",
          stroke: n,
          strokeWidth: 1.25,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "circle",
        {
          cx: 8,
          cy: 11.5,
          r: 0.5,
          stroke: n,
          strokeWidth: 1.25,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), tn = en, rn = ({
  width: e = 24,
  height: r = 24,
  fillcolor: o = "none",
  strokecolor: n = "#FFB800",
  ...i
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    fill: o,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M0.571289 8.00084C0.571289 9.97102 1.35394 11.8605 2.74707 13.2536C4.14019 14.6468 6.02968 15.4294 7.99986 15.4294C9.97004 15.4294 11.8595 14.6468 13.2527 13.2536C14.6458 11.8605 15.4284 9.97102 15.4284 8.00084C15.4284 6.03066 14.6458 4.14117 13.2527 2.74804C11.8595 1.35492 9.97004 0.572266 7.99986 0.572266C6.02968 0.572266 4.14019 1.35492 2.74707 2.74804C1.35394 4.14117 0.571289 6.03066 0.571289 8.00084V8.00084Z",
          fill: o
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M8 5.5V9",
          stroke: n,
          strokeWidth: 1.6,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "circle",
        {
          cx: 8,
          cy: 12,
          r: 0.5,
          stroke: n,
          strokeWidth: 1.25,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), on = rn, nn = ({
  fillcolor: e = "none",
  pathfillcolor: r = "#fff",
  pathstrokecolor: o = "#1B8751",
  width: n = 24,
  height: i = 24,
  ...s
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: n,
    height: i,
    fill: e,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ...s,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Z",
          fill: r
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M11 6.424 7.424 10l-2-2",
          stroke: o,
          strokeWidth: 1.25,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), an = nn, sn = ({
  width: e = 16,
  height: r = 16,
  fillcolor: o = "none",
  strokecolor: n = "#330066",
  ...i
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    viewBox: "0 0 16 16",
    fill: o,
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ w("g", { clipPath: "url(#clip0_2241_4458)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M0.571289 8.00084C0.571289 9.97102 1.35394 11.8605 2.74707 13.2536C4.14019 14.6468 6.02968 15.4294 7.99986 15.4294C9.97004 15.4294 11.8595 14.6468 13.2527 13.2536C14.6458 11.8605 15.4284 9.97102 15.4284 8.00084C15.4284 6.03066 14.6458 4.14117 13.2527 2.74804C11.8595 1.35492 9.97004 0.572266 7.99986 0.572266C6.02968 0.572266 4.14019 1.35492 2.74707 2.74804C1.35394 4.14117 0.571289 6.03066 0.571289 8.00084V8.00084Z",
            stroke: n,
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M8 5.14453V8.00167L10.904 11.3902",
            stroke: n,
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ] }),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "clip0_2241_4458", children: /* @__PURE__ */ t("rect", { width: "16", height: "16", fill: "white" }) }) })
    ]
  }
), ln = sn, cn = ({
  width: e = 16,
  height: r = 16,
  fillcolor: o = "none",
  strokecolor: n = "#330066",
  ...i
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    viewBox: "0 0 16 16",
    fill: o,
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ w("g", { clipPath: "url(#clip0_2246_4605)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M0.571289 8.00084C0.571289 9.97102 1.35394 11.8605 2.74707 13.2536C4.14019 14.6468 6.02968 15.4294 7.99986 15.4294C9.97004 15.4294 11.8595 14.6468 13.2527 13.2536C14.6458 11.8605 15.4284 9.97102 15.4284 8.00084C15.4284 6.03066 14.6458 4.14117 13.2527 2.74804C11.8595 1.35492 9.97004 0.572266 7.99986 0.572266C6.02968 0.572266 4.14019 1.35492 2.74707 2.74804C1.35394 4.14117 0.571289 6.03066 0.571289 8.00084V8.00084Z",
            stroke: n,
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M8 8V12",
            stroke: n,
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M7.42871 5.14369C7.42871 5.29525 7.48891 5.44059 7.59608 5.54776C7.70324 5.65492 7.84859 5.71512 8.00014 5.71512C8.15169 5.71512 8.29704 5.65492 8.4042 5.54776C8.51136 5.44059 8.57157 5.29525 8.57157 5.14369C8.57157 4.99214 8.51136 4.8468 8.4042 4.73963C8.29704 4.63247 8.15169 4.57227 8.00014 4.57227C7.84859 4.57227 7.70324 4.63247 7.59608 4.73963C7.48891 4.8468 7.42871 4.99214 7.42871 5.14369Z",
            stroke: n,
            strokeWidth: "1.25",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ] }),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "clip0_2246_4605", children: /* @__PURE__ */ t("rect", { width: "16", height: "16", fill: "white" }) }) })
    ]
  }
), dn = cn, un = ({
  width: e = 14,
  height: r = 14,
  fillcolor: o = "none",
  strokecolor: n = "inherit",
  ...i
}) => /* @__PURE__ */ w(
  "svg",
  {
    fill: o,
    viewBox: "0 0 14 14",
    width: e,
    height: r,
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ t(
        "circle",
        {
          cx: "7",
          cy: "7",
          r: "6",
          stroke: n,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ t("circle", { cx: "7", cy: "7", r: "3", fill: n })
    ]
  }
), fn = un, pn = ({
  width: e = 24,
  height: r = 24,
  pathfillcolor: o = "#14CC70",
  ...n
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M1.5 12C1.5 14.7848 2.60625 17.4555 4.57538 19.4246C6.54451 21.3938 9.21523 22.5 12 22.5C14.7848 22.5 17.4555 21.3938 19.4246 19.4246C21.3938 17.4555 22.5 14.7848 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5C9.21523 1.5 6.54451 2.60625 4.57538 4.57538C2.60625 6.54451 1.5 9.21523 1.5 12V12Z",
          fill: o
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M16.5 8.25L10.7727 16.5L7.5 12.1579",
          stroke: "white",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), mn = pn, hn = ({
  width: e = 24,
  height: r = 24,
  fillcolor: o = "none",
  strokecolor: n = "#868686",
  ...i
}) => /* @__PURE__ */ w(
  "svg",
  {
    width: e,
    height: r,
    viewBox: "0 0 16 16",
    fill: o,
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ t(
        "circle",
        {
          cx: "7",
          cy: "7",
          r: "5",
          stroke: n,
          "stroke-width": "1.25",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M11 11L14.5 14.5",
          stroke: n,
          "stroke-width": "1.25",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    ]
  }
), gn = hn, bn = ({
  width: e = 24,
  height: r = 24,
  pathstrokecolor: o = "#330066",
  ...n
}) => /* @__PURE__ */ w(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    width: e,
    height: r,
    ...n,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12 7.71431V6",
          stroke: o,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9.42871 14.5717C9.42871 15.8575 10.5807 16.286 12.0001 16.286C13.4196 16.286 14.5716 16.286 14.5716 14.5717C14.5716 12.0003 9.42871 12.0003 9.42871 9.42889C9.42871 7.7146 10.5807 7.7146 12.0001 7.7146C13.4196 7.7146 14.5716 8.36431 14.5716 9.42889",
          stroke: o,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M12 16.2854V17.9997",
          stroke: o,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M2.25 12C2.25 14.5859 3.27723 17.0658 5.10571 18.8943C6.93419 20.7228 9.41414 21.75 12 21.75C14.5859 21.75 17.0658 20.7228 18.8943 18.8943C20.7228 17.0658 21.75 14.5859 21.75 12C21.75 9.41414 20.7228 6.93419 18.8943 5.10571C17.0658 3.27723 14.5859 2.25 12 2.25C9.41414 2.25 6.93419 3.27723 5.10571 5.10571C3.27723 6.93419 2.25 9.41414 2.25 12V12Z",
          stroke: o,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), wn = bn, vn = {
  apple: ko,
  arrowRight: _0,
  arrowLeft: F0,
  check: Do,
  chrome: bo,
  close: ao,
  dialogBack: Zo,
  dialogClose: jt,
  dash: jo,
  download: ro,
  eftposCard: Bo,
  error: qo,
  incorrect: Ko,
  eyeHide: uo,
  eyeShow: lo,
  facebook: Fo,
  favourite: Dt,
  filter: no,
  firefox: Co,
  google: No,
  info: Jo,
  infoCircle: dn,
  masterCard: Eo,
  safari: vo,
  spinnerOutline: zo,
  spinnerSolid: Wo,
  success: an,
  successSolid: mn,
  visaCard: Lo,
  warning: tn,
  breadcrumbHome: S0,
  clock: ln,
  radioButton: fn,
  dollar: wn,
  play: ho,
  search: gn,
  unFavourite: $t,
  cancel: Yo,
  warningSolid: on
}, xn = V.memo(
  ({
    name: e,
    width: r,
    height: o,
    strokecolor: n,
    strokeWidth: i,
    strokefill: s,
    fillcolor: a,
    pathfillcolor: c,
    pathfillcolor2: u,
    pathstrokewidth: p,
    pathstrokecolor: g,
    pathstrokecolor2: v,
    imagewidth: d,
    imageheight: m,
    rotatecenter: f,
    className: h,
    onClick: b,
    disabled: _
  }) => {
    const y = vn[e];
    return /* @__PURE__ */ t(
      y,
      {
        width: r,
        height: o,
        strokecolor: n,
        strokeWidth: i,
        strokefill: s,
        fillcolor: a,
        pathfillcolor: c,
        pathfillcolor2: u,
        pathstrokewidth: p,
        pathstrokecolor: g,
        pathstrokecolor2: v,
        imagewidth: d,
        imageheight: m,
        rotatecenter: f,
        className: h,
        onClick: b,
        disabled: _
      }
    );
  }
), Y = xn, N0 = V.forwardRef(
  ({
    children: e,
    className: r,
    disabled: o = !1,
    isLoading: n,
    variant: i = "primary",
    size: s = "lg",
    type: a = "button",
    ...c
  }, u) => /* @__PURE__ */ w(
    "button",
    {
      ref: u,
      type: a,
      disabled: o,
      className: C(
        "button-base",
        //#region  //*=========== Variants ===========
        [
          i === "primary" && ["button-primary"],
          i === "outline" && ["button-outline"],
          i === "ghost" && ["button-ghost"]
        ],
        [s === "sm" && ["button-small"]],
        [s === "lg" && ["button-large"]],
        //#endregion  //*======== Variants ===========
        [
          n && [
            "is-loading relative text-transparent transition-none disabled:cursor-wait"
          ]
        ],
        r
      ),
      "data-test-id": "button",
      onMouseDown: (p) => p.preventDefault(),
      ...c,
      children: [
        n && /* @__PURE__ */ w(
          "div",
          {
            className: C(
              {
                "text-white": ["primary", "dark"].includes(i),
                "text-neutral": ["light"].includes(i),
                "text-primary-500": ["outline", "ghost"].includes(i)
              },
              "is-loading"
            ),
            children: [
              i === "outline" && /* @__PURE__ */ t(
                Y,
                {
                  name: "spinnerOutline",
                  className: "animate-spin",
                  width: s === "sm" ? 16 : 20,
                  height: s === "sm" ? 16 : 20
                }
              ),
              i === "primary" && /* @__PURE__ */ t(
                Y,
                {
                  name: "spinnerSolid",
                  className: "animate-spin",
                  width: s === "sm" ? 16 : 20,
                  height: s === "sm" ? 16 : 20
                }
              )
            ]
          }
        ),
        !n && e
      ]
    }
  )
);
N0.displayName = "Button";
const Vt = N0, M0 = V.forwardRef(
  ({
    className: e,
    variant: r = "outline",
    size: o = "md",
    type: n,
    icon: i,
    iconPosition: s = "left",
    isLoading: a,
    ...c
  }, u) => /* @__PURE__ */ w(
    "button",
    {
      ref: u,
      type: n,
      className: C(
        "action-button-base",
        //#region  //*=========== Variants ===========
        [
          r === "outline" && ["action-button-outline"],
          r === "ghost" && ["action-button-ghost"],
          r === "text" && ["action-button-text"]
        ],
        [o === "sm" && ["action-button-small"]],
        [o === "md" && ["action-button-medium"]],
        [i && c.children && ["space-x-2"]],
        [
          i && !c.children && o === "sm" && ["min-w-[32px] max-w-[32px] justify-center"]
        ],
        [
          i && !c.children && o === "md" && ["min-w-[36px] max-w-[36px] justify-center"]
        ],
        [
          a && [
            "is-loading relative text-transparent transition-none disabled:cursor-wait"
          ]
        ],
        //#endregion  //*======== Variants ===========
        e
      ),
      ...c,
      children: [
        a && /* @__PURE__ */ t(
          "div",
          {
            className: C(
              {
                "text-primary-500": ["outline"].includes(r)
              },
              "is-loading"
            ),
            children: r === "outline" && /* @__PURE__ */ t(
              Y,
              {
                name: "spinnerOutline",
                className: "animate-spin",
                width: 20,
                height: 20
              }
            )
          }
        ),
        !a && /* @__PURE__ */ w(Se, { children: [
          s === "left" && i,
          /* @__PURE__ */ t("span", { className: "text-body-md-700", children: c.children }),
          s === "right" && i
        ] })
      ]
    }
  )
);
M0.displayName = "ActionButton";
const bt = M0;
const E0 = V.forwardRef(
  ({ children: e, href: r, openNewTab: o = !1, className: n, size: i, ...s }, a) => /* @__PURE__ */ t(
    "a",
    {
      tabIndex: 0,
      ref: a,
      target: o ? "_blank" : void 0,
      rel: "noopener noreferrer",
      href: r,
      ...s,
      className: C(
        "unstyled-link",
        // Add the class name to the component
        [i === "xs" && ["text-body-xs"]],
        [i === "sm" && ["text-body-sm"]],
        [i === "md" && ["text-body-base"]],
        [i === "lg" && ["text-body-lg"]],
        n
      ),
      children: e
    }
  )
);
E0.displayName = "UnstyledLink";
const Fe = E0, I0 = V.forwardRef(
  ({ children: e, className: r, ...o }, n) => /* @__PURE__ */ t(
    Fe,
    {
      ref: n,
      ...o,
      className: C(
        "custom-link inline-flex items-center underline underline-offset-4 cursor-pointer",
        "focus:ring-2 focus:ring-blue-500 ring-offset-2 rounded-sm",
        "text-primary-500 hover:border-primary-400 hover:text-primary-400",
        r
      ),
      children: e
    }
  )
);
I0.displayName = "UnderlineLink";
const L0 = I0;
function Cn({
  children: e,
  className: r,
  direction: o = "right",
  icon: n,
  iconPosition: i = "left",
  as: s,
  ...a
}) {
  const c = s || L0, u = C(
    "inline-flex items-center justify-center w-[1.25em] h-[1.25em] rounded-full transition-colors duration-200"
  );
  return /* @__PURE__ */ w(
    c,
    {
      ...a,
      className: C(
        "group gap-[0.25em] cursor-pointer",
        o === "left" && "flex-row-reverse",
        r
      ),
      children: [
        i === "left" && n ? /* @__PURE__ */ t("span", { className: u, children: n }) : null,
        /* @__PURE__ */ t("span", { children: e }),
        i === "right" && n ? /* @__PURE__ */ t("span", { className: u, children: n }) : null
      ]
    }
  );
}
Cn.displayName = "IconLink";
const A0 = V.forwardRef(
  ({ children: e, className: r, variant: o = "primary", size: n = "lg", ...i }, s) => /* @__PURE__ */ t(
    Fe,
    {
      ref: s,
      ...i,
      className: C(
        "button-base cursor-pointer font-primary",
        //#region  //*=========== Variants ===========
        [
          o === "primary" && ["button-primary"],
          o === "outline" && ["button-outline"],
          o === "ghost" && ["button-ghost"],
          o === "link" && ["button-link"]
        ],
        [n === "xs" && ["button-extra-small"]],
        [n === "sm" && ["button-small"]],
        [n === "lg" && ["button-large"]],
        //#endregion  //*======== Variants ===========
        r
      ),
      "data-test-id": "button-link",
      children: e
    }
  )
);
A0.displayName = "ButtonLink";
const B0 = A0, T0 = V.forwardRef(
  ({ className: e, children: r, ...o }, n) => /* @__PURE__ */ t(
    Fe,
    {
      ref: n,
      ...o,
      className: C(
        "inline-flex items-center cursor-pointer",
        "text-primary-500 hover:text-primary-500",
        "focus:ring-2 focus:ring-blue-500 rounded ring-offset-2",
        e
      ),
      children: r
    }
  )
);
T0.displayName = "TextLink";
const Ns = T0, Z0 = V.forwardRef(({ className: e, size: r = 36 }, o) => /* @__PURE__ */ t("div", { className: O("flex justify-center", e), ref: o, children: /* @__PURE__ */ t(Lr, { className: "animate-spin", size: r }) }));
Z0.displayName = "Spinner";
const Ms = Z0, _t = He(
  ({
    label: e,
    id: r,
    name: o,
    type: n = "text",
    placeholder: i = "",
    className: s,
    state: a = "default",
    helperText: c,
    hideHelperText: u = !1,
    value: p,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    icon: g,
    iconPosition: v,
    error: d,
    children: m,
    childrenPosition: f,
    childrenClassName: h,
    hidePasswordIcon: b,
    onChange: _,
    onBlur: y,
    ...k
  }, L) => {
    const [A, R] = J(p || ""), [z, I] = J(!!p), [B, E] = J(
      !!(p && p.toString().length > 0)
    ), S = n === "password" ? "right" : v, [T, $] = J(!1), [j, te] = J(!1);
    le(() => {
      R(p || ""), E(!!p);
    }, [p]);
    const U = d ? "error" : a, me = d ? d.message : c, he = () => {
      $(!T);
    }, ie = (se, pe) => {
      let { placeholder: re } = se.target;
      pe === "focus" ? (re = i, I(!0)) : pe === "blur" && (B ? (I(!0), re = i) : (I(!1), re = "")), se.target.placeholder = re, y && y(se);
    }, de = (se) => {
      const { value: pe } = se.target;
      R(pe), E(!!pe), _ && _(se);
    };
    return /* @__PURE__ */ w(
      "div",
      {
        className: C(
          "text-input relative flex flex-col flex-wrap gap-2",
          U === "success" && "border-success-500"
        ),
        children: [
          /* @__PURE__ */ w("div", { className: "relative flex w-full", children: [
            f === "left" && m && /* @__PURE__ */ t(
              "div",
              {
                className: C(
                  j && !["error", "success"].includes(U) && "border-primary-500",
                  U === "error" && "border-error-500",
                  U === "success" && "border-success-500",
                  h
                ),
                children: m
              }
            ),
            /* @__PURE__ */ t(
              "input",
              {
                ...k,
                ref: L,
                id: r,
                name: o,
                type: T ? "text" : n,
                value: p,
                onChange: de,
                onFocus: (se) => {
                  ie(se, "focus"), te(!0);
                },
                onBlur: (se) => {
                  ie(se, "blur"), te(!1);
                },
                className: C(
                  "inline-flex h-[48px] w-full items-center justify-center rounded-[8px] border bg-white py-4 pl-3 pr-8 text-neutral-500 placeholder-neutral-200  focus:border-primary-500 focus:outline-none focus:ring-transparent disabled:cursor-not-allowed disabled:border-neutral-100 disabled:bg-neutral-50",
                  !["success", "error"].includes(U) && "border-neutral-200",
                  U === "error" && "border-error-500 text-error-500 focus:border-error-500",
                  U === "success" && "border-success-500 focus:border-success-500",
                  "placeholder-transparent",
                  "focus:placeholder-neutral-200",
                  "text-body-base",
                  s
                )
              }
            ),
            /* @__PURE__ */ t(
              "label",
              {
                tabIndex: -1,
                htmlFor: r,
                className: O(
                  "will-change-transform",
                  "text-body-base",
                  "leading-[16.5px]",
                  "pointer-events-none absolute w-full max-w-fit select-none p-0 text-body-base antialiased transform-gpu transition ease-in duration[0.2s] ",
                  A ? "!translate-x-[8px] !translate-y-[-6px] !scale-[0.875]" : "translate-x-[13px] translate-y-[16px] scale-100",
                  "origin-top-left",
                  B && !j && !["success", "error"].includes(U) && "text-neutral-400",
                  z && j && !["success", "error"].includes(U) && "text-purple-500",
                  U === "success" && "text-success-500",
                  U === "error" && "text-error-500",
                  k.disabled && "text-neutral-200",
                  !k.disabled && !j && A && "text-neutral-400",
                  !k.disabled && !j && !A && "text-neutral-300"
                ),
                children: /* @__PURE__ */ t(
                  "span",
                  {
                    className: C(
                      "flex antialiased rounded pointer-events-none select-none",
                      z && "bg-white px-1 leading-none",
                      U === "success" && "text-success-600",
                      U === "error" && "text-error-500"
                    ),
                    children: e
                  }
                )
              }
            ),
            n === "password" && !b && /* @__PURE__ */ t(
              "span",
              {
                className: C(
                  "absolute z-10 m-0 h-4 w-4 cursor-pointer p-0",
                  S === "right" && "right-3 top-1/2 -translate-y-1/2"
                ),
                children: T ? /* @__PURE__ */ t(Y, { name: "eyeShow", onClick: he }) : /* @__PURE__ */ t(Y, { name: "eyeHide", onClick: he })
              }
            ),
            f === "right" && m && /* @__PURE__ */ t("div", { className: C(h), children: m })
          ] }),
          me && !u && /* @__PURE__ */ t(
            "p",
            {
              id: "helperText",
              className: O(
                "max-w-fit px-2 text-body-md-400",
                !["success", "error"].includes(U) && "text-neutral-400",
                U === "success" && "text-neutral-400",
                U === "error" && "text-error-500"
              ),
              dangerouslySetInnerHTML: { __html: me }
            }
          )
        ]
      }
    );
  }
);
_t.displayName = "Textfield";
const yn = {
  xs: "w-16",
  sm: "w-20",
  md: "w-24",
  lg: "w-32",
  xl: "w-40"
}, kn = {
  xs: "h-16",
  sm: "h-20",
  md: "h-24",
  lg: "h-32",
  xl: "h-40"
}, _n = {
  xs: "p-[14px]",
  sm: "p-4",
  md: "p-5",
  lg: "p-6",
  xl: "p-8"
}, Fn = V.forwardRef(function({
  src: r,
  fallback: o,
  children: n,
  size: i = "sm",
  className: s,
  hasBorder: a = !0,
  ...c
}, u) {
  return /* @__PURE__ */ w(
    Lt.Root,
    {
      className: C(
        "flex-column flex items-center justify-center overflow-hidden",
        "rounded-full bg-white",
        i && [yn[i], kn[i]],
        i && _n[i],
        a && "border-[1.25px] border-neutral-100",
        s
      ),
      children: [
        r && /* @__PURE__ */ t(Lt.Image, { src: r, ref: u, ...c }),
        o && /* @__PURE__ */ t(Lt.Fallback, { delayMs: 600, children: o }),
        n
      ]
    }
  );
});
function R0({
  width: e,
  height: r,
  aspectRatio: o = "auto",
  ...n
}) {
  const i = C("animate-shimmer bg-[#f6f7f8]");
  return /* @__PURE__ */ t(
    "div",
    {
      className: i,
      style: {
        backgroundImage: "linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)",
        backgroundSize: "700px 100%",
        backgroundRepeat: "no-repeat",
        aspectRatio: o.replace(":", "/"),
        height: `${r}px`,
        width: `${e}px`
      },
      ...n
    }
  );
}
R0.displayName = "Skeleton";
const P0 = ({
  src: e,
  srcList: r,
  alt: o,
  width: n,
  height: i,
  className: s,
  variant: a = "standard",
  aspectRatio: c = "auto",
  loading: u = "eager",
  ...p
}) => {
  const {
    src: g,
    error: v,
    isLoading: d
  } = Ar({
    srcList: r || e,
    useSuspense: !1
  });
  return v || d ? /* @__PURE__ */ t(R0, { width: n, height: i, aspectRatio: c }) : a === "standard" ? /* @__PURE__ */ t(
    "img",
    {
      src: g,
      alt: o,
      width: n,
      height: i,
      className: s,
      loading: u,
      ...p
    }
  ) : /* @__PURE__ */ t(
    "div",
    {
      "aria-label": a === "cover" ? o : void 0,
      className: C(
        "bg-cover rounded-cr-lg bg-no-repeat",
        a === "center" && "bg-white border border-neutral-200",
        "flex items-center justify-center",
        c === "16:9" && "aspect-[16/9]",
        c === "1:1" && "aspect-[1/1]",
        c === "9:16" && "aspect-[9/16]",
        c === "5:9" && "aspect-[5/9]",
        c === "7:5" && "aspect-[7/5]"
      ),
      style: {
        ...a === "cover" && { backgroundImage: `url(${g})` },
        height: i,
        width: n
      },
      children: a === "center" && /* @__PURE__ */ t(
        "img",
        {
          src: g,
          alt: o,
          className: C("max-w-[50%] max-h-[50%]", s),
          loading: u,
          ...p
        }
      )
    }
  );
};
P0.displayName = "Image";
const ot = P0, Sn = "bg-white w-4 h-4 inline-flex justify-center items-center", Nn = "rounded border border-neutral-300", Mn = "ring-offset-0 focus:outline-none focus:ring-2 focus:ring-blue-500", En = "hover:bg-neutral-100", In = "cursor-pointer", Ln = "data-[state=indeterminate]:bg-primary-500 data-[state=indeterminate]:hover:bg-primary-400", An = "[&:not(:disabled)]:data-[state=checked]:border-none data-[state=checked]:bg-primary-500 data-[state=checked]:hover:bg-primary-400", Bn = "data-[disabled]:disabled:border-neutral-200 data-[disabled]:data-[state=checked]:border-neutral-200 data-[disabled]:data-[state=checked]:border", Tn = "data-[disabled]:disabled:bg-neutral-50 data-[disabled]:data-[state=checked]:bg-neutral-50", Zn = "data-[disabled]:disabled:pointer-events-none data-[disabled]:disabled:cursor-not-allowed", Rn = ({
  id: e,
  label: r,
  defaultChecked: o = !1,
  checkedColor: n = "inherit",
  customCheckboxElement: i,
  onCheckedChange: s,
  ...a
}) => {
  const [c, u] = J(
    o === "indeterminate" ? "indeterminate" : o
  ), p = (v) => {
    u(v), s ? s(v) : u(v);
  }, g = (v) => {
    v.key === " " && p(!c);
  };
  return /* @__PURE__ */ w("div", { className: C("flex gap-2 grid-flow-col items-center", "group"), children: [
    i ? /* @__PURE__ */ t(
      r0,
      {
        id: e,
        defaultChecked: o,
        className: C("cursor-pointer"),
        asChild: !0,
        checked: c,
        onCheckedChange: p,
        disabled: a.disabled,
        name: a.name,
        value: a.value,
        required: a.required,
        tabIndex: 0,
        onKeyDown: g,
        children: i
      }
    ) : /* @__PURE__ */ t(
      r0,
      {
        id: e,
        defaultChecked: o,
        className: C(
          Sn,
          Nn,
          Mn,
          En,
          In,
          An,
          Ln,
          Bn,
          Tn,
          Zn
        ),
        checked: c,
        onCheckedChange: p,
        disabled: a.disabled,
        name: a.name,
        value: a.value,
        required: a.required,
        children: /* @__PURE__ */ w(
          Br,
          {
            className: C(
              "data-[state=checked]:stroke-white data-[state=indeterminate]:stroke-white data-[state=checked]:data-[disabled]:stroke-neutral-200"
            ),
            children: [
              c === "indeterminate" && /* @__PURE__ */ t(Y, { name: "dash", strokecolor: n }),
              c === !0 && /* @__PURE__ */ t(Y, { name: "check", strokecolor: n })
            ]
          }
        )
      }
    ),
    r && /* @__PURE__ */ t(
      "label",
      {
        className: C(!a.disabled && "group-hover:cursor-pointer"),
        htmlFor: e,
        children: r
      }
    )
  ] });
}, Es = Rn, Pn = V.forwardRef(
  function({ type: r = "h1", size: o = "lg", className: n, children: i }, s) {
    return /* @__PURE__ */ t(r, { ref: s, className: C(o, n), children: i });
  }
), Ct = Pn, On = ({
  children: e,
  id: r,
  name: o,
  size: n = "small",
  variant: i = "primary",
  className: s,
  labelVariant: a = "inline",
  value: c,
  label: u,
  onChange: p,
  ...g
}) => {
  var b, _;
  const [v, d] = J(
    null
  ), m = H(
    (y) => {
      d({
        current: y
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [c]
  ), f = ((b = v == null ? void 0 : v.current) == null ? void 0 : b.selectedIndex) || 0, h = (_ = v == null ? void 0 : v.current) == null ? void 0 : _.options[f].text;
  return /* @__PURE__ */ w(
    "div",
    {
      className: C([
        "rounded-cr-sm flex max-w-full transition-colors",
        i === "primary" && "border-purple-500 border font-normal focus-within:border-red-100 focus-within:outline-none focus-within:ring-2 focus-within:ring-blue-500 focus-within:outline-2 focus-within:outline-offset-2  text-purple-500 hover:bg-purple-500 hover:text-white",
        a === "inline" && "relative w-fit whitespace-nowrap",
        n === "small" && "pt-cr-1 pb-cr-1 pl-cr-2 pr-cr-2",
        n === "small" && ".text-body-sm",
        "group",
        s
      ]),
      children: [
        /* @__PURE__ */ t(
          "label",
          {
            className: C([
              a === "inline" && "justify-center items-center pointer-events-none"
            ]),
            htmlFor: r,
            children: u
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            className: C([
              "hidden",
              a === "inline" && "block font-bold pl-cr-2 flex-grow bg-right bg-no-repeat pr-[25px] text-ellipsis overflow-hidden bg-arrowDownPrimary",
              a === "inline" && "group-hover:bg-arrowDownWhite"
            ]),
            children: h
          }
        ),
        /* @__PURE__ */ t(
          "select",
          {
            className: C([
              "appearance-none border-0 cursor-pointer",
              a === "inline" && "outline-none absolute top-0 left-0 w-full opacity-0",
              n === "small" && ".text-body-sm",
              "bg-white text-purple-500"
            ]),
            id: r,
            name: o,
            ref: m,
            value: c,
            onChange: p,
            ...g,
            children: e
          }
        )
      ]
    }
  );
}, Is = On, Dn = ({ text: e, children: r }) => /* @__PURE__ */ t("optgroup", { label: e, children: r }), Ls = Dn, $n = ({ children: e, value: r, ...o }) => /* @__PURE__ */ t("option", { value: r, ...o, children: e }), As = $n, jn = V.forwardRef(
  function({ items: r, linksAs: o, className: n, ...i }, s) {
    const a = o ?? Fe;
    return /* @__PURE__ */ t(
      "ol",
      {
        "aria-label": "Breadcrumb",
        ref: s,
        className: C(
          "flex items-center gap-1 text-xs font-secondary text-neutral-300",
          n
        ),
        itemScope: !0,
        itemType: "https://schema.org/BreadcrumbList",
        ...i,
        children: r.map(({ path: c, text: u, active: p }, g) => {
          const v = g === 0 ? /* @__PURE__ */ w(Se, { children: [
            /* @__PURE__ */ t(S0, { width: 10, height: 10 }, "icon"),
            /* @__PURE__ */ t("span", { itemProp: "name", className: "hidden", children: u }, "meta")
          ] }) : /* @__PURE__ */ t("span", { itemProp: "name", children: u });
          return /* @__PURE__ */ w(V.Fragment, { children: [
            /* @__PURE__ */ w(
              "li",
              {
                itemProp: "itemListElement",
                itemScope: !0,
                itemType: "https://schema.org/ListItem",
                className: C("text-neutral-300"),
                children: [
                  c ? /* @__PURE__ */ t(
                    a,
                    {
                      href: c,
                      itemProp: "item",
                      className: O(
                        "hover:text-neutral-400",
                        p && "text-neutral-500"
                      ),
                      "aria-label": u,
                      children: v
                    }
                  ) : /* @__PURE__ */ t(
                    "span",
                    {
                      className: O(p && "text-neutral-500"),
                      itemProp: "name",
                      children: v
                    }
                  ),
                  /* @__PURE__ */ t(
                    "meta",
                    {
                      itemProp: "position",
                      content: `${g + 1}`
                    },
                    `${u}-meta`
                  )
                ]
              },
              `${u}`
            ),
            g < r.length - 1 && /* @__PURE__ */ t("span", { children: "/" }, `${u}-sep`)
          ] }, `${u}`);
        })
      }
    );
  }
), Bs = jn, O0 = V.forwardRef(
  ({
    className: e,
    isRounded: r,
    icon: o,
    size: n = "sm",
    iconPosition: i = "right",
    children: s,
    ...a
  }, c) => {
    const u = s ? /* @__PURE__ */ w(Se, { children: [
      i === "left" && o,
      /* @__PURE__ */ t("span", { children: s }),
      i === "right" && o
    ] }) : o;
    return /* @__PURE__ */ t(
      Vt,
      {
        ref: c,
        className: O(
          "flex items-center justify-center",
          r && "rounded-cr-full",
          e
        ),
        size: n,
        ...a,
        children: u
      }
    );
  }
);
O0.displayName = "IconButton";
const D0 = O0, n0 = At.default ? At.default : At, $0 = ({
  src: e,
  autoPlay: r = !1,
  loop: o = !1,
  controls: n = !0,
  muted: i = !1,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  playsInline: s = !0,
  thumbnail: a,
  className: c = "",
  height: u,
  width: p,
  onFirstQuartile: g,
  onMidPoint: v,
  onThirdQuartile: d,
  onClickPreview: m,
  onEnded: f,
  thumbnailOrientation: h = "landscape",
  playInline: b = !1,
  ..._
}) => {
  const y = ce(null), k = ce(!1), L = ce(!1), A = ce(!1), R = ce(null), [z, I] = J(r), [B, E] = J(!1), [S, T] = J(r);
  le(() => {
    typeof window < "u" && E(!0);
  }, []);
  const $ = H(
    ({
      playedSeconds: ie,
      loadedSeconds: de
    }) => {
      const se = ie / de * 100;
      [
        {
          percentage: 25,
          ref: k,
          callback: g
        },
        { percentage: 50, ref: L, callback: v },
        {
          percentage: 75,
          ref: A,
          callback: d
        }
      ].forEach(
        ({ percentage: re, ref: Te, callback: Me }) => {
          !Te.current && se >= re && (Te.current = !0, Me && Me(y.current));
        }
      );
    },
    [g, v, d]
  ), j = H(() => {
    f && f(y.current);
  }, [f]), te = H((ie) => {
    const de = document.querySelector("body");
    de && (de.style.overflow = ie ? "hidden" : "");
  }, []), U = H(() => {
    var ie, de;
    I(!1), (de = (ie = y.current) == null ? void 0 : ie.getInternalPlayer()) == null || de.pause(), te(!1);
  }, [te]);
  le(() => {
    const ie = (de) => {
      de.key === "Escape" && U();
    };
    return document.addEventListener("keydown", ie), () => {
      document.removeEventListener("keydown", ie);
    };
  }, [U]);
  const me = H(() => {
    m && m(y == null ? void 0 : y.current), T(!0), b || I(!0), te(!0);
  }, [te, m, b]), he = /* @__PURE__ */ t(Y, { name: "play", height: 64, width: 64, className: "absolute self-center" });
  return /* @__PURE__ */ t(Se, { children: B && /* @__PURE__ */ w(Se, { children: [
    (b && !S || !b) && /* @__PURE__ */ t(
      "div",
      {
        style: {
          backgroundImage: `url(${a})`,
          height: u,
          width: p
        },
        className: C(
          h === "portrait" && "aspect-9/16",
          h === "landscape" && "aspect-video",
          "relative bg-cover bg-center w-full h-full cursor-pointer flex justify-center align-middle bg-black-100 rounded-cr-lg overflow-hidden backdrop-brightness-50",
          c
        ),
        onClick: me,
        children: /* @__PURE__ */ t("div", { className: "relative flex justify-center w-full h-full align-middle bg-center bg-cover cursor-pointer bg-transparent-black-50 backdrop-brightness-50", children: he })
      }
    ),
    b && S && /* @__PURE__ */ t(
      "div",
      {
        className: C(
          h === "portrait" && "aspect-9/16",
          h === "landscape" && "aspect-video",
          "relative w-full h-full cursor-pointer flex justify-center align-middle bg-black-100 rounded-cr-lg overflow-hidden backdrop-brightness-50",
          c
        ),
        style: {
          height: u,
          width: p
        },
        children: /* @__PURE__ */ t(
          n0,
          {
            ref: y,
            url: e,
            playing: S,
            loop: o,
            controls: n,
            muted: r ? !0 : i,
            playsinline: !0,
            playIcon: he,
            className: "h-full max-w-[1280px] max-h-[1280px] self-center relative",
            onProgress: $,
            width: "100%",
            height: "100%",
            light: !1,
            onEnded: j,
            ..._
          }
        )
      }
    ),
    z && /* @__PURE__ */ w(
      "div",
      {
        ref: R,
        className: O(
          "fixed top-0 left-0 w-full h-full z-50 bg-opacity-80 flex items-center justify-center bg-neutral-900"
        ),
        children: [
          /* @__PURE__ */ t(
            D0,
            {
              className: "absolute z-[60] bg-white top-4 right-4 hover:bg-neutral-200",
              onClick: U,
              isRounded: !0,
              icon: /* @__PURE__ */ t(
                Y,
                {
                  width: 16,
                  height: 16,
                  strokecolor: "#282828",
                  name: "close"
                }
              )
            }
          ),
          /* @__PURE__ */ t("div", { className: "relative flex h-full", children: /* @__PURE__ */ t(
            n0,
            {
              ref: y,
              url: e,
              playing: S,
              loop: o,
              controls: n,
              muted: r ? !0 : i,
              playsinline: !0,
              playIcon: he,
              className: "h-full max-w-[1280px] max-h-[1280px] self-center relative",
              onProgress: $,
              width: "100%",
              height: "100%",
              light: !1,
              onEnded: j,
              ..._
            }
          ) })
        ]
      }
    )
  ] }) });
};
$0.displayName = "VideoPlayer";
const i0 = $0, Vn = ({ date: e }) => /* @__PURE__ */ t("time", { dateTime: "2023-09-15T19:00", children: Tr(e, "d MMMM yyyy") }), a0 = Vn, Wn = ({ dirtyHtml: e }) => /* @__PURE__ */ t(
  Zr,
  {
    options: {
      overrides: {
        ul: {
          props: {
            className: "list-disc list-inside"
          }
        },
        ol: {
          props: {
            className: "list-decimal list-inside"
          }
        },
        a: {
          component: L0
        }
      }
    },
    children: Rr(e, {
      allowedTags: [
        "a",
        "div",
        "span",
        "br",
        "p",
        "em",
        "i",
        "strong",
        "b",
        "ul",
        "ol",
        "li"
      ]
    })
  }
), Hn = Wn, j0 = _r.forwardRef(
  ({ className: e, icon: r, heading: o, message: n, action: i, href: s }, a) => /* @__PURE__ */ t("div", { className: C(e, "w-full"), ref: a, children: /* @__PURE__ */ t(
    "div",
    {
      className: C(
        "w-[352px] flex justify-between rounded-md p-2",
        r === "error" ? "bg-error-100" : r === "warning" ? "bg-alert-100" : r === "success" ? "bg-success-100" : "bg-info-100"
      ),
      children: /* @__PURE__ */ w("div", { className: "flex", children: [
        /* @__PURE__ */ t("div", { className: "mt-1", children: r === "error" ? /* @__PURE__ */ t(
          Y,
          {
            name: "incorrect",
            width: "16",
            height: "16",
            className: "flex-grow flex-shrink-0 "
          }
        ) : r === "warning" ? /* @__PURE__ */ t(
          Y,
          {
            name: "warningSolid",
            width: "16",
            height: "16",
            className: " flex-grow flex-shrink-0",
            strokecolor: "black",
            fillcolor: "#FAC832"
          }
        ) : r === "success" ? /* @__PURE__ */ t(
          Y,
          {
            name: "successSolid",
            width: "16",
            height: "16",
            className: "flex-grow flex-shrink-0"
          }
        ) : /* @__PURE__ */ t(
          Y,
          {
            name: "warningSolid",
            width: "16",
            height: "16",
            className: " flex-grow flex-shrink-0",
            strokecolor: "white",
            fillcolor: "#5975FF"
          }
        ) }),
        /* @__PURE__ */ w("div", { className: "ml-2", children: [
          o && /* @__PURE__ */ t("h2", { className: "font-secondary text-cr-body-lg-700", children: o }),
          /* @__PURE__ */ t("p", { className: "font-secondary text-cr-body-lg-400 overflow-hidden overflow-ellipsis max-h-20", children: n }),
          s && /* @__PURE__ */ t(
            Fe,
            {
              href: s,
              className: "font-secondary text-cr-body-lg-700 mt-1",
              children: i
            }
          )
        ] })
      ] })
    }
  ) })
);
j0.displayName = "AlertBox";
const Ts = j0, V0 = V.forwardRef(
  ({ className: e, isDarkBg: r = !1, browserName: o, size: n = "lg", ...i }, s) => {
    const a = (u = "lg") => {
      const p = {
        className: u === "sm" ? "w-[16px] h-[16px]" : "w-[24px] h-[24px]",
        width: u === "sm" ? 16 : 24,
        height: u === "sm" ? 16 : 24
      };
      switch (o) {
        case "chrome":
          return /* @__PURE__ */ t(Y, { name: "chrome", ...p });
        case "firefox":
          return /* @__PURE__ */ t(Y, { name: "firefox", ...p });
        case "safari":
          return /* @__PURE__ */ t(Y, { name: "safari", ...p });
        default:
          return /* @__PURE__ */ t(Y, { name: "chrome", ...p });
      }
    };
    return /* @__PURE__ */ w(
      B0,
      {
        ref: s,
        href: (() => {
          switch (o) {
            case "chrome":
              return "https://chrome.google.com/webstore/detail/cashrewards/foehlpanophbpagddidofdpeiappcmgf?utm_source=Instapage&utm_medium=cta&utm_campaign=notifier";
            case "firefox":
              return "https://addons.mozilla.org/en-US/firefox/addon/cashrewards/?utm_source=Instapage&utm_medium=cta&utm_campaign=notifier";
            case "safari":
              return "https://apps.apple.com/us/app/cashrewards/id1449226880?utm_source=Instapage&utm_medium=cta&utm_campaign=notifier";
            default:
              return "https://chrome.google.com/webstore/detail/cashrewards/foehlpanophbpagddidofdpeiappcmgf?utm_source=Instapage&utm_medium=cta&utm_campaign=notifier";
          }
        })(),
        type: "button",
        className: C(
          [
            r ? "bg-white text-neutral-500 focus:bg-white hover:border hover:border-white hover:bg-neutral-500 hover:text-white" : "bg-neutral-900 text-white hover:bg-neutral-500 focus:bg-neutral-500"
          ],
          [
            n === "sm" && ["notifier-button-small"],
            n === "lg" && ["notifier-button-large"]
          ],
          e
        ),
        ...i,
        children: [
          a(n),
          /* @__PURE__ */ w("span", { children: [
            "Add to ",
            o
          ] })
        ]
      }
    );
  }
);
V0.displayName = "NotifierButton";
const Zs = V0, zn = {
  ios: "https://apps.apple.com/au/app/cashrewards-cashback-rewards/id1435807627",
  android: "https://play.google.com/store/apps/details?id=com.cashrewards&hl=en_AU&gl=US"
}, s0 = {
  iosLight: "assets/icons/svg/app-store.svg",
  androidLight: "assets/icons/svg/google-play.svg",
  iosDark: "assets/icons/svg/app-store-white.svg",
  androidDark: "assets/icons/svg/google-play-white.svg",
  iosOutline: "assets/icons/svg/app-store-outline.svg",
  androidOutline: "assets/icons/svg/google-play-outline.svg",
  iosOutlineDark: "assets/icons/svg/app-store-outline-white.svg",
  androidOutlineDark: "assets/icons/svg/google-play-outline-white.svg"
}, Un = V.forwardRef(
  ({ isDarkBg: e = !1, os: r, variant: o, size: n = "lg", ...i }, s) => {
    const a = () => o === "outline" ? s0[`${r}${e ? "OutlineDark" : "Outline"}`] : s0[`${r}${e ? "Dark" : "Light"}`], c = () => n === "sm" ? "h-[40px] max-h-[40px]" : n === "md" ? "h-[44px] max-h-[44px]" : n === "lg" ? "h-[48px] max-h-[48px]" : "";
    return /* @__PURE__ */ t(
      Fe,
      {
        ref: s,
        href: zn[r],
        target: "_blank",
        rel: "noopener noreferrer",
        type: "button",
        className: C("focus:ring-0 max-w-fit", c()),
        ...i,
        children: /* @__PURE__ */ t(
          "img",
          {
            src: a(),
            className: "w-full h-full",
            alt: r === "ios" ? "Download on the App Store" : "Get it on Google Play"
          }
        )
      }
    );
  }
), Rs = Un, W0 = He(
  ({
    className: e,
    disabled: r,
    isDarkBg: o = !1,
    ssoName: n = "facebook",
    isLoading: i,
    size: s = "md",
    hideContinueText: a = !1,
    styleClassName: c,
    showOnlyIcon: u = !1,
    ...p
  }, g) => {
    const v = i || r, d = n.toLowerCase(), m = () => {
      const f = {
        className: "w-6 h-6",
        disabled: v
      };
      switch (d) {
        case "google":
        case "apple":
          return /* @__PURE__ */ t(Y, { name: d, ...f });
        default:
          return /* @__PURE__ */ t(Y, { name: "facebook", ...f });
      }
    };
    return /* @__PURE__ */ t(
      Vt,
      {
        ref: g,
        type: "button",
        isLoading: i,
        size: s,
        disabled: v,
        className: O(
          "sso-button-base",
          "p-cr-3",
          u ? "sso-button-iconOnly" : "",
          c || "",
          u ? "max-w-[48px]" : "",
          {
            "sso-button-md": s === "md",
            "sso-button-lg": s === "lg"
          },
          e
        ),
        ...p,
        children: u ? m() : /* @__PURE__ */ w(Se, { children: [
          m(),
          /* @__PURE__ */ w("span", { children: [
            a ? /* @__PURE__ */ t("span", { className: "sr-only", children: "Continue with " }) : /* @__PURE__ */ t("span", { className: "inline-block", children: "Continue with " }),
            n.charAt(0).toUpperCase() + n.slice(1)
          ] })
        ] })
      }
    );
  }
);
W0.displayName = "SSOButton";
const Ps = W0, Ft = 25, qn = ye({
  from: { transform: `translateX(calc(100% + ${Ft}px))` },
  to: { transform: "translateX(0)" }
}), Gn = ye({
  from: { transform: "translateX(var(--radix-toast-swipe-end-x))" },
  to: { transform: `translateX(calc(100% + ${Ft}px))` }
}), Yn = ye({
  from: {
    transform: `translateY(calc(-100% - ${Ft}px))`,
    opacity: 0
  },
  to: {
    transform: "translateY(0)",
    opacity: 1
  }
}), Xn = ye({
  "0%": { opacity: 1 },
  "100%": { opacity: 0 }
}), Kn = Ne(Ve.Action, {
  gridArea: "action"
}), Qn = Ve.Provider, Jn = Ve.Title, ei = Ve.Description, ti = (e, r) => {
  const o = "mt-1";
  switch (e) {
    case "success":
      return /* @__PURE__ */ t(
        Y,
        {
          name: "success",
          className: o,
          fillcolor: r === "light" ? "#14CC70" : "#fff",
          strokecolor: r === "light" ? "#fff" : "#1B8751"
        }
      );
    case "error":
      return /* @__PURE__ */ t(
        Y,
        {
          name: "error",
          className: o,
          fillcolor: r === "light" ? "#E52E5C" : "#fff",
          strokecolor: "#E52E5C"
        }
      );
    case "warning":
      return /* @__PURE__ */ t(
        Y,
        {
          name: "warning",
          className: o,
          fillcolor: r === "light" ? "#FAC832" : "#fff"
        }
      );
    case "info":
      return /* @__PURE__ */ t(
        Y,
        {
          name: "info",
          className: o,
          fillcolor: r === "light" ? "#5975FF" : "#fff",
          strokecolor: r === "light" ? "#fff" : "#5975FF"
        }
      );
    default:
      return /* @__PURE__ */ t(Y, { name: "info", className: o });
  }
}, ri = (e, r) => {
  const o = {
    success: {
      light: "text-neutral-500 bg-success-100",
      dark: "bg-success-500 text-neutral-500"
    },
    error: {
      light: "text-neutral-500 bg-error-100",
      dark: "bg-error-500 text-white"
    },
    warning: {
      light: "text-neutral-500 bg-alert-100",
      dark: "bg-alert-500 text-neutral-500"
    },
    info: {
      light: "text-neutral-500 bg-info-100",
      dark: "bg-info-500 text-white"
    }
  }, n = o[e] || o.info;
  return r === "light" ? n.light : n.dark;
}, oi = (e, r) => ({
  warning: "#282828",
  info: r === "light" ? "#282828" : "#fff"
})[e] || (r === "light" ? "#282828" : "#fff"), H0 = ({
  className: e,
  title: r,
  type: o,
  variant: n = "light",
  icon: i,
  isShow: s = !0,
  message: a,
  action: c,
  actionAltText: u,
  animationDirection: p = "top-right",
  swipeDirection: g = "right",
  duration: v = 5e3,
  handleToastOpen: d,
  handleActionClick: m
}) => {
  const [f, h] = J(s), b = V.useRef(0), _ = Ne(Ve.Viewport, {
    position: "fixed",
    bottom: p === "top-right" ? 0 : "auto",
    top: p === "top-bottom" ? 0 : "auto",
    right: p === "top-right" ? 0 : "50%",
    transform: p === "top-bottom" ? "translateX(50%)" : "none",
    display: "flex",
    flexDirection: "column",
    padding: Ft,
    gap: 10,
    margin: 0,
    listStyle: "none",
    zIndex: 2147483647,
    outline: "none"
  }), y = Ne(Ve.Root, {
    "@media (prefers-reduced-motion: no-preference)": {
      '&[data-state="open"]': {
        animation: `${p === "top-bottom" ? Yn : qn} 150ms cubic-bezier(0.16, 1, 0.3, 1)`
      },
      '&[data-state="closed"]': {
        animation: `${Xn} 100ms ease-in`
      },
      '&[data-swipe="move"]': {
        transform: "translateX(var(--radix-toast-swipe-move-x))"
      },
      '&[data-swipe="cancel"]': {
        transform: "translateX(0)",
        transition: "transform 200ms ease-out"
      },
      '&[data-swipe="end"]': {
        animation: `${Gn} 100ms ease-out`
      }
    }
  });
  return le(() => (s && (b.current = window.setTimeout(() => {
    h(!0);
  }, v)), () => {
    clearTimeout(b.current);
  }), [s, v]), /* @__PURE__ */ w(Qn, { swipeDirection: g, children: [
    /* @__PURE__ */ w(
      y,
      {
        open: f,
        onOpenChange: (k) => {
          d && d(k), h(k);
        },
        className: C(
          "flex min-w-[334px] max-w-[926px] gap-[10px] rounded bg-error-500 p-2 transition ease-in focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75",
          ri(o, n),
          e
        ),
        "data-test-id": "toaster-wrapper",
        duration: v,
        defaultOpen: !1,
        children: [
          i ? /* @__PURE__ */ t(Se, { children: i }) : ti(o, n),
          /* @__PURE__ */ w("div", { className: "flex flex-col", children: [
            r && /* @__PURE__ */ t(
              Jn,
              {
                className: "mb-1 font-bold text-body-base",
                "data-test-id": "toaster-title",
                children: r
              }
            ),
            a && /* @__PURE__ */ t(
              ei,
              {
                className: "mb-2 text-sm",
                "data-test-id": "toaster-message",
                children: a
              }
            ),
            c && /* @__PURE__ */ t(Kn, { asChild: !0, altText: u ?? "Action", children: /* @__PURE__ */ t(
              B0,
              {
                href: c.href,
                onClick: () => {
                  m && m();
                },
                children: c.children
              }
            ) })
          ] }),
          /* @__PURE__ */ t(
            Ve.Close,
            {
              "aria-label": "Close",
              className: "w-2 h-2 mt-1 ml-auto",
              children: /* @__PURE__ */ t(
                Y,
                {
                  name: "close",
                  strokecolor: oi(o, n),
                  height: 8,
                  width: 8,
                  "aria-hidden": !0
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ t(_, {})
  ] });
};
H0.displayName = "Toaster";
const Os = H0, ni = Ne("div", {
  "-webkit-tap-highlight-color": "transparent",
  "&::before": {
    content: "",
    position: "absolute",
    height: "100%",
    width: "100%",
    borderRadius: "100px",
    transition: "all 200ms"
  }
});
function Ds({
  tabs: e,
  value: r,
  onChange: o,
  floating: n,
  size: i = "md",
  variant: s = "over-white"
}) {
  const a = (e == null ? void 0 : e.length) || 1, c = ze(() => e == null ? void 0 : e.findIndex((_) => _.name === r), [r, e]), u = (_) => {
    r !== _ && o && o(_);
  }, p = c >= 0, g = p ? c : 0, v = 8, d = a - 1, m = v * d, f = `calc(( 100% - ${m}px) / ${a} )`, h = p ? `calc(${f})` : "100%", b = `calc(calc(( 100% - ${m}px) / ${a} ) * ${g} + ${v * g}px)`;
  return /* @__PURE__ */ t(
    ni,
    {
      role: "tablist",
      className: C(
        "relative grid items-center w-full font-bold cursor-pointer rounded-[100px] gap-2 border-4 border-transparent",
        s === "over-white" && "bg-neutral-100  before:bg-white",
        s === "over-grey" && "bg-white before:bg-primary-500",
        s === "over-image" && "bg-white/60 before:bg-white  backdrop-blur-[5px]",
        n && "shadow-[0_4px_10px_rgba(0,0,0,0.2)]"
      ),
      css: {
        "grid-template-columns": `repeat(${a}, 1fr)`,
        "&::before": {
          opacity: p ? "100%" : "0%",
          width: h,
          left: b
        }
      },
      children: e && e.map((_) => {
        const y = r === _.name;
        return /* @__PURE__ */ t(
          "button",
          {
            className: C(
              "relative rounded-[100px] text-center disabled:cursor-not-allowed disabled:text-neutral-200 focus-visible:outline focus-visible:outline-2 outline-info-500",
              !_.disabled && !y && "hover:bg-neutral-50",
              !y && "text-neutral-500",
              y && s === "over-white" && "text-primary-500",
              y && s === "over-image" && "text-primary-500",
              y && s === "over-grey" && "text-white",
              i === "sm" ? "px-4 py-[4px]" : " px-4 py-[8px]",
              "text-base"
            ),
            disabled: y ? !1 : _.disabled || !o,
            onClick: _.disabled ? void 0 : () => u(_.name),
            title: _.title,
            role: "tab",
            "aria-selected": y,
            children: _.title
          },
          _.name
        );
      })
    }
  );
}
function ii({
  tab: e,
  value: r,
  onChange: o,
  setIndicatorPosition: n,
  isHoverEnabled: i
}) {
  const s = (u) => {
    r !== u && o && o(u);
  }, a = ce(null), c = r === e.name;
  return le(() => {
    var u, p, g, v, d;
    if (n && c && (n(
      ((u = a.current) == null ? void 0 : u.offsetLeft) || 0,
      ((p = a.current) == null ? void 0 : p.clientWidth) || 0
    ), (g = a.current) != null && g.parentElement)) {
      const m = a.current.parentElement.clientWidth, f = 20;
      ((v = a.current) == null ? void 0 : v.parentElement.scrollLeft) < a.current.offsetLeft - m / 2 && (a.current.parentElement.scrollLeft += m / 2), ((d = a.current) == null ? void 0 : d.parentElement.scrollLeft) > a.current.offsetLeft - f && (a.current.parentElement.scrollLeft = a.current.offsetLeft - f);
    }
  }, [a, n, c]), /* @__PURE__ */ t(
    "button",
    {
      ref: a,
      className: C(
        "relative mx-1 pt-2 pb-4 text-left text-body-base text-neutral-400 outline-info-500 focus-visible:outline focus-visible:outline-2 disabled:cursor-not-allowed disabled:text-neutral-200",
        c && "text-primary-500",
        i && "hover:text-primary-400"
      ),
      disabled: c ? !1 : e.disabled || !o,
      onClick: e.disabled ? void 0 : () => s(e.name),
      title: e.title,
      role: "tab",
      "aria-selected": c,
      children: /* @__PURE__ */ t("span", { className: "whitespace-nowrap", children: e.title })
    },
    e.name
  );
}
const ai = Ne("div", {
  "&::before": {
    content: "",
    position: "absolute",
    height: "100%",
    transition: "all 200ms"
  }
});
function $s({
  tabs: e,
  value: r,
  onChange: o,
  floating: n,
  isHoverEnabled: i = !0
}) {
  const s = (e == null ? void 0 : e.length) || 1, a = ze(() => (e == null ? void 0 : e.findIndex((g) => g.name === r)) >= 0, [r, e]), [c, u] = J({
    left: 0,
    width: 0
  }), p = H(
    (g, v) => {
      (c.left !== g || c.width !== v) && u({ left: g, width: v });
    },
    [c.left, c.width]
  );
  return /* @__PURE__ */ t(
    ai,
    {
      role: "tablist",
      className: C(
        "relative grid cursor-pointer items-center gap-8 overflow-auto whitespace-nowrap border-b-[1px] border-neutral-200 bg-white px-4 font-normal before:border-b-4 before:border-solid before:border-primary-500 before:bg-white",
        n && "shadow-[0_4px_10px_rgba(0,0,0,0.2)]"
      ),
      css: {
        "grid-template-columns": `repeat(${s}, min-content)`,
        "&::before": {
          opacity: a ? "100%" : "0%",
          width: c.width,
          left: c.left
        }
      },
      children: e && e.map((g) => /* @__PURE__ */ t(
        ii,
        {
          tab: g,
          value: r,
          onChange: o,
          setIndicatorPosition: p,
          isHoverEnabled: i
        },
        g.name
      ))
    }
  );
}
const We = 300, si = ye({
  "0%": { opacity: 0 },
  "100%": { opacity: 1 }
}), li = ye({
  "0%": { opacity: 1 },
  "100%": { opacity: 0 }
}), ci = Ne("div", {
  backgroundColor: "rgb(0, 0, 0, 0.2)",
  animation: `${li} ${We}ms forwards`,
  animationDelay: `${We}ms`,
  variants: {
    isOpen: {
      true: {
        animation: `${si} ${We}ms forwards`
      }
    }
  }
}), di = ye({
  "0%": { transform: "translateY(-15vh)", opacity: 0 },
  "100%": { transform: "translateY(0)", opacity: 1 }
}), ui = ye({
  "0%": { transform: "translateY(0)", opacity: 1 },
  "100%": { transform: "translateY(15vh)", opacity: 0 }
}), fi = Ne("div", {
  animation: `${ui} ${We + 200}ms forwards`,
  variants: {
    isOpen: {
      true: {
        animation: `${di} ${We + 200}ms forwards`
      }
    }
  }
}), l0 = Ne("div", {
  "&::-webkit-scrollbar": {
    display: "none"
  },
  "-ms-overflow-style": "none",
  "scrollbar-width": "none",
  transition: `all ${We + 200}ms`
});
function pi(e) {
  e.stopPropagation();
}
function js({
  steps: e,
  onClose: r,
  currentStep: o,
  themeColor: n,
  triggerCloseRef: i,
  fullScreenOnMobile: s,
  size: a = "md"
}) {
  const c = ce(null), [u, p] = J(!0), g = H(
    (d) => {
      d == null || d.stopPropagation(), r && p(!1);
    },
    [r]
  );
  i && (i.current = g), le(() => {
    if (!u && r) {
      const d = setTimeout(r, We * 2);
      return () => clearTimeout(d);
    }
  }, [u, r]);
  const v = ze(() => typeof o == "number" ? o : e.findIndex(({ id: d }) => d == o), [o, e]);
  return Pr(
    /* @__PURE__ */ t(
      ci,
      {
        className: O(
          "fixed top-0 left-0 z-[48] flex h-full w-full",
          "bg-black bg-opacity-20 text-neutral-900 md:px-9",
          s ? "px-0" : "px-2",
          n
        ),
        isOpen: u,
        onClick: g,
        children: /* @__PURE__ */ t(
          fi,
          {
            ref: c,
            onClick: pi,
            isOpen: u,
            className: O(
              "relative m-auto max-w-full md:rounded-cr-lg md:h-auto bg-white px-4 py-11 shadow md:px-12 md:py-12",
              a == "xs" && "w-[343px]",
              a == "sm" && "w-[544px]",
              a == "md" && "w-[736px]",
              a == "lg" && "w-[928px]",
              a == "xl" && "w-[1120px]",
              s ? "h-full" : "rounded-cr-lg"
            ),
            children: e.map((d, m) => /* @__PURE__ */ w(V.Fragment, { children: [
              /* @__PURE__ */ w(
                l0,
                {
                  className: O(
                    "flex flex-col gap-4 overflow-x-hidden overflow-y-hidden",
                    v == m ? "max-h-[80vh]" : "max-h-0 overflow-y-hidden"
                  ),
                  children: [
                    /* @__PURE__ */ w("div", { className: "flex", children: [
                      (d.title || d.onBack) && /* @__PURE__ */ w(
                        "h4",
                        {
                          className: O(
                            "flex items-center gap-2 text-lg md:text-2xl"
                          ),
                          children: [
                            d.onBack && /* @__PURE__ */ t("div", { className: "cursor-pointer", onClick: d.onBack, children: /* @__PURE__ */ t(Y, { name: "dialogBack" }) }),
                            d.title
                          ]
                        }
                      ),
                      r && /* @__PURE__ */ t(
                        "span",
                        {
                          className: "absolute float-right cursor-pointer top-4 right-4 sm:top-8 sm:right-8 opacity-[15%]",
                          onClick: g,
                          children: /* @__PURE__ */ t(Y, { name: "dialogClose" })
                        }
                      )
                    ] }),
                    d.subtitle && /* @__PURE__ */ t("p", { className: "text-body-base", children: d.subtitle })
                  ]
                }
              ),
              /* @__PURE__ */ t(
                l0,
                {
                  className: O(
                    "flex flex-col gap-4 overflow-x-hidden",
                    v == m ? "max-h-[80vh] pt-4" : "max-h-0 overflow-y-hidden"
                  ),
                  children: d.content
                }
              )
            ] }, m))
          }
        )
      }
    ),
    document.body
  );
}
const mi = "w-[160px] h-[160px] max-w-[160px] max-h-[160px]", hi = "w-[192px] h-[192px] max-w-[192px] max-h-[192px]", gi = "relative box-border inline-flex flex-col cursor-pointer overflow-hidden px-4 rounded-2xl bg-cover bg-center bg-no-repeat transition-transform ease-linear bg-purple-500", z0 = ({
  size: e = "large",
  href: r = "#",
  className: o,
  bgImage: n,
  logo: i,
  cashbackText: s
}) => /* @__PURE__ */ w(
  Fe,
  {
    href: r,
    className: O(
      gi,
      e === "small" && mi,
      e === "large" && hi,
      o
    ),
    style: n && {
      backgroundImage: `url(${n.src})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat"
    },
    children: [
      n && /* @__PURE__ */ t("div", { className: "absolute top-0 left-0 z-10 w-full h-full rounded-2xl bg-transparent-dark-50 group-hover:bg-transparent-dark-80" }),
      i && /* @__PURE__ */ t(
        "div",
        {
          className: O(
            "absolute inset-0 m-auto max-w-fit max-h-fit left-4 right-4 z-[15]"
          ),
          children: /* @__PURE__ */ t(ot, { ...i })
        }
      ),
      s && /* @__PURE__ */ t(
        "div",
        {
          className: O(
            "absolute left-4 right-4 text-white text-center z-[15]",
            e === "small" && "bottom-5 text-xs",
            e === "large" && "bottom-8 text-sm"
          ),
          children: s
        }
      )
    ]
  }
);
z0.displayName = "MerchantCard";
const Vs = z0, U0 = (e) => {
  switch (e) {
    case "1:1":
      return "aspect-square";
    case "7:5":
      return "aspect-7/5";
    case "5:7":
      return "aspect-5/7";
    case "16:9":
      return "aspect-video";
    case "9:16":
      return "aspect-9/16";
    default:
      return "aspect-square";
  }
}, bi = function({
  as: r,
  className: o,
  href: n,
  ...i
}) {
  return /* @__PURE__ */ t(
    r || Fe,
    {
      href: n || "",
      ...i,
      className: C(
        "inline-flex w-full h-full flex-col justify-start items-center group",
        o
      )
    }
  );
}, Wt = function({
  children: r,
  className: o,
  ...n
}) {
  return /* @__PURE__ */ t("div", { ...n, className: C("relative w-full", o), children: r });
}, q0 = function({
  imageHoverAnimation: r = !1,
  className: o,
  aspectRatio: n,
  ...i
}) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: C(
        "overflow-hidden rounded-cr-lg justify-center border border-neutral-200 w-full h-full flex",
        U0(n)
      ),
      children: /* @__PURE__ */ t("div", { className: "flex justify-center w-1/2 m-auto h-1/2 ", children: /* @__PURE__ */ t(
        ot,
        {
          ...i,
          className: C(
            "object-contain max-h-full",
            r && "group-hover:scale-125 duration-1000 transaition-transform ease-in-out",
            o
          )
        }
      ) })
    }
  );
}, G0 = function({
  ...r
}) {
  return /* @__PURE__ */ t("div", { className: "absolute left-4 bottom-4", children: /* @__PURE__ */ t(Fn, { size: "sm", hasBorder: !0, ...r }) });
}, Ht = function({
  className: r,
  title: o,
  titleAs: n = "span",
  actionButton: i,
  children: s,
  titleClassName: a,
  ...c
}) {
  return /* @__PURE__ */ w(
    "div",
    {
      ...c,
      className: C(
        "flex gap-1 justify-start items-start w-full p-cr-2 pt-cr-4 flex-col",
        r
      ),
      children: [
        (o || s) && /* @__PURE__ */ w("div", { className: "flex items-center w-full", children: [
          o && /* @__PURE__ */ t(
            n,
            {
              "data-test-id": "card-content-title",
              className: C(
                "text-ellipse line-clamp-1 break-all text-cr-body-lg-700",
                a
              ),
              children: o
            }
          ),
          /* @__PURE__ */ t("div", { className: "flex ml-auto", children: i })
        ] }),
        s
      ]
    }
  );
}, zt = function({
  as: r,
  onClick: o,
  children: n,
  ...i
}) {
  const s = r ?? Vt, a = H(
    (c) => {
      o && (c.stopPropagation(), c.preventDefault(), o(c));
    },
    [o]
  );
  return /* @__PURE__ */ t(s, { variant: "ghost", onClick: a, ...i, children: n });
}, Y0 = function({
  className: r,
  children: o,
  ...n
}) {
  return /* @__PURE__ */ t(
    "div",
    {
      ...n,
      className: C(
        "flex flex-row items-center justify-end gap-1 absolute top-0 w-full px-cr-2 pt-cr-2 pb-cr-1",
        r
      ),
      children: o
    }
  );
}, Ut = function({
  ...r
}) {
  return /* @__PURE__ */ t(kt, { size: "md", ...r });
}, qt = bi;
var N = /* @__PURE__ */ ((e) => (e.search_suggestions = "search_suggestions", e.search = "search", e.product_impression = "product_impression", e.scroll = "scroll", e.generic_click = "generic_click", e.screen_view = "screen_view", e.sign_up = "sign_up", e.sign_in = "sign_in", e.sign_out = "sign_out", e.tab = "tab", e.link_account = "link_account", e.shop_click = "shop_click", e.screen_redirect = "screen_redirect", e.show_popup = "show_popup", e.close_popup = "close_popup", e.withdraw_funds = "withdraw_funds", e.add_to_favourites = "add_to_favourites", e.remove_from_favourites = "remove_from_favourites", e.play_media = "play_media", e.pause_media = "pause_media", e.skip_to_media = "skip-to_media", e.product_action = "product_action", e.copy_coupon = "copy_coupon", e))(N || {}), M = /* @__PURE__ */ ((e) => (e.page_view = "page_view", e.screen_redirect = "screen_redirect", e.click_signup = "click-signup", e.click_signin = "click-signin", e.click_signout = "click-signout", e.click_settings_switch_tab = "click-setting-switch_tab", e.click_settings_link_bank_account = "click-settings-link_bank_account", e.click_settings_link_paypal = "click-settings-link_paypal", e.popup_web_joinnow_show = "popup_web_joinnow_show", e.popup_web_joinnow_close = "popup_web_joinnow_close", e.impression_search_web_search_suggestion = "impression-search_web-search_suggestion", e.search_search_web_search = "search-search_web-search", e.impression_search_web_view_search_results = "impression-search_web-view_search_results", e.scroll_search_web_scroll = "scroll-search_web-scroll", e.impression_web_search_card_render = "impression-web-search-card-render", e.impression_web_search_card_viewed = "impression-web-search-card-viewed", e.click_web_search_card = "click-web-search-card", e.scroll_shophome = "scroll-shophome", e.impression_shophome_carousel = "impression-shophome-carousel", e.click_web_merchant = "click-web-merchant", e.click_shophome_exit = "click-shophome-exit", e.click_merchant_view_switch_tab = "click-merchant-view_switch_tab", e.scroll_merchant_scroll_merchant_page = "scroll-merchant-scroll_merchant_page", e.click_merchant_shop_now = "click-merchant-shop_now", e.click_merchant_add_to_favourites = "click-merchant-add_to_favourites", e.click_merchant_remove_from_favourites = "click-merchant-remove_from_favourites", e.popup_merchant_categories_show = "popup-merchant-categories_show", e.popup_merchant_offers_show = "popup-merchant-offers_show", e.impression_web_banner_render = "impression-web-banner-render", e.impression_web_banner_viewed = "impression-web-banner-viewed", e.click_web_banner = "click-web-banner", e.click_merchant_view_terms = "click-merchant-view_terms", e.popup_notifier_web_promo_show = "popup-notifier_web_promo-show", e.popup_notifier_web_promo_close = "popup-notifier_web_promo-close", e.click_notifier_web_promo_click = "click-notifier_web_promo-click", e.search_myrewards_transaction = "search-myrewards-transaction", e.search_myrewards_withdrawal = "search-myrewards-withdrawal", e.click_myrewards_history = "search-myrewards-history", e.scroll_myrewards = "scorll-myrewards", e.scroll_clickhistory = "scroll_clickhistory", e.search_clickhistory = "search_clickhistory", e.popup_linkaccount_show = "popup-linkaccount-show", e.popup_chooseaccount_show = "popup-chooseaccount-show", e.popup_enteramount_show = "popup-enteramount-show", e.popup_insufficientfund_show = "popup_insufficientfund-show", e.click_web_copy_coupon = "click-web-copy_coupon", e.click_web_withdraw = "click-web-withdraw", e.click_myrewards_show_detail = "click-myrewards-show_detail", e.click_myrewards_transaction_filters = "click-myrewards-transaction_filters", e.click_myrewards_withdrawal_filters = "click-myrewards-withdrawal_filters", e.click_myrewards_switch_tab = "click-myrewards-switch_tab", e.click_mobileapp_load = "click-mobileapp-load", e.click_mobileapp_exit = "click-mobileapp-exit", e.click_mobileapp_switch_tab = "click-mobileapp-switch_tab", e.click_mobileapp_signup = "click-mobileapp-signup", e.click_mobileapp_signin = "click-mobileapp-signin", e.click_mobileapp_signout = "click-mobileapp-signout", e.click_ad_unit = "click-ad-unit", e.dismiss_ad_unit = "dismiss-ad-unit", e.impression_ad_unit_loaded = "impression-web-ad-unit-loaded", e.impression_ad_unit_render = "impression-web-ad-unit-render", e.impression_ad_unit_viewed = "impression-web-ad-unit-viewed", e.video_ad_start = "video-ad-start", e.video_ad_first_quartile = "video-ad-first-quartile", e.video_ad_midpoint = "video-ad-midpoint", e.video_ad_third_quartile = "video-ad-third-quartile", e.video_ad_completed = "video-ad-completed", e.scroll_page = "scroll-page", e.scroll_element = "scroll-element", e.click_generic = "click-generic", e.impression_run_of_market_carousel = "impression-run-of-market-carousel", e.click_run_of_market_carousel = "click-run-of-market-carousel", e.impression_web_carousel = "impression-web-carousel", e.click_web_article = "click-web-article", e.impression_web_category_merchant_list = "impression-web-category-merchant_list", e.click_partner_join = "click_partner_join", e.click_partner_signin = "click_partner_signin", e))(M || {});
M.page_view, N.screen_view, M.screen_redirect, N.screen_redirect, M.impression_search_web_search_suggestion, N.search_suggestions, M.search_search_web_search, N.search, M.impression_search_web_view_search_results, N.product_impression, M.impression_ad_unit_loaded, N.product_impression, M.impression_ad_unit_render, N.product_impression, M.impression_ad_unit_viewed, N.product_impression, M.impression_shophome_carousel, N.product_impression, M.impression_web_search_card_render, N.product_impression, M.impression_web_search_card_viewed, N.product_impression, M.click_web_search_card, N.generic_click, M.click_myrewards_transaction_filters, N.product_impression, M.click_myrewards_withdrawal_filters, N.product_impression, M.scroll_clickhistory, N.scroll, M.scroll_merchant_scroll_merchant_page, N.scroll, M.scroll_myrewards, N.scroll, M.scroll_search_web_scroll, N.scroll, M.scroll_shophome, N.scroll, M.dismiss_ad_unit, N.generic_click, M.click_ad_unit, N.generic_click, M.click_merchant_view_switch_tab, N.tab, M.click_merchant_shop_now, N.shop_click, M.click_myrewards_history, N.screen_redirect, M.search_myrewards_transaction, N.search, M.search_myrewards_withdrawal, N.search, M.search_clickhistory, N.search, M.click_shophome_exit, N.screen_redirect, M.click_signup, N.sign_up, M.click_signin, N.sign_in, M.click_signout, N.sign_out, M.click_settings_switch_tab, N.tab, M.click_settings_link_bank_account, N.link_account, M.click_settings_link_paypal, N.link_account, M.click_web_withdraw, N.withdraw_funds, M.click_merchant_add_to_favourites, N.add_to_favourites, M.click_merchant_remove_from_favourites, N.remove_from_favourites, M.click_myrewards_show_detail, N.product_impression, M.click_myrewards_switch_tab, N.tab, M.click_partner_join, N.screen_redirect, M.click_partner_signin, N.screen_redirect, M.popup_web_joinnow_show, N.show_popup, M.popup_web_joinnow_close, N.close_popup, M.popup_linkaccount_show, N.show_popup, M.popup_chooseaccount_show, N.show_popup, M.popup_enteramount_show, N.show_popup, M.popup_insufficientfund_show, N.show_popup, M.popup_merchant_categories_show, N.show_popup, M.popup_merchant_offers_show, N.show_popup, M.popup_notifier_web_promo_show, N.show_popup, M.popup_notifier_web_promo_close, N.close_popup, M.click_notifier_web_promo_click, N.product_action, M.video_ad_start, N.play_media, M.video_ad_first_quartile, N.play_media, M.video_ad_midpoint, N.play_media, M.video_ad_third_quartile, N.play_media, M.video_ad_completed, N.play_media, M.scroll_page, N.scroll, M.scroll_element, N.scroll, M.click_generic, N.generic_click, M.impression_web_banner_render, N.product_impression, M.impression_web_banner_viewed, N.product_impression, M.click_web_banner, N.generic_click, M.impression_run_of_market_carousel, N.product_impression, M.click_run_of_market_carousel, N.generic_click, M.impression_web_carousel, N.product_impression, M.click_web_article, N.generic_click, M.click_merchant_view_terms, N.generic_click, M.click_web_copy_coupon, N.copy_coupon, M.impression_web_category_merchant_list, N.product_impression;
var at = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c0;
function wi() {
  if (c0)
    return at;
  c0 = 1;
  var e = V, r = Symbol.for("react.element"), o = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(c, u, p) {
    var g, v = {}, d = null, m = null;
    p !== void 0 && (d = "" + p), u.key !== void 0 && (d = "" + u.key), u.ref !== void 0 && (m = u.ref);
    for (g in u)
      n.call(u, g) && !s.hasOwnProperty(g) && (v[g] = u[g]);
    if (c && c.defaultProps)
      for (g in u = c.defaultProps, u)
        v[g] === void 0 && (v[g] = u[g]);
    return { $$typeof: r, type: c, key: d, ref: m, props: v, _owner: i.current };
  }
  return at.Fragment = o, at.jsx = a, at.jsxs = a, at;
}
var st = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var d0;
function vi() {
  return d0 || (d0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = V, r = Symbol.for("react.element"), o = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), c = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), f = Symbol.iterator, h = "@@iterator";
    function b(l) {
      if (l === null || typeof l != "object")
        return null;
      var x = f && l[f] || l[h];
      return typeof x == "function" ? x : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(l) {
      {
        for (var x = arguments.length, F = new Array(x > 1 ? x - 1 : 0), D = 1; D < x; D++)
          F[D - 1] = arguments[D];
        k("error", l, F);
      }
    }
    function k(l, x, F) {
      {
        var D = _.ReactDebugCurrentFrame, ee = D.getStackAddendum();
        ee !== "" && (x += "%s", F = F.concat([ee]));
        var ne = F.map(function(K) {
          return String(K);
        });
        ne.unshift("Warning: " + x), Function.prototype.apply.call(console[l], console, ne);
      }
    }
    var L = !1, A = !1, R = !1, z = !1, I = !1, B;
    B = Symbol.for("react.module.reference");
    function E(l) {
      return !!(typeof l == "string" || typeof l == "function" || l === n || l === s || I || l === i || l === p || l === g || z || l === m || L || A || R || typeof l == "object" && l !== null && (l.$$typeof === d || l.$$typeof === v || l.$$typeof === a || l.$$typeof === c || l.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      l.$$typeof === B || l.getModuleId !== void 0));
    }
    function S(l, x, F) {
      var D = l.displayName;
      if (D)
        return D;
      var ee = x.displayName || x.name || "";
      return ee !== "" ? F + "(" + ee + ")" : F;
    }
    function T(l) {
      return l.displayName || "Context";
    }
    function $(l) {
      if (l == null)
        return null;
      if (typeof l.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof l == "function")
        return l.displayName || l.name || null;
      if (typeof l == "string")
        return l;
      switch (l) {
        case n:
          return "Fragment";
        case o:
          return "Portal";
        case s:
          return "Profiler";
        case i:
          return "StrictMode";
        case p:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case c:
            var x = l;
            return T(x) + ".Consumer";
          case a:
            var F = l;
            return T(F._context) + ".Provider";
          case u:
            return S(l, l.render, "ForwardRef");
          case v:
            var D = l.displayName || null;
            return D !== null ? D : $(l.type) || "Memo";
          case d: {
            var ee = l, ne = ee._payload, K = ee._init;
            try {
              return $(K(ne));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var j = Object.assign, te = 0, U, me, he, ie, de, se, pe;
    function re() {
    }
    re.__reactDisabledLog = !0;
    function Te() {
      {
        if (te === 0) {
          U = console.log, me = console.info, he = console.warn, ie = console.error, de = console.group, se = console.groupCollapsed, pe = console.groupEnd;
          var l = {
            configurable: !0,
            enumerable: !0,
            value: re,
            writable: !0
          };
          Object.defineProperties(console, {
            info: l,
            log: l,
            warn: l,
            error: l,
            group: l,
            groupCollapsed: l,
            groupEnd: l
          });
        }
        te++;
      }
    }
    function Me() {
      {
        if (te--, te === 0) {
          var l = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: j({}, l, {
              value: U
            }),
            info: j({}, l, {
              value: me
            }),
            warn: j({}, l, {
              value: he
            }),
            error: j({}, l, {
              value: ie
            }),
            group: j({}, l, {
              value: de
            }),
            groupCollapsed: j({}, l, {
              value: se
            }),
            groupEnd: j({}, l, {
              value: pe
            })
          });
        }
        te < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ze = _.ReactCurrentDispatcher, Re;
    function Pe(l, x, F) {
      {
        if (Re === void 0)
          try {
            throw Error();
          } catch (ee) {
            var D = ee.stack.trim().match(/\n( *(at )?)/);
            Re = D && D[1] || "";
          }
        return `
` + Re + l;
      }
    }
    var qe = !1, Oe;
    {
      var Nt = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new Nt();
    }
    function De(l, x) {
      if (!l || qe)
        return "";
      {
        var F = Oe.get(l);
        if (F !== void 0)
          return F;
      }
      var D;
      qe = !0;
      var ee = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ne;
      ne = Ze.current, Ze.current = null, Te();
      try {
        if (x) {
          var K = function() {
            throw Error();
          };
          if (Object.defineProperty(K.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(K, []);
            } catch (Ee) {
              D = Ee;
            }
            Reflect.construct(l, [], K);
          } else {
            try {
              K.call();
            } catch (Ee) {
              D = Ee;
            }
            l.call(K.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ee) {
            D = Ee;
          }
          l();
        }
      } catch (Ee) {
        if (Ee && D && typeof Ee.stack == "string") {
          for (var q = Ee.stack.split(`
`), be = D.stack.split(`
`), ue = q.length - 1, fe = be.length - 1; ue >= 1 && fe >= 0 && q[ue] !== be[fe]; )
            fe--;
          for (; ue >= 1 && fe >= 0; ue--, fe--)
            if (q[ue] !== be[fe]) {
              if (ue !== 1 || fe !== 1)
                do
                  if (ue--, fe--, fe < 0 || q[ue] !== be[fe]) {
                    var Ce = `
` + q[ue].replace(" at new ", " at ");
                    return l.displayName && Ce.includes("<anonymous>") && (Ce = Ce.replace("<anonymous>", l.displayName)), typeof l == "function" && Oe.set(l, Ce), Ce;
                  }
                while (ue >= 1 && fe >= 0);
              break;
            }
        }
      } finally {
        qe = !1, Ze.current = ne, Me(), Error.prepareStackTrace = ee;
      }
      var Je = l ? l.displayName || l.name : "", t0 = Je ? Pe(Je) : "";
      return typeof l == "function" && Oe.set(l, t0), t0;
    }
    function ft(l, x, F) {
      return De(l, !1);
    }
    function $e(l) {
      var x = l.prototype;
      return !!(x && x.isReactComponent);
    }
    function Ge(l, x, F) {
      if (l == null)
        return "";
      if (typeof l == "function")
        return De(l, $e(l));
      if (typeof l == "string")
        return Pe(l);
      switch (l) {
        case p:
          return Pe("Suspense");
        case g:
          return Pe("SuspenseList");
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case u:
            return ft(l.render);
          case v:
            return Ge(l.type, x, F);
          case d: {
            var D = l, ee = D._payload, ne = D._init;
            try {
              return Ge(ne(ee), x, F);
            } catch {
            }
          }
        }
      return "";
    }
    var Ie = Object.prototype.hasOwnProperty, Le = {}, Ye = _.ReactDebugCurrentFrame;
    function Xe(l) {
      if (l) {
        var x = l._owner, F = Ge(l.type, l._source, x ? x.type : null);
        Ye.setExtraStackFrame(F);
      } else
        Ye.setExtraStackFrame(null);
    }
    function pt(l, x, F, D, ee) {
      {
        var ne = Function.call.bind(Ie);
        for (var K in l)
          if (ne(l, K)) {
            var q = void 0;
            try {
              if (typeof l[K] != "function") {
                var be = Error((D || "React class") + ": " + F + " type `" + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[K] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw be.name = "Invariant Violation", be;
              }
              q = l[K](x, K, D, F, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ue) {
              q = ue;
            }
            q && !(q instanceof Error) && (Xe(ee), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", D || "React class", F, K, typeof q), Xe(null)), q instanceof Error && !(q.message in Le) && (Le[q.message] = !0, Xe(ee), y("Failed %s type: %s", F, q.message), Xe(null));
          }
      }
    }
    var mt = Array.isArray;
    function ge(l) {
      return mt(l);
    }
    function Ae(l) {
      {
        var x = typeof Symbol == "function" && Symbol.toStringTag, F = x && l[Symbol.toStringTag] || l.constructor.name || "Object";
        return F;
      }
    }
    function Ke(l) {
      try {
        return W(l), !1;
      } catch {
        return !0;
      }
    }
    function W(l) {
      return "" + l;
    }
    function Q(l) {
      if (Ke(l))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ae(l)), W(l);
    }
    var Z = _.ReactCurrentOwner, oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, ve, X;
    X = {};
    function P(l) {
      if (Ie.call(l, "ref")) {
        var x = Object.getOwnPropertyDescriptor(l, "ref").get;
        if (x && x.isReactWarning)
          return !1;
      }
      return l.ref !== void 0;
    }
    function xe(l) {
      if (Ie.call(l, "key")) {
        var x = Object.getOwnPropertyDescriptor(l, "key").get;
        if (x && x.isReactWarning)
          return !1;
      }
      return l.key !== void 0;
    }
    function it(l, x) {
      if (typeof l.ref == "string" && Z.current && x && Z.current.stateNode !== x) {
        var F = $(Z.current.type);
        X[F] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', $(Z.current.type), l.ref), X[F] = !0);
      }
    }
    function ht(l, x) {
      {
        var F = function() {
          ke || (ke = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", x));
        };
        F.isReactWarning = !0, Object.defineProperty(l, "key", {
          get: F,
          configurable: !0
        });
      }
    }
    function pr(l, x) {
      {
        var F = function() {
          ve || (ve = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", x));
        };
        F.isReactWarning = !0, Object.defineProperty(l, "ref", {
          get: F,
          configurable: !0
        });
      }
    }
    var mr = function(l, x, F, D, ee, ne, K) {
      var q = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: l,
        key: x,
        ref: F,
        props: K,
        // Record the component responsible for creating this element.
        _owner: ne
      };
      return q._store = {}, Object.defineProperty(q._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(q, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: D
      }), Object.defineProperty(q, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ee
      }), Object.freeze && (Object.freeze(q.props), Object.freeze(q)), q;
    };
    function hr(l, x, F, D, ee) {
      {
        var ne, K = {}, q = null, be = null;
        F !== void 0 && (Q(F), q = "" + F), xe(x) && (Q(x.key), q = "" + x.key), P(x) && (be = x.ref, it(x, ee));
        for (ne in x)
          Ie.call(x, ne) && !oe.hasOwnProperty(ne) && (K[ne] = x[ne]);
        if (l && l.defaultProps) {
          var ue = l.defaultProps;
          for (ne in ue)
            K[ne] === void 0 && (K[ne] = ue[ne]);
        }
        if (q || be) {
          var fe = typeof l == "function" ? l.displayName || l.name || "Unknown" : l;
          q && ht(K, fe), be && pr(K, fe);
        }
        return mr(l, q, be, ee, D, Z.current, K);
      }
    }
    var Mt = _.ReactCurrentOwner, Yt = _.ReactDebugCurrentFrame;
    function Qe(l) {
      if (l) {
        var x = l._owner, F = Ge(l.type, l._source, x ? x.type : null);
        Yt.setExtraStackFrame(F);
      } else
        Yt.setExtraStackFrame(null);
    }
    var Et;
    Et = !1;
    function It(l) {
      return typeof l == "object" && l !== null && l.$$typeof === r;
    }
    function Xt() {
      {
        if (Mt.current) {
          var l = $(Mt.current.type);
          if (l)
            return `

Check the render method of \`` + l + "`.";
        }
        return "";
      }
    }
    function gr(l) {
      {
        if (l !== void 0) {
          var x = l.fileName.replace(/^.*[\\\/]/, ""), F = l.lineNumber;
          return `

Check your code at ` + x + ":" + F + ".";
        }
        return "";
      }
    }
    var Kt = {};
    function br(l) {
      {
        var x = Xt();
        if (!x) {
          var F = typeof l == "string" ? l : l.displayName || l.name;
          F && (x = `

Check the top-level render call using <` + F + ">.");
        }
        return x;
      }
    }
    function Qt(l, x) {
      {
        if (!l._store || l._store.validated || l.key != null)
          return;
        l._store.validated = !0;
        var F = br(x);
        if (Kt[F])
          return;
        Kt[F] = !0;
        var D = "";
        l && l._owner && l._owner !== Mt.current && (D = " It was passed a child from " + $(l._owner.type) + "."), Qe(l), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', F, D), Qe(null);
      }
    }
    function Jt(l, x) {
      {
        if (typeof l != "object")
          return;
        if (ge(l))
          for (var F = 0; F < l.length; F++) {
            var D = l[F];
            It(D) && Qt(D, x);
          }
        else if (It(l))
          l._store && (l._store.validated = !0);
        else if (l) {
          var ee = b(l);
          if (typeof ee == "function" && ee !== l.entries)
            for (var ne = ee.call(l), K; !(K = ne.next()).done; )
              It(K.value) && Qt(K.value, x);
        }
      }
    }
    function wr(l) {
      {
        var x = l.type;
        if (x == null || typeof x == "string")
          return;
        var F;
        if (typeof x == "function")
          F = x.propTypes;
        else if (typeof x == "object" && (x.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        x.$$typeof === v))
          F = x.propTypes;
        else
          return;
        if (F) {
          var D = $(x);
          pt(F, l.props, "prop", D, l);
        } else if (x.PropTypes !== void 0 && !Et) {
          Et = !0;
          var ee = $(x);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ee || "Unknown");
        }
        typeof x.getDefaultProps == "function" && !x.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function vr(l) {
      {
        for (var x = Object.keys(l.props), F = 0; F < x.length; F++) {
          var D = x[F];
          if (D !== "children" && D !== "key") {
            Qe(l), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", D), Qe(null);
            break;
          }
        }
        l.ref !== null && (Qe(l), y("Invalid attribute `ref` supplied to `React.Fragment`."), Qe(null));
      }
    }
    function e0(l, x, F, D, ee, ne) {
      {
        var K = E(l);
        if (!K) {
          var q = "";
          (l === void 0 || typeof l == "object" && l !== null && Object.keys(l).length === 0) && (q += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var be = gr(ee);
          be ? q += be : q += Xt();
          var ue;
          l === null ? ue = "null" : ge(l) ? ue = "array" : l !== void 0 && l.$$typeof === r ? (ue = "<" + ($(l.type) || "Unknown") + " />", q = " Did you accidentally export a JSX literal instead of a component?") : ue = typeof l, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ue, q);
        }
        var fe = hr(l, x, F, ee, ne);
        if (fe == null)
          return fe;
        if (K) {
          var Ce = x.children;
          if (Ce !== void 0)
            if (D)
              if (ge(Ce)) {
                for (var Je = 0; Je < Ce.length; Je++)
                  Jt(Ce[Je], l);
                Object.freeze && Object.freeze(Ce);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Jt(Ce, l);
        }
        return l === n ? vr(fe) : wr(fe), fe;
      }
    }
    function xr(l, x, F) {
      return e0(l, x, F, !0);
    }
    function Cr(l, x, F) {
      return e0(l, x, F, !1);
    }
    var yr = Cr, kr = xr;
    st.Fragment = n, st.jsx = yr, st.jsxs = kr;
  }()), st;
}
process.env.NODE_ENV === "production" ? wi() : vi();
function Zt(e) {
  const r = ce(e);
  return le(() => {
    r.current = e;
  }), ze(() => (...o) => {
    var n;
    return (n = r.current) == null ? void 0 : n.call(r, ...o);
  }, []);
}
var xi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, u0 = { exports: {} };
(function(e, r) {
  (function(o, n) {
    var i = "1.0.37", s = "", a = "?", c = "function", u = "undefined", p = "object", g = "string", v = "major", d = "model", m = "name", f = "type", h = "vendor", b = "version", _ = "architecture", y = "console", k = "mobile", L = "tablet", A = "smarttv", R = "wearable", z = "embedded", I = 500, B = "Amazon", E = "Apple", S = "ASUS", T = "BlackBerry", $ = "Browser", j = "Chrome", te = "Edge", U = "Firefox", me = "Google", he = "Huawei", ie = "LG", de = "Microsoft", se = "Motorola", pe = "Opera", re = "Samsung", Te = "Sharp", Me = "Sony", Ze = "Xiaomi", Re = "Zebra", Pe = "Facebook", qe = "Chromium OS", Oe = "Mac OS", Nt = function(W, Q) {
      var Z = {};
      for (var oe in W)
        Q[oe] && Q[oe].length % 2 === 0 ? Z[oe] = Q[oe].concat(W[oe]) : Z[oe] = W[oe];
      return Z;
    }, De = function(W) {
      for (var Q = {}, Z = 0; Z < W.length; Z++)
        Q[W[Z].toUpperCase()] = W[Z];
      return Q;
    }, ft = function(W, Q) {
      return typeof W === g ? $e(Q).indexOf($e(W)) !== -1 : !1;
    }, $e = function(W) {
      return W.toLowerCase();
    }, Ge = function(W) {
      return typeof W === g ? W.replace(/[^\d\.]/g, s).split(".")[0] : n;
    }, Ie = function(W, Q) {
      if (typeof W === g)
        return W = W.replace(/^\s\s*/, s), typeof Q === u ? W : W.substring(0, I);
    }, Le = function(W, Q) {
      for (var Z = 0, oe, ke, ve, X, P, xe; Z < Q.length && !P; ) {
        var it = Q[Z], ht = Q[Z + 1];
        for (oe = ke = 0; oe < it.length && !P && it[oe]; )
          if (P = it[oe++].exec(W), P)
            for (ve = 0; ve < ht.length; ve++)
              xe = P[++ke], X = ht[ve], typeof X === p && X.length > 0 ? X.length === 2 ? typeof X[1] == c ? this[X[0]] = X[1].call(this, xe) : this[X[0]] = X[1] : X.length === 3 ? typeof X[1] === c && !(X[1].exec && X[1].test) ? this[X[0]] = xe ? X[1].call(this, xe, X[2]) : n : this[X[0]] = xe ? xe.replace(X[1], X[2]) : n : X.length === 4 && (this[X[0]] = xe ? X[3].call(this, xe.replace(X[1], X[2])) : n) : this[X] = xe || n;
        Z += 2;
      }
    }, Ye = function(W, Q) {
      for (var Z in Q)
        if (typeof Q[Z] === p && Q[Z].length > 0) {
          for (var oe = 0; oe < Q[Z].length; oe++)
            if (ft(Q[Z][oe], W))
              return Z === a ? n : Z;
        } else if (ft(Q[Z], W))
          return Z === a ? n : Z;
      return W;
    }, Xe = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, pt = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      "8.1": "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, mt = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [b, [m, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [b, [m, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [m, b],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [b, [m, pe + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [b, [m, pe]],
        [
          // Mixed
          /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
          // Baidu
        ],
        [b, [m, "Baidu"]],
        [
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
          /(heytap|ovi)browser\/([\d\.]+)/i,
          // Heytap/Ovi
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [m, b],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [b, [m, "UC" + $]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          // WeChat Desktop for Windows Built-in Browser
          /\bqbcore\/([\w\.]+).+microm/i,
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [b, [m, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [b, [m, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [b, [m, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
          // Yandex
        ],
        [b, [m, "Yandex"]],
        [
          /slbrowser\/([\w\.]+)/i
          // Smart Lenovo Browser
        ],
        [b, [m, "Smart Lenovo " + $]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[m, /(.+)/, "$1 Secure " + $], b],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [b, [m, U + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [b, [m, pe + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [b, [m, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [b, [m, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [b, [m, pe + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [b, [m, "MIUI " + $]],
        [
          /fxios\/([-\w\.]+)/i
          // Firefox for iOS
        ],
        [b, [m, U]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
          // 360
        ],
        [[m, "360 " + $]],
        [
          /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
        ],
        [[m, /(.+)/, "$1 " + $], b],
        [
          // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
          /samsungbrowser\/([\w\.]+)/i
          // Samsung Internet
        ],
        [b, [m, re + " Internet"]],
        [
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[m, /_/g, " "], b],
        [
          /metasr[\/ ]?([\d\.]+)/i
          // Sogou Explorer
        ],
        [b, [m, "Sogou Explorer"]],
        [
          /(sogou)mo\w+\/([\d\.]+)/i
          // Sogou Mobile
        ],
        [[m, "Sogou Mobile"], b],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
          // QQBrowser/2345 Browser
        ],
        [m, b],
        [
          /(lbbrowser)/i,
          // LieBao Browser
          /\[(linkedin)app\]/i
          // LinkedIn App for iOS & Android
        ],
        [m],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[m, Pe], b],
        [
          /(Klarna)\/([\w\.]+)/i,
          // Klarna Shopping Browser for iOS & Android
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          // Kakao App
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          // Naver InApp
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(alipay)client\/([\w\.]+)/i,
          // Alipay
          /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram/Snapchat
        ],
        [m, b],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [b, [m, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
          // TikTok
        ],
        [b, [m, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [b, [m, j + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[m, j + " WebView"], b],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [b, [m, "Android " + $]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [m, b],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [b, [m, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [b, m],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [m, [b, Ye, Xe]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [m, b],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[m, "Netscape"], b],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [b, [m, U + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
          /(links) \(([\w\.]+)/i,
          // Links
          /panasonic;(viera)/i
          // Panasonic Viera
        ],
        [m, b],
        [
          /(cobalt)\/([\w\.]+)/i
          // Cobalt
        ],
        [m, [b, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
          // AMD64 (x64)
        ],
        [[_, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[_, $e]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32 (x86)
        ],
        [[_, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
          // ARM64
        ],
        [[_, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[_, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows (ce|mobile); ppc;/i
        ],
        [[_, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
          // PowerPC
        ],
        [[_, /ower/, s, $e]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[_, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[_, $e]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [d, [h, re], [f, L]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [d, [h, re], [f, k]],
        [
          // Apple
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
          // iPod/iPhone
        ],
        [d, [h, E], [f, k]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [d, [h, E], [f, L]],
        [
          /(macintosh);/i
        ],
        [d, [h, E]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [d, [h, Te], [f, k]],
        [
          // Huawei
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [d, [h, he], [f, L]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [d, [h, he], [f, k]],
        [
          // Xiaomi
          /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
          // Xiaomi Redmi 'numeric' models
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
          // Xiaomi Mi
        ],
        [[d, /_/g, " "], [h, Ze], [f, k]],
        [
          /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
          // Redmi Pad
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[d, /_/g, " "], [h, Ze], [f, L]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [d, [h, "OPPO"], [f, k]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [d, [h, "Vivo"], [f, k]],
        [
          // Realme
          /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
        ],
        [d, [h, "Realme"], [f, k]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [d, [h, se], [f, k]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [d, [h, se], [f, L]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [d, [h, ie], [f, L]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [d, [h, ie], [f, k]],
        [
          // Lenovo
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [d, [h, "Lenovo"], [f, L]],
        [
          // Nokia
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[d, /_/g, " "], [h, "Nokia"], [f, k]],
        [
          // Google
          /(pixel c)\b/i
          // Google Pixel C
        ],
        [d, [h, me], [f, L]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [d, [h, me], [f, k]],
        [
          // Sony
          /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [d, [h, Me], [f, k]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[d, "Xperia Tablet"], [h, Me], [f, L]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [d, [h, "OnePlus"], [f, k]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
          // Kindle Fire without Silk / Echo Show
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [d, [h, B], [f, L]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[d, /(.+)/g, "Fire Phone $1"], [h, B], [f, k]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [d, h, [f, L]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [d, [h, T], [f, k]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [d, [h, S], [f, L]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [d, [h, S], [f, k]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [d, [h, "HTC"], [f, L]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [h, [d, /_/g, " "], [f, k]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [d, [h, "Acer"], [f, L]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [d, [h, "Meizu"], [f, k]],
        [
          // Ulefone
          /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
        ],
        [d, [h, "Ulefone"], [f, k]],
        [
          // MIXED
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i,
          // Asus
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w]+)/i,
          // Lenovo
          /(jolla)/i,
          // Jolla
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [h, d, [f, k]],
        [
          /(kobo)\s(ereader|touch)/i,
          // Kobo
          /(archos) (gamepad2?)/i,
          // Archos
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [h, d, [f, L]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [d, [h, de], [f, L]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [d, [h, "Fairphone"], [f, k]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [d, [h, "AT&T"], [f, k]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [d, [h, "Siemens"], [f, k]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [d, [h, "RCA"], [f, L]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [d, [h, "Dell"], [f, L]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [d, [h, "Verizon"], [f, L]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [d, [h, "Barnes & Noble"], [f, L]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [d, [h, "NuVision"], [f, L]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [d, [h, "ZTE"], [f, L]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [d, [h, "ZTE"], [f, k]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [d, [h, "Swiss"], [f, k]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [d, [h, "Swiss"], [f, L]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [d, [h, "Zeki"], [f, L]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[h, "Dragon Touch"], d, [f, L]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [d, [h, "Insignia"], [f, L]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [d, [h, "NextBook"], [f, L]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[h, "Voice"], d, [f, k]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[h, "LvTel"], d, [f, k]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [d, [h, "Essential"], [f, k]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [d, [h, "Envizen"], [f, L]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [d, [h, "MachSpeed"], [f, L]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [d, [h, "Rotor"], [f, L]],
        [
          /(shield[\w ]+) b/i
          // Nvidia Shield Tablets
        ],
        [d, [h, "Nvidia"], [f, L]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [h, d, [f, k]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[d, /\./g, " "], [h, de], [f, k]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [d, [h, Re], [f, L]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [d, [h, Re], [f, k]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [h, [f, A]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[d, /^/, "SmartTV"], [h, re], [f, A]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[h, ie], [f, A]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [h, [d, E + " TV"], [f, A]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[d, j + "cast"], [h, me], [f, A]],
        [
          /droid.+aft(\w+)( bui|\))/i
          // Fire TV
        ],
        [d, [h, B], [f, A]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
          // Sharp
        ],
        [d, [h, Te], [f, A]],
        [
          /(bravia[\w ]+)( bui|\))/i
          // Sony
        ],
        [d, [h, Me], [f, A]],
        [
          /(mitv-\w{5}) bui/i
          // Xiaomi
        ],
        [d, [h, Ze], [f, A]],
        [
          /Hbbtv.*(technisat) (.*);/i
          // TechniSAT
        ],
        [h, d, [f, A]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[h, Ie], [d, Ie], [f, A]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          // SmartTV from Unidentified Vendors
        ],
        [[f, A]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [h, d, [f, y]],
        [
          /droid.+; (shield) bui/i
          // Nvidia
        ],
        [d, [h, "Nvidia"], [f, y]],
        [
          /(playstation [345portablevi]+)/i
          // Playstation
        ],
        [d, [h, Me], [f, y]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [d, [h, de], [f, y]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /((pebble))app/i
          // Pebble
        ],
        [h, d, [f, R]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
          // Apple Watch
        ],
        [d, [h, E], [f, R]],
        [
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [d, [h, me], [f, R]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [d, [h, Re], [f, R]],
        [
          /(quest( 2| pro)?)/i
          // Oculus Quest
        ],
        [d, [h, Pe], [f, R]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [h, [f, z]],
        [
          /(aeobc)\b/i
          // Echo Dot
        ],
        [d, [h, B], [f, z]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [d, [f, k]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [d, [f, L]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[f, L]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[f, k]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
          // Generic Android Device
        ],
        [d, [h, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [b, [m, te + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [b, [m, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          // iCab
          /\b(libweb)/i
        ],
        [m, b],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [b, m]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [m, b],
        [
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
          // Windows Phone
        ],
        [m, [b, Ye, pt]],
        [
          /windows nt 6\.2; (arm)/i,
          // Windows RT
          /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
          /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[b, Ye, pt], [m, "Windows"]],
        [
          // iOS/macOS
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[b, /_/g, "."], [m, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[m, Oe], [b, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
          // Android-x86/HarmonyOS
        ],
        [b, m],
        [
          // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          // Tizen/KaiOS
          /\((series40);/i
          // Series 40
        ],
        [m, b],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [b, [m, T]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [b, [m, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [b, [m, U + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [b, [m, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
          // watchOS
        ],
        [b, [m, "watchOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [b, [m, j + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
          // Chromium OS
        ],
        [[m, qe], b],
        [
          // Smart TVs
          /panasonic;(viera)/i,
          // Panasonic Viera
          /(netrange)mmh/i,
          // Netrange
          /(nettv)\/(\d+\.[\w\.]+)/i,
          // NetTV
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux) ?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [m, b],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[m, "Solaris"], b],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [m, b]
      ]
    }, ge = function(W, Q) {
      if (typeof W === p && (Q = W, W = n), !(this instanceof ge))
        return new ge(W, Q).getResult();
      var Z = typeof o !== u && o.navigator ? o.navigator : n, oe = W || (Z && Z.userAgent ? Z.userAgent : s), ke = Z && Z.userAgentData ? Z.userAgentData : n, ve = Q ? Nt(mt, Q) : mt, X = Z && Z.userAgent == oe;
      return this.getBrowser = function() {
        var P = {};
        return P[m] = n, P[b] = n, Le.call(P, oe, ve.browser), P[v] = Ge(P[b]), X && Z && Z.brave && typeof Z.brave.isBrave == c && (P[m] = "Brave"), P;
      }, this.getCPU = function() {
        var P = {};
        return P[_] = n, Le.call(P, oe, ve.cpu), P;
      }, this.getDevice = function() {
        var P = {};
        return P[h] = n, P[d] = n, P[f] = n, Le.call(P, oe, ve.device), X && !P[f] && ke && ke.mobile && (P[f] = k), X && P[d] == "Macintosh" && Z && typeof Z.standalone !== u && Z.maxTouchPoints && Z.maxTouchPoints > 2 && (P[d] = "iPad", P[f] = L), P;
      }, this.getEngine = function() {
        var P = {};
        return P[m] = n, P[b] = n, Le.call(P, oe, ve.engine), P;
      }, this.getOS = function() {
        var P = {};
        return P[m] = n, P[b] = n, Le.call(P, oe, ve.os), X && !P[m] && ke && ke.platform != "Unknown" && (P[m] = ke.platform.replace(/chrome os/i, qe).replace(/macos/i, Oe)), P;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return oe;
      }, this.setUA = function(P) {
        return oe = typeof P === g && P.length > I ? Ie(P, I) : P, this;
      }, this.setUA(oe), this;
    };
    ge.VERSION = i, ge.BROWSER = De([m, b, v]), ge.CPU = De([_]), ge.DEVICE = De([d, h, f, y, k, A, L, R, z]), ge.ENGINE = ge.OS = De([m, b]), e.exports && (r = e.exports = ge), r.UAParser = ge;
    var Ae = typeof o !== u && (o.jQuery || o.Zepto);
    if (Ae && !Ae.ua) {
      var Ke = new ge();
      Ae.ua = Ke.getResult(), Ae.ua.get = function() {
        return Ke.getUA();
      }, Ae.ua.set = function(W) {
        Ke.setUA(W);
        var Q = Ke.getResult();
        for (var Z in Q)
          Ae.ua[Z] = Q[Z];
      };
    }
  })(typeof window == "object" ? window : xi);
})(u0, u0.exports);
function Ci() {
  const e = typeof window < "u", r = H(() => {
    const i = e ? window.innerWidth : null, s = e ? window.innerHeight : null;
    return {
      width: i,
      height: s
    };
  }, [e]), [o, n] = J({ height: 100, width: 100 });
  return le(() => {
    function i() {
      n(r());
    }
    if (e)
      return n(r()), window.addEventListener("resize", i), () => window.removeEventListener("resize", i);
  }, [r, e]), o;
}
function yi(e, r) {
  typeof e == "function" ? e(r) : e != null && (e.current = r);
}
function ki(...e) {
  return (r) => e.forEach((o) => yi(o, r));
}
function _i(...e) {
  return V.useCallback(ki(...e), e);
}
function X0(e) {
  var r, o, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var i = e.length;
      for (r = 0; r < i; r++)
        e[r] && (o = X0(e[r])) && (n && (n += " "), n += o);
    } else
      for (o in e)
        e[o] && (n && (n += " "), n += o);
  return n;
}
function Fi() {
  for (var e, r, o = 0, n = "", i = arguments.length; o < i; o++)
    (e = arguments[o]) && (r = X0(e)) && (n && (n += " "), n += r);
  return n;
}
function Si() {
  for (var e = 0, r, o, n = ""; e < arguments.length; )
    (r = arguments[e++]) && (o = K0(r)) && (n && (n += " "), n += o);
  return n;
}
function K0(e) {
  if (typeof e == "string")
    return e;
  for (var r, o = "", n = 0; n < e.length; n++)
    e[n] && (r = K0(e[n])) && (o && (o += " "), o += r);
  return o;
}
var Gt = "-";
function Ni(e) {
  var r = Ei(e), o = e.conflictingClassGroups, n = e.conflictingClassGroupModifiers, i = n === void 0 ? {} : n;
  function s(c) {
    var u = c.split(Gt);
    return u[0] === "" && u.length !== 1 && u.shift(), Q0(u, r) || Mi(c);
  }
  function a(c, u) {
    var p = o[c] || [];
    return u && i[c] ? [].concat(p, i[c]) : p;
  }
  return {
    getClassGroupId: s,
    getConflictingClassGroupIds: a
  };
}
function Q0(e, r) {
  var o;
  if (e.length === 0)
    return r.classGroupId;
  var n = e[0], i = r.nextPart.get(n), s = i ? Q0(e.slice(1), i) : void 0;
  if (s)
    return s;
  if (r.validators.length !== 0) {
    var a = e.join(Gt);
    return (o = r.validators.find(function(c) {
      var u = c.validator;
      return u(a);
    })) == null ? void 0 : o.classGroupId;
  }
}
var f0 = /^\[(.+)\]$/;
function Mi(e) {
  if (f0.test(e)) {
    var r = f0.exec(e)[1], o = r == null ? void 0 : r.substring(0, r.indexOf(":"));
    if (o)
      return "arbitrary.." + o;
  }
}
function Ei(e) {
  var r = e.theme, o = e.prefix, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, i = Li(Object.entries(e.classGroups), o);
  return i.forEach(function(s) {
    var a = s[0], c = s[1];
    Rt(c, n, a, r);
  }), n;
}
function Rt(e, r, o, n) {
  e.forEach(function(i) {
    if (typeof i == "string") {
      var s = i === "" ? r : p0(r, i);
      s.classGroupId = o;
      return;
    }
    if (typeof i == "function") {
      if (Ii(i)) {
        Rt(i(n), r, o, n);
        return;
      }
      r.validators.push({
        validator: i,
        classGroupId: o
      });
      return;
    }
    Object.entries(i).forEach(function(a) {
      var c = a[0], u = a[1];
      Rt(u, p0(r, c), o, n);
    });
  });
}
function p0(e, r) {
  var o = e;
  return r.split(Gt).forEach(function(n) {
    o.nextPart.has(n) || o.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), o = o.nextPart.get(n);
  }), o;
}
function Ii(e) {
  return e.isThemeGetter;
}
function Li(e, r) {
  return r ? e.map(function(o) {
    var n = o[0], i = o[1], s = i.map(function(a) {
      return typeof a == "string" ? r + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(function(c) {
        var u = c[0], p = c[1];
        return [r + u, p];
      })) : a;
    });
    return [n, s];
  }) : e;
}
function Ai(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var r = 0, o = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  function i(s, a) {
    o.set(s, a), r++, r > e && (r = 0, n = o, o = /* @__PURE__ */ new Map());
  }
  return {
    get: function(a) {
      var c = o.get(a);
      if (c !== void 0)
        return c;
      if ((c = n.get(a)) !== void 0)
        return i(a, c), c;
    },
    set: function(a, c) {
      o.has(a) ? o.set(a, c) : i(a, c);
    }
  };
}
var J0 = "!";
function Bi(e) {
  var r = e.separator || ":", o = r.length === 1, n = r[0], i = r.length;
  return function(a) {
    for (var c = [], u = 0, p = 0, g, v = 0; v < a.length; v++) {
      var d = a[v];
      if (u === 0) {
        if (d === n && (o || a.slice(v, v + i) === r)) {
          c.push(a.slice(p, v)), p = v + i;
          continue;
        }
        if (d === "/") {
          g = v;
          continue;
        }
      }
      d === "[" ? u++ : d === "]" && u--;
    }
    var m = c.length === 0 ? a : a.substring(p), f = m.startsWith(J0), h = f ? m.substring(1) : m, b = g && g > p ? g - p : void 0;
    return {
      modifiers: c,
      hasImportantModifier: f,
      baseClassName: h,
      maybePostfixModifierPosition: b
    };
  };
}
function Ti(e) {
  if (e.length <= 1)
    return e;
  var r = [], o = [];
  return e.forEach(function(n) {
    var i = n[0] === "[";
    i ? (r.push.apply(r, o.sort().concat([n])), o = []) : o.push(n);
  }), r.push.apply(r, o.sort()), r;
}
function Zi(e) {
  return {
    cache: Ai(e.cacheSize),
    splitModifiers: Bi(e),
    ...Ni(e)
  };
}
var Ri = /\s+/;
function Pi(e, r) {
  var o = r.splitModifiers, n = r.getClassGroupId, i = r.getConflictingClassGroupIds, s = /* @__PURE__ */ new Set();
  return e.trim().split(Ri).map(function(a) {
    var c = o(a), u = c.modifiers, p = c.hasImportantModifier, g = c.baseClassName, v = c.maybePostfixModifierPosition, d = n(v ? g.substring(0, v) : g), m = !!v;
    if (!d) {
      if (!v)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      if (d = n(g), !d)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      m = !1;
    }
    var f = Ti(u).join(":"), h = p ? f + J0 : f;
    return {
      isTailwindClass: !0,
      modifierId: h,
      classGroupId: d,
      originalClassName: a,
      hasPostfixModifier: m
    };
  }).reverse().filter(function(a) {
    if (!a.isTailwindClass)
      return !0;
    var c = a.modifierId, u = a.classGroupId, p = a.hasPostfixModifier, g = c + u;
    return s.has(g) ? !1 : (s.add(g), i(u, p).forEach(function(v) {
      return s.add(c + v);
    }), !0);
  }).reverse().map(function(a) {
    return a.originalClassName;
  }).join(" ");
}
function Oi() {
  for (var e = arguments.length, r = new Array(e), o = 0; o < e; o++)
    r[o] = arguments[o];
  var n, i, s, a = c;
  function c(p) {
    var g = r[0], v = r.slice(1), d = v.reduce(function(m, f) {
      return f(m);
    }, g());
    return n = Zi(d), i = n.cache.get, s = n.cache.set, a = u, u(p);
  }
  function u(p) {
    var g = i(p);
    if (g)
      return g;
    var v = Pi(p, n);
    return s(p, v), v;
  }
  return function() {
    return a(Si.apply(null, arguments));
  };
}
function ae(e) {
  var r = function(n) {
    return n[e] || [];
  };
  return r.isThemeGetter = !0, r;
}
var er = /^\[(?:([a-z-]+):)?(.+)\]$/i, Di = /^\d+\/\d+$/, $i = /* @__PURE__ */ new Set(["px", "full", "screen"]), ji = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Vi = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Wi = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function _e(e) {
  return je(e) || $i.has(e) || Di.test(e) || Pt(e);
}
function Pt(e) {
  return Ue(e, "length", Yi);
}
function Hi(e) {
  return Ue(e, "size", tr);
}
function zi(e) {
  return Ue(e, "position", tr);
}
function Ui(e) {
  return Ue(e, "url", Xi);
}
function wt(e) {
  return Ue(e, "number", je);
}
function je(e) {
  return !Number.isNaN(Number(e));
}
function qi(e) {
  return e.endsWith("%") && je(e.slice(0, -1));
}
function lt(e) {
  return m0(e) || Ue(e, "number", m0);
}
function G(e) {
  return er.test(e);
}
function ct() {
  return !0;
}
function Be(e) {
  return ji.test(e);
}
function Gi(e) {
  return Ue(e, "", Ki);
}
function Ue(e, r, o) {
  var n = er.exec(e);
  return n ? n[1] ? n[1] === r : o(n[2]) : !1;
}
function Yi(e) {
  return Vi.test(e);
}
function tr() {
  return !1;
}
function Xi(e) {
  return e.startsWith("url(");
}
function m0(e) {
  return Number.isInteger(Number(e));
}
function Ki(e) {
  return Wi.test(e);
}
function Qi() {
  var e = ae("colors"), r = ae("spacing"), o = ae("blur"), n = ae("brightness"), i = ae("borderColor"), s = ae("borderRadius"), a = ae("borderSpacing"), c = ae("borderWidth"), u = ae("contrast"), p = ae("grayscale"), g = ae("hueRotate"), v = ae("invert"), d = ae("gap"), m = ae("gradientColorStops"), f = ae("gradientColorStopPositions"), h = ae("inset"), b = ae("margin"), _ = ae("opacity"), y = ae("padding"), k = ae("saturate"), L = ae("scale"), A = ae("sepia"), R = ae("skew"), z = ae("space"), I = ae("translate"), B = function() {
    return ["auto", "contain", "none"];
  }, E = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, S = function() {
    return ["auto", G, r];
  }, T = function() {
    return [G, r];
  }, $ = function() {
    return ["", _e];
  }, j = function() {
    return ["auto", je, G];
  }, te = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, U = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, me = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, he = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, ie = function() {
    return ["", "0", G];
  }, de = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, se = function() {
    return [je, wt];
  }, pe = function() {
    return [je, G];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [ct],
      spacing: [_e],
      blur: ["none", "", Be, G],
      brightness: se(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Be, G],
      borderSpacing: T(),
      borderWidth: $(),
      contrast: se(),
      grayscale: ie(),
      hueRotate: pe(),
      invert: ie(),
      gap: T(),
      gradientColorStops: [e],
      gradientColorStopPositions: [qi, Pt],
      inset: S(),
      margin: S(),
      opacity: se(),
      padding: T(),
      saturate: se(),
      scale: se(),
      sepia: ie(),
      skew: pe(),
      space: T(),
      translate: T()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", G]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Be]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": de()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": de()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(te(), [G])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: E()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": E()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": E()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: B()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": B()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": B()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [h]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [h]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [h]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [h]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [h]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [h]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [h]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [h]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [h]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", lt]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: S()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", G]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ie()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ie()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", lt]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [ct]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", lt]
        }, G]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": j()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": j()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [ct]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [lt]
        }, G]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": j()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": j()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", G]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", G]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [d]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [d]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [d]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(he())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(he(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(he(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [b]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [b]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [b]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [b]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [b]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [b]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [b]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [b]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [b]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [z]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [z]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", G, r]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", G, _e]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [Be]
        }, Be, G]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [G, r, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", G, _e]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [G, r, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Be, Pt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", wt]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [ct]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", G]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", je, wt]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", G, _e]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", G]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", G]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [_]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [_]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(U(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", _e]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", G, _e]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: T()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", G]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", G]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [_]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(te(), [zi])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Hi]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Ui]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [f]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [f]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [f]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [s]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [s]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [s]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [s]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [s]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [s]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [s]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [s]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [s]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [s]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [s]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [s]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [s]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [s]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [s]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [c]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [c]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [c]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [c]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [c]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [c]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [c]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [c]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [c]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [_]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(U(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [c]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [c]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [_]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: U()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(U())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [G, _e]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [_e]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: $()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [_]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [_e]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Be, Gi]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [ct]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [_]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": me()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": me()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [o]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [u]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Be, G]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [p]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [g]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [v]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [k]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [A]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [o]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [u]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [p]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [g]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [v]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [_]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [k]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [A]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", G]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: pe()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", G]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: pe()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", G]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [L]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [L]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [L]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [lt, G]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [I]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [I]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [R]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [R]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", G]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", G]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": T()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": T()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": T()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": T()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": T()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": T()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": T()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": T()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": T()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": T()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": T()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": T()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": T()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": T()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": T()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": T()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": T()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": T()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", G]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [_e, wt]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var Ji = /* @__PURE__ */ Oi(Qi);
function we(...e) {
  return Ji(Fi(...e));
}
function Bt(e, r, { checkForDefaultPrevented: o = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), o === !1 || !i.defaultPrevented)
      return r == null ? void 0 : r(i);
  };
}
const rr = function({
  aspectRatio: r,
  imageHoverAnimation: o = !0,
  className: n,
  as: i,
  ...s
}) {
  const a = i || ot;
  return /* @__PURE__ */ t(
    "div",
    {
      className: we("overflow-hidden rounded-cr-lg"),
      "data-test-id": "card-image-container",
      children: /* @__PURE__ */ t(
        a,
        {
          ...s,
          src: s.src,
          className: we(
            "object-cover",
            o && "group-hover:scale-125 transition-transform ease-in-out duration-1000 ",
            U0(r),
            n
          )
        }
      )
    }
  );
}, vt = "text-body-md-400 font-secondary", Tt = "p font-extrabold text-purple-500 break-words font-primary", ea = ({
  merchantName: e,
  storeUrl: r = "#",
  onlineRate: o,
  inStoreRate: n,
  logoUrl: i,
  background: s,
  description: a,
  onClick: c,
  sponsoredRate: u,
  sponsored: p = !1
}) => /* @__PURE__ */ w(
  qt,
  {
    className: "max-w-[480px] min-w-[280px]",
    href: r,
    onClick: c,
    children: [
      /* @__PURE__ */ w(Wt, { children: [
        s && /* @__PURE__ */ t(
          rr,
          {
            alt: e + "-background-image",
            className: "w-full",
            imageHoverAnimation: !1,
            aspectRatio: "16:9",
            src: s
          }
        ),
        i && s && /* @__PURE__ */ t(G0, { alt: e + "-avatar", src: i }),
        i && !s && /* @__PURE__ */ t(
          q0,
          {
            alt: e + "-logo",
            aspectRatio: "16:9",
            src: i
          }
        )
      ] }),
      /* @__PURE__ */ t(
        Ht,
        {
          className: "break-words font-secondary text-cr-body-lg-700 pt-cr-4 pb-cr-2 px-cr-2",
          actionButton: /* @__PURE__ */ t(zt, { children: p && /* @__PURE__ */ t(Ut, { color: "neutral", className: "text-neutral-400", children: "Sponsored" }) }),
          title: e,
          children: /* @__PURE__ */ w(
            "div",
            {
              className: C(
                "grid grid-cols-2 divide-x divide-neutral-100 w-full",
                !n && o || n && !o || p && "grid-cols-1"
              ),
              children: [
                p && /* @__PURE__ */ w("div", { children: [
                  /* @__PURE__ */ t("p", { className: C(vt), children: a }),
                  /* @__PURE__ */ t("p", { className: C(Tt), children: u })
                ] }),
                o && !p && /* @__PURE__ */ w("div", { className: o && n && "pr-2", children: [
                  /* @__PURE__ */ t("p", { className: C(vt), children: "Online cashback" }),
                  /* @__PURE__ */ t("p", { className: C(Tt), children: o })
                ] }),
                n && !p && /* @__PURE__ */ w("div", { className: o && n && "pl-2", children: [
                  /* @__PURE__ */ t("p", { className: C(vt), children: "In-store cashback" }),
                  /* @__PURE__ */ t("p", { className: C(Tt), children: n })
                ] }),
                !o && !n && !p && /* @__PURE__ */ t("p", { className: C(vt), children: "No current cashback" })
              ]
            }
          )
        }
      )
    ]
  }
), Ws = ea, ta = [
  { code: "+61", name: "Australia" },
  { code: "+64", name: "New Zealand" }
], or = V.memo(
  He(
    ({
      wrapperClassName: e,
      icon: r,
      countryCodes: o = ta,
      selectedCountryCode: n = o[0].code,
      error: i,
      state: s,
      label: a,
      id: c,
      name: u,
      type: p = "tel",
      placeholder: g,
      className: v,
      onChange: d = () => {
      },
      ...m
    }, f) => /* @__PURE__ */ t("div", { className: C("relative flex", e), children: /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(
      _t,
      {
        ref: f,
        label: a,
        id: c,
        name: u,
        type: p,
        placeholder: g,
        className: C(
          "rounded-tl-none rounded-bl-none border-l-0 mobile-input",
          v
        ),
        childrenPosition: "left",
        childrenClassName: O(
          "w-fit border border-r-0 rounded-tl-[8px] rounded-bl-[8px] h-[48px]"
        ),
        onChange: (h) => {
          d(h.target.value, "mobile");
        },
        error: i,
        state: s,
        ...m,
        children: /* @__PURE__ */ w(
          Or,
          {
            onValueChange: (h) => {
              d(h, "country");
            },
            defaultValue: n,
            children: [
              /* @__PURE__ */ w(
                Dr,
                {
                  className: O(
                    "bg-transparent z-10 flex items-center justify-between hover:bg-transparent focus-within:bg-transparent pl-4 pr-1 h-full text-neutral-300 focus:outline-none"
                  ),
                  "aria-label": "Select country code",
                  children: [
                    /* @__PURE__ */ t($r, { placeholder: n }),
                    /* @__PURE__ */ t(jr, { children: r || /* @__PURE__ */ t(
                      "svg",
                      {
                        fill: "none",
                        height: "6",
                        viewBox: "0 0 8 6",
                        width: "8",
                        xmlns: "http://www.w3.org/2000/svg",
                        className: "ml-1",
                        children: /* @__PURE__ */ t("path", { d: "m4 6 3.5-6h-7z", fill: "#282828" })
                      }
                    ) })
                  ]
                }
              ),
              /* @__PURE__ */ t(Vr, { children: /* @__PURE__ */ t(
                Wr,
                {
                  className: O(
                    "w-[184px] h-fit flex rounded-lg p-1 bg-white z-50 shadow-mobile-custom"
                  ),
                  position: "popper",
                  sideOffset: 8,
                  children: /* @__PURE__ */ t(Hr, { children: /* @__PURE__ */ t(zr, { children: o == null ? void 0 : o.map((h) => /* @__PURE__ */ w(
                    Ur,
                    {
                      value: h.code,
                      className: O(
                        "cursor-pointer hover:bg-neutral-100 px-4 py-2 rounded-[4px] gap-4 flex p focus:bg-neutral-100 focus:outline-none data-[state=checked]:bg-transparent data-[state=checked]:text-neutral-500 data-[state=checked]:font-semibold"
                      ),
                      children: [
                        /* @__PURE__ */ t(qr, { children: h.code }),
                        /* @__PURE__ */ t("span", { children: h.name })
                      ]
                    },
                    h.code
                  )) }) })
                }
              ) })
            ]
          }
        )
      }
    ) }) })
  )
);
or.displayName = "MobileInput";
const Hs = or, xt = (e, r) => {
  const o = r - e + 1;
  return Array.from({ length: o }, (n, i) => i + e);
}, dt = "...", ra = ({
  total: e,
  siblingCount: r = 1,
  selected: o
}) => {
  if (r + 5 >= e)
    return xt(1, e);
  const i = Math.max(o - r, 1), s = Math.min(o + r, e), a = i > 2, c = s < e - 2, u = 1, p = e;
  if (!a && c) {
    const g = 3 + 2 * r;
    return [...xt(1, g), dt, e];
  }
  if (a && !c) {
    const g = 3 + 2 * r, v = xt(e - g + 1, e);
    return [u, dt, ...v];
  }
  if (a && c) {
    const g = xt(i, s);
    return [u, dt, ...g, dt, p];
  }
}, h0 = "h-10 w-10 rounded-full mr-[2px] flex items-center justify-center text-neutral-400", oa = ({
  onSelectedChange: e,
  selected: r = 1,
  total: o,
  screenReaderLabel: n = "Pagination"
}) => {
  const i = ra({
    total: o,
    siblingCount: 1,
    selected: r
  });
  return /* @__PURE__ */ t("nav", { children: /* @__PURE__ */ w("ul", { "aria-label": n, className: "flex", children: [
    /* @__PURE__ */ w("li", { className: "flex items-center", children: [
      /* @__PURE__ */ t(
        bt,
        {
          className: C("p-2 md:mr-4 mr-2 sm:hidden"),
          size: "sm",
          type: "button",
          variant: "text",
          iconPosition: "left",
          disabled: r <= 1,
          icon: /* @__PURE__ */ t(Y, { name: "arrowLeft", height: "16", width: "16" }),
          onClick: () => e(r - 1)
        }
      ),
      /* @__PURE__ */ t(
        bt,
        {
          className: C("p-2 md:mr-4 mr-2 hidden sm:flex"),
          size: "sm",
          type: "button",
          variant: "text",
          iconPosition: "left",
          disabled: r <= 1,
          icon: /* @__PURE__ */ t(Y, { name: "arrowLeft", height: "16", width: "16" }),
          onClick: () => e(r - 1),
          children: /* @__PURE__ */ t("span", { className: C("hidden md:block"), children: " Prev " })
        }
      )
    ] }),
    i == null ? void 0 : i.map((s, a) => s === dt ? /* @__PURE__ */ t("li", { className: C(h0, "cursor-default"), children: /* @__PURE__ */ t("a", { className: C("text-sm font-secondary"), children: s }) }, a) : /* @__PURE__ */ t(
      "li",
      {
        className: C(
          h0,
          r === s ? "bg-purple-500 text-white hover:cursor-pointer" : "hover:bg-neutral-100 hover:cursor-pointer hover:text-neutral-900"
        ),
        onClick: () => e(s),
        children: /* @__PURE__ */ t("a", { className: C("text-sm font-secondary"), children: s })
      },
      a
    )),
    /* @__PURE__ */ w("li", { className: "flex items-center", children: [
      /* @__PURE__ */ t(
        bt,
        {
          className: C("p-2 md:mr-4 sm:hidden", "ml-2"),
          size: "sm",
          type: "button",
          variant: "text",
          iconPosition: "right",
          disabled: r === o,
          icon: /* @__PURE__ */ t(Y, { name: "arrowRight", height: "16", width: "16" }),
          onClick: () => e(r + 1)
        }
      ),
      /* @__PURE__ */ t(
        bt,
        {
          className: C("p-2 md:mr-4 hidden sm:flex", "ml-2"),
          size: "sm",
          type: "button",
          variant: "text",
          iconPosition: "right",
          disabled: r === o,
          icon: /* @__PURE__ */ t(Y, { name: "arrowRight", height: "16", width: "16" }),
          onClick: () => e(r + 1),
          children: /* @__PURE__ */ t("span", { className: C("hidden md:block"), children: " Next " })
        }
      )
    ] })
  ] }) });
}, zs = oa, na = He(
  ({
    value: e,
    numInputs: r = 6,
    onChange: o,
    shouldAutoFocus: n = !0,
    placeholder: i,
    renderSeparator: s,
    inputType: a = "text",
    inputClassName: c,
    state: u,
    error: p,
    containerClassName: g = "flex gap-2",
    isPassword: v = !1
  }, d) => {
    const [m, f] = J(e || "");
    return /* @__PURE__ */ w("div", { ref: d, className: "flex flex-col gap-3", children: [
      /* @__PURE__ */ t(
        Gr,
        {
          value: m,
          numInputs: r,
          onChange: (b) => {
            f(b), o(b);
          },
          inputType: a,
          placeholder: i,
          renderInput: (b, _) => /* @__PURE__ */ t(
            _t,
            {
              id: `otp-${_}`,
              className: O(
                "w-12 h-12 px-2 text-left border rounded max-w-[48px] max-h-[48px]",
                "otp_input",
                c
              ),
              autoFocus: n && _ === 0,
              placeholder: i || " ",
              type: v ? "password" : b.type,
              state: u,
              "aria-label": `Character ${_ + 1}.`,
              onChange: b.onChange,
              onFocus: b.onFocus,
              onKeyDown: b.onKeyDown,
              onPaste: b.onPaste,
              ref: b.ref,
              autoComplete: "one-time-code",
              value: b.value
            },
            `otp-input-${_}`
          ),
          shouldAutoFocus: n,
          renderSeparator: s,
          containerStyle: g
        }
      ),
      (p == null ? void 0 : p.message) && /* @__PURE__ */ t(
        "span",
        {
          id: "helperText",
          className: "text-body-md text-error-500 max-w-fit",
          children: p == null ? void 0 : p.message
        }
      )
    ] });
  }
), Us = na, nr = He(
  ({
    label: e = "Card number",
    id: r = "card-number",
    cardType: o = null,
    placeholder: n = "0000 0000 0000 0000",
    className: i,
    onChange: s,
    ...a
  }, c) => {
    const [u, p] = J(""), [g, v] = J(o || null), d = (f) => /^4[0-9]{12}(?:[0-9]{3})?$/.test(f) ? "visa" : /^5[1-5][0-9]{14}$/.test(f) ? "mastercard" : /^(?:5[0678]\d\d|6304|67\d\d)\d{8,15}$/.test(f) ? "eftpos" : null, m = (f) => {
      const { value: h } = f.target, b = h ? h.replace(/\s/g, "") : "";
      v(o || d(b));
      const _ = b.replace(/(\d{4})/g, "$1 ").trim();
      p(_), s && s(_);
    };
    return /* @__PURE__ */ t(
      _t,
      {
        id: r,
        ref: c,
        type: "text",
        label: e,
        placeholder: n,
        value: a.value !== void 0 ? a.value.toString().trim() : u.trim(),
        className: C("relative", i),
        maxLength: 19,
        onChange: m,
        childrenPosition: "right",
        childrenClassName: C(
          "absolute",
          "right-4",
          g === "mastercard" || g === "eftpos" ? "translate-y-[10px]" : "top-4"
        ),
        children: g === "mastercard" ? /* @__PURE__ */ t(Y, { name: "masterCard" }) : g === "visa" ? /* @__PURE__ */ t(Y, { name: "visaCard" }) : g === "eftpos" ? /* @__PURE__ */ t(Y, { name: "eftposCard" }) : null,
        error: a.error,
        state: a.state
      }
    );
  }
);
nr.displayName = "CreditCardInput";
const qs = nr, yt = 300, ia = ye({
  "0%": { backgroundColor: "rgb(0 0 0 / 0)" },
  "100%": { backgroundColor: "rgb(0 0 0 / 0.2)" }
}), aa = ye({
  "0%": { backgroundColor: "rgb(0 0 0 / 0.2)" },
  "100%": { backgroundColor: "rgb(0 0 0 / 0)" }
}), sa = Ne(ut.Overlay, {
  animation: `${ia} ${yt}ms forwards`,
  '&[data-state="closed"]': {
    animation: `${aa} ${yt}ms forwards`
  }
}), la = ({ ...e }) => /* @__PURE__ */ t(
  sa,
  {
    className: O(
      "fixed top-0 left-0 z-[100] flex h-full w-full",
      "z-[100] px-2 text-neutral-900 md:px-9"
    ),
    ...e
  }
), ca = la, ir = Sr({
  hideClose: !1
}), da = () => Nr(ir), ua = ir, fa = ye({
  "0%": { bottom: "-100%" },
  "100%": { bottom: "0" }
}), pa = ye({
  "0%": { bottom: "0" },
  "100%": { bottom: "-100%" }
}), ma = Ne(ut.Content, {
  animation: `${fa} ${yt}ms cubic-bezier(0.17, 0.89, 0.24, 1.11)`,
  '&[data-state="closed"]': {
    animation: `${pa} ${yt}ms ease-in-out`
  }
}), ha = V.forwardRef(function({ children: r, id: o, className: n, ...i }, s) {
  const { hideClose: a, size: c } = da(), { height: u } = Ci(), p = `absolute ${c === "full" ? "top-4 right-4" : "top-10 right-10"}`;
  return /* @__PURE__ */ w(
    ma,
    {
      id: o,
      "data-test-id": o,
      ...i,
      ref: s,
      className: C(
        "fixed left-0 bottom-0 z-[100] w-full max-w-full overflow-auto bg-white",
        n
      ),
      style: {
        height: `${c === "full" ? `${u}px` : "auto"}`,
        maxHeight: `${u}px`
      },
      children: [
        r,
        !a && /* @__PURE__ */ t(ut.Close, { "aria-label": "Close", className: p, children: /* @__PURE__ */ t(jt, { width: 16, height: 16 }) })
      ]
    }
  );
}), ga = ({
  children: e,
  hideClose: r,
  size: o = "fit",
  id: n,
  className: i,
  ...s
}) => {
  const a = ze(() => ({ hideClose: r, size: o }), [r, o]);
  return /* @__PURE__ */ t(ua.Provider, { value: a, children: /* @__PURE__ */ t(ut.Root, { ...s, children: /* @__PURE__ */ w(ut.Portal, { children: [
    /* @__PURE__ */ t(ca, {}),
    /* @__PURE__ */ t(ha, { id: n, className: i, children: e })
  ] }) }) });
}, Gs = ga, ba = ({
  variant: e = "primary",
  text: r,
  actionText: o,
  direction: n = "left",
  className: i,
  playOn: s = "mobile"
}) => /* @__PURE__ */ w(
  "div",
  {
    className: O([
      "marqueeText",
      e === "primary" && "bg-purple-500",
      e === "midnight" && "bg-purple-900",
      e === "black" && "bg-neutral-900",
      i
    ]),
    children: [
      /* @__PURE__ */ w(
        "div",
        {
          className: O(
            s === "mobile" && (n === "left" ? "animate-marquee-left sm:animate-none sm:mx-auto" : "animate-marquee-right sm:animate-none sm:mx-auto"),
            s === "mobile-tablet" && (n === "left" ? "animate-marquee-left lg:animate-none" : "animate-marquee-right lg:animate-none"),
            s === "tablet" && (n === "left" ? "mx-auto md:mx-0 md:animate-marquee-left lg:animate-none" : "mx-auto md:mx-0 md:animate-marquee2-right lg:animate-none"),
            s === "tablet-desktop" && (n === "left" ? "mx-auto md:mx-0 md:animate-marquee-left" : "mx-auto md:mx-0 md:animate-marquee-right"),
            s === "desktop" && (n === "left" ? "mx-auto xl:animate-marquee-left" : "mx-auto xl:animate-marquee-right"),
            s === "all" && (n === "left" ? "animate-marquee-left" : "animate-marquee-right"),
            "whitespace-nowrap flex lg:w-full justify-center"
          ),
          children: [
            /* @__PURE__ */ t("span", { className: "mx-cr-4", children: r }),
            /* @__PURE__ */ t("span", { className: "antialiased mx-cr-2 text-lime-500 font-primary text-cr-body-xl-800", children: o })
          ]
        }
      ),
      /* @__PURE__ */ w(
        "div",
        {
          className: O(
            s === "mobile" && (n === "left" ? "animate-marquee2-left  sm:hidden" : "animate-marquee2-right  sm:hidden"),
            s === "mobile-tablet" && (n === "left" ? "animate-marquee2-left lg:hidden" : "animate-marquee2-right lg:hidden"),
            s === "tablet" && (n === "left" ? "hidden md:animate-marquee2-left md:flex lg:hidden" : "hidden md:animate-marquee2-right md:flex lg:hidden"),
            s === "tablet-desktop" && (n === "left" ? "hidden md:flex md:animate-marquee2-left" : "hidden md:flex md:animate-marquee2-right"),
            s === "desktop" && (n === "left" ? "hidden xl:flex xl:animate-marquee2-left" : "hidden xl:flex xl:animate-marquee2-right"),
            s === "all" && (n === "left" ? "animate-marquee2-left" : "animate-marquee2-right"),
            "absolute whitespace-nowrap flex lg:w-full justify-center"
          ),
          children: [
            /* @__PURE__ */ t("span", { className: "mx-cr-5", children: r }),
            /* @__PURE__ */ t("span", { className: "antialiased mx-cr-3 text-lime-500 font-primary text-cr-body-xl-800", children: o })
          ]
        }
      )
    ]
  }
), wa = ba, va = ({
  variant: e = "primary",
  onClose: r,
  onClick: o,
  text: n,
  actionText: i,
  href: s,
  target: a,
  location: c = "bottom-screen",
  trackingPixelUrl: u,
  direction: p,
  playOn: g = "mobile"
}) => /* @__PURE__ */ w(
  "div",
  {
    className: O(
      e === "primary" && "bg-purple-500",
      e === "midnight" && "bg-purple-900",
      e === "black" && "bg-neutral-900",
      c === "inline" && "inline  w-full",
      c === "bottom-screen" && "fixed bottom-0 left-0 w-full z-10",
      "flex h-fit"
    ),
    children: [
      /* @__PURE__ */ w("div", { className: "flex-auto w-1/2 ml-cr-6", children: [
        u && /* @__PURE__ */ t("img", { src: u, loading: "lazy", className: "w-px h-px" }),
        /* @__PURE__ */ t(
          Fe,
          {
            href: s,
            target: a,
            onClick: o,
            className: "group focus-visible:outline-none",
            children: /* @__PURE__ */ t(
              wa,
              {
                text: n,
                variant: e,
                actionText: i,
                direction: p,
                playOn: g,
                className: "w-full h-full rounded-lg group-focus-visible:outline-none group-focus-visible:ring-2 group-focus-visible:ring-blue-500"
              }
            )
          }
        )
      ] }),
      /* @__PURE__ */ t("div", { className: O("flex flex-initial w-fit ml-cr-4 mr-cr-6"), children: /* @__PURE__ */ t(
        "button",
        {
          className: "w-8 h-8 m-auto rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
          onClick: r,
          children: /* @__PURE__ */ t(jt, { className: "m-auto text-white" })
        }
      ) })
    ]
  }
), Ys = va, et = {
  videoStarted: 70,
  firstQuartile: 71,
  midpoint: 72,
  thirdQuartile: 73,
  videoEnded: 74,
  previewClicked: "clicked"
}, ar = V.memo(
  ({
    location: e = "top-screen",
    orientation: r = "landscape",
    title: o,
    description: n,
    videoOrientation: i = "landscape",
    videoPosition: s = "left",
    pixel: { impressionUrl: a = "", eventUrls: c = {}, clickUrl: u = "" } = {},
    onFirstQuartile: p,
    onMidPoint: g,
    onThirdQuartile: v,
    onEnded: d,
    onClickPreview: m,
    playInline: f,
    ...h
  }) => {
    const b = O(
      "flex-1",
      r === "landscape" && "h-full",
      r === "portrait" && "h-auto"
    ), [_, y] = J(""), k = H(
      (E) => {
        y(E === "clicked" ? u : c[E]);
      },
      [c, u]
    ), L = H(() => {
      k(et.videoStarted);
    }, [k]), A = H(
      (E) => {
        k(et.firstQuartile), p && p(E);
      },
      [p, k]
    ), R = H(
      (E) => {
        k(et.midpoint), g && g(E);
      },
      [g, k]
    ), z = H(
      (E) => {
        k(et.thirdQuartile), v && v(E);
      },
      [v, k]
    ), I = H(
      (E) => {
        k(et.videoEnded), d && d(E);
      },
      [d, k]
    ), B = H(
      (E) => {
        k(et.previewClicked), m && m(E);
      },
      [m, k]
    );
    return /* @__PURE__ */ w(
      "div",
      {
        className: O(
          e === "bottom-screen" && "fixed bottom-0 left-0 z-10",
          "p-cr-4 rounded-cr-lg border border-neutral-200 w-full max-w-[1536px]",
          r === "portrait" && "max-w-sm"
        ),
        "data-test-id": "video-banner",
        children: [
          /* @__PURE__ */ w(
            "div",
            {
              className: O(
                "flex w-full gap-x-8 gap-y-4 justify-center items-center",
                r === "landscape" ? "flex-col sm:flex-row" : "flex-col",
                r === "portrait" && "h-full"
              ),
              children: [
                s === "left" && /* @__PURE__ */ t(
                  i0,
                  {
                    className: O(b),
                    ...h,
                    onFirstQuartile: A,
                    onMidPoint: R,
                    onThirdQuartile: z,
                    onEnded: I,
                    onPlay: L,
                    onClickPreview: B,
                    videoOrientation: i,
                    playInline: f
                  }
                ),
                o || n ? /* @__PURE__ */ w("div", { className: "flex-1 w-full sm:self-center sm:w-auto", children: [
                  o && /* @__PURE__ */ t(Ct, { type: "h4", size: "xs", className: "text-2xl", children: o }),
                  n && /* @__PURE__ */ t("p", { className: "text-body-base mt-cr-2", children: n })
                ] }) : null,
                s === "right" && /* @__PURE__ */ t(
                  i0,
                  {
                    ...h,
                    className: b,
                    onFirstQuartile: A,
                    onMidPoint: R,
                    onThirdQuartile: z,
                    onEnded: I,
                    onPlay: L,
                    onClickPreview: B,
                    playInline: f,
                    videoOrientation: i
                  }
                )
              ]
            }
          ),
          a && /* @__PURE__ */ t(
            "img",
            {
              "data-test-id": "impression-pixel",
              src: a,
              alt: "",
              className: "absolute hidden w-px h-px border-none"
            }
          ),
          _ && /* @__PURE__ */ t(
            "img",
            {
              "data-test-id": "video-event-pixel",
              src: _,
              alt: "",
              className: "absolute hidden border-none",
              width: "0",
              height: "0"
            }
          )
        ]
      }
    );
  }
);
ar.displayName = "VideoBanner";
const Xs = ar, xa = ({
  desktopUrl: e,
  mobileUrl: r,
  tabletUrl: o,
  href: n,
  alt: i,
  adWatermark: s,
  adWatermarkText: a,
  onClick: c,
  trackingPixelUrl: u,
  variant: p,
  rounded: g,
  ClassName: v,
  testId: d = "image-banner"
}) => /* @__PURE__ */ t(
  "div",
  {
    onClick: c,
    "data-test-id": d,
    className: O(
      "relative",
      p === "HalfPage" && "max-w-[300px] max-h-[600px]",
      p === "WideSkyscraper" && "max-w-[160px] max-h-[600px]",
      p === "MREC" && "max-w-[300px] max-h-[250px]",
      p === "Billboard" && "max-w-[970px] max-h-[250px]",
      p === "Leaderboard" && "max-w-[728px] max-h-[90px]",
      p === "MerchantBanner" && o && "max-w-[300px] max-h-[250px] md:max-w-[768px] md:max-h-[192px]",
      p === "MerchantBanner" && !o && "max-w-[300px] max-h-[250px] md:max-w-[768px] md:max-h-[192px]",
      g === "lg" && "rounded-cr-lg",
      v
    ),
    children: /* @__PURE__ */ w("a", { href: n, children: [
      u && /* @__PURE__ */ t(
        "img",
        {
          src: u,
          loading: "lazy",
          className: "w-px h-px",
          "data-test-id": `${d}-impression-pixel`
        }
      ),
      /* @__PURE__ */ w("picture", { children: [
        e && /* @__PURE__ */ t(
          "source",
          {
            srcSet: `${e}`,
            media: `(min-width: ${o ? "1024px" : "768px"})`
          }
        ),
        o && /* @__PURE__ */ t("source", { srcSet: `${o}`, media: "(min-width:768px)" }),
        /* @__PURE__ */ t(
          ot,
          {
            src: r || o || e || "",
            alt: i,
            useSkeleton: !0,
            className: O(g === "lg" && "rounded-cr-lg")
          }
        )
      ] }),
      s && /* @__PURE__ */ t(
        kt,
        {
          color: "transparent-dark-50",
          className: "absolute bottom-0 right-0 mr-cr-2 mb-cr-2 px-cr-2 py-cr-half",
          children: a
        }
      )
    ] })
  }
), Ks = xa;
function Ca({
  card: e,
  onClick: r,
  onImageLoad: o
}) {
  return e.isControl ? null : /* @__PURE__ */ t(
    "div",
    {
      className: "w-full overflow-hidden rounded-cr-lg",
      onClick: () => r(e),
      children: /* @__PURE__ */ t("a", { href: e.url, children: /* @__PURE__ */ t(
        "img",
        {
          onLoad: o,
          src: e.imageUrl,
          alt: e.extras.imageAlt,
          className: "w-full"
        }
      ) })
    }
  );
}
function ya({
  card: e,
  onImageLoad: r,
  onClick: o
}) {
  return e.isControl ? null : /* @__PURE__ */ w(
    "div",
    {
      className: "flex w-full flex-col overflow-hidden rounded-cr-lg bg-white shadow-cr-shadow-xs",
      onClick: () => o(e),
      children: [
        /* @__PURE__ */ t(
          "img",
          {
            onLoad: r,
            src: e.imageUrl,
            alt: e.extras.imageAlt
          }
        ),
        /* @__PURE__ */ w("div", { className: "flex flex-col gap-2 p-5 text-left", children: [
          /* @__PURE__ */ t("strong", { className: "text-cr-body-xl-800 font-[800]", children: /* @__PURE__ */ t("a", { href: e.url, children: e.title }) }),
          /* @__PURE__ */ t("p", { className: "whitespace-pre-wrap leading-4", children: e.description }),
          e.url && /* @__PURE__ */ t("a", { href: e.url, className: "font-bold text-primary-500", children: e.linkText })
        ] })
      ]
    }
  );
}
function ka({
  card: e,
  onClick: r,
  onImageLoad: o
}) {
  return e.isControl ? null : /* @__PURE__ */ w(
    "div",
    {
      className: "flex w-full items-center gap-5 overflow-hidden rounded-cr-lg bg-white p-5 shadow-cr-shadow-xs",
      onClick: () => r(e),
      children: [
        /* @__PURE__ */ t(
          "img",
          {
            onLoad: o,
            src: e.imageUrl,
            alt: e.extras.imageAlt,
            className: "aspect-square h-[75px] rounded-lg"
          }
        ),
        /* @__PURE__ */ w("div", { className: "flex flex-col gap-2 text-left", children: [
          /* @__PURE__ */ t("strong", { className: "text-cr-body-xl-800 font-[800]", children: /* @__PURE__ */ t("a", { href: e.url, children: e.title }) }),
          /* @__PURE__ */ t("p", { className: "whitespace-pre-wrap leading-4", children: e.description }),
          e.url && /* @__PURE__ */ t("a", { href: e.url, className: "font-bold text-primary-500", children: e.linkText })
        ] })
      ]
    }
  );
}
function Qs({ feedId: e, className: r }) {
  const [o, n] = J([]), [i, s] = J([]), [a, c] = J(() => {
    if (typeof window < "u")
      return window.braze;
  }), [u, p] = J(0), [g, v] = J(0), [d, m] = J(1), [f, h] = J(!1), b = ce(null), _ = ce(), y = ce(null), [k, L] = w0(
    Date.now,
    0
  );
  le(() => {
    p(0), v(0), m(0), o.length && a && a.logContentCardImpressions([...o, ...i]);
  }, [o, i, a]), le(() => {
    let I;
    function B() {
      clearTimeout(I), I = setTimeout(L, 200);
    }
    return window.addEventListener("resize", B), () => window.removeEventListener("resize", B);
  }, []), le(() => {
    const I = setTimeout(() => {
      var S;
      const B = (S = b.current) == null ? void 0 : S.getBoundingClientRect().width;
      if (!B)
        return;
      const E = Math.round(g / B);
      p(E);
    }, 150);
    return () => clearTimeout(I);
  }, [g]);
  const A = H(
    ({ cards: I }) => {
      let B = I;
      e && (B = B.filter(
        (S) => (S.extras.feed_id || "").split(",").includes(e)
      ));
      const E = window.innerWidth < 600 ? "mobile" : "desktop";
      B = B.filter(
        (S) => !S.extras.device || S.extras.device.split(",").includes(E)
      ), n(B.filter((S) => !S.isControl)), s(B.filter((S) => S.isControl));
    },
    [e]
  );
  le(() => {
    if (a)
      return;
    const I = setInterval(() => {
      typeof window.braze < "u" && c(window.braze);
    }, 300);
    return () => clearInterval(I);
  }, [a]), le(() => {
    if (!a)
      return;
    const I = a.subscribeToContentCardsUpdates(A), B = a.getCachedContentCards();
    return A(B), () => a.removeSubscription(I);
  }, [a, A]);
  const R = H((I) => {
    var E, S;
    const B = (E = b.current) == null ? void 0 : E.getBoundingClientRect().width;
    B && ((S = b.current) == null || S.scrollTo({
      left: B * I,
      behavior: "smooth"
    }));
  }, []);
  le(() => R(u), [u, R]), le(() => {
    o.length && setTimeout(() => {
      const I = document.getElementById(
        `content-card-${o[u].id}`
      );
      !I || !y.current || (y.current.style.height = `${I.getBoundingClientRect().height}px`);
    }, 100);
  }, [u, o, k]);
  const z = H(
    (I) => {
      a && a.logContentCardClick(I);
    },
    [a]
  );
  return le(() => {
    let I;
    function B() {
      clearTimeout(I), I = setTimeout(() => {
        if (!y.current)
          return;
        const E = y.current.getBoundingClientRect(), S = !(E.bottom < 0 || E.top > window.innerHeight);
        h(S);
      }, 300);
    }
    return document.addEventListener("scroll", B), B(), () => document.removeEventListener("scroll", B);
  }, [o, u]), le(() => {
    if (o.length < 2)
      return;
    const I = setTimeout(() => {
      f && p(u + d);
    }, 8e3);
    return () => clearTimeout(I);
  }, [o, u, d, f]), le(() => {
    if (o.length < 2) {
      m(0);
      return;
    }
    u === o.length - 1 && m(-1), u === 0 && m(1);
  }, [o, u, d]), le(() => {
    a && setTimeout(() => {
      const I = parseInt(
        sessionStorage.getItem("BrazeContentCards.lastRefresh") || "0",
        10
      );
      Date.now() - I > 6e5 && (sessionStorage.setItem(
        "BrazeContentCards.lastRefresh",
        Date.now().toString()
      ), a.requestContentCardsRefresh());
    }, 3e3);
  }, [a]), !a || !o.length ? null : /* @__PURE__ */ t("div", { className: r, children: /* @__PURE__ */ w(
    "div",
    {
      ref: y,
      className: "relative w-full overflow-hidden transition-all duration-500",
      children: [
        /* @__PURE__ */ t(
          "div",
          {
            onClick: () => p(u - 1),
            style: {
              WebkitTapHighlightColor: "transparent"
            },
            className: O(
              "absolute left-0 top-[50%] flex h-full translate-y-[-50%] items-center mix-blend-difference transition-all",
              "hig cursor-pointer bg-gray-600 bg-opacity-0 p-2 text-white hover:bg-opacity-30",
              u <= 0 ? "translate-x-[-130%]" : "translate-x-[0%]"
            ),
            children: /* @__PURE__ */ t(Y, { name: "arrowLeft", height: "16", width: "16" })
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            onClick: () => p(u + 1),
            style: {
              WebkitTapHighlightColor: "transparent"
            },
            className: O(
              "absolute right-0 top-[50%] flex h-full translate-y-[-50%] items-center mix-blend-difference transition-all",
              "cursor-pointer bg-gray-600 bg-opacity-0 p-2 text-white hover:bg-opacity-30",
              u >= o.length - 1 ? "translate-x-[130%]" : "translate-x-[0%]"
            ),
            children: /* @__PURE__ */ t(Y, { name: "arrowRight", height: "16", width: "16" })
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            ref: b,
            onScroll: (I) => {
              clearTimeout(_.current), _.current = setTimeout(() => {
                v(I.target.scrollLeft);
              }, 50);
            },
            className: O(
              "hide-scrollbar flex w-full items-start gap-3 overflow-x-scroll",
              "snap-x snap-mandatory "
            ),
            children: o.map((I) => {
              let B;
              if (I instanceof a.ClassicCard)
                B = ka;
              else if (I instanceof a.CaptionedImage)
                B = ya;
              else if (I instanceof a.Banner)
                B = Ca;
              else
                return null;
              return /* @__PURE__ */ t(
                "div",
                {
                  id: `content-card-${I.id}`,
                  className: "min-w-full px-1 py-1 snap-center",
                  children: /* @__PURE__ */ t(
                    B,
                    {
                      card: I,
                      onImageLoad: L,
                      brazeSdk: a,
                      onClick: z
                    }
                  )
                },
                I.id
              );
            })
          }
        )
      ]
    }
  ) });
}
const sr = V.createContext(
  void 0
);
function nt() {
  const e = V.useContext(sr);
  if (e === void 0)
    throw new Error(
      "useCarouselContext must be used within a CarouselProvider"
    );
  return e;
}
const _a = sr, Fa = (e, r) => {
  if (e.length !== r.length)
    return !1;
  const o = e.reduce((i, s) => ({ ...i, [s]: !0 }), {});
  return r.every((i) => o[i]);
}, Sa = ({
  children: e,
  className: r,
  ...o
}) => /* @__PURE__ */ t(
  "button",
  {
    className: we(
      "z-10, outline-non relative m-0 flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-md disabled:opacity-0",
      r
    ),
    ...o,
    children: e
  }
), Js = Sa, el = (e) => {
  const {
    children: r,
    enableDragging: o,
    onVisibleItemsChanged: n,
    onMounted: i,
    visibilityThreshold: s = 1,
    ...a
  } = e, c = ce(null), u = ce(null), p = ce(!1), g = ce(null), [v, d] = J(!1), [m, f] = J(!0), [h, b] = J(!1), [_, y] = J({}), k = ce(null), L = H(() => {
    var T;
    const E = ((T = c.current) == null ? void 0 : T.getVisibleIndices()) ?? [];
    return { currentPage: Math.floor(E[E.length - 1] / E.length) + 1, itemsPerPage: E.length };
  }, []), A = ce({
    visibleIndices: [],
    mounted: !1,
    getPageInfo: L
  }), R = H(() => {
    var E;
    b(!0), (E = c.current) == null || E.goNext();
  }, []), z = H(() => {
    var E;
    b(!0), (E = c.current) == null || E.goPrevious();
  }, []), I = H(() => new Promise((E) => {
    var $;
    let S = ($ = u.current) == null ? void 0 : $.scrollLeft;
    const T = () => {
      var j, te;
      S === ((j = u.current) == null ? void 0 : j.scrollLeft) ? (k.current = null, E(!0)) : (S = (te = u.current) == null ? void 0 : te.scrollLeft, k.current = setTimeout(T, 100));
    };
    k.current = setTimeout(() => {
      requestAnimationFrame(T);
    }, 20);
  }), [u]);
  le(() => {
    const E = u.current;
    if (E) {
      const S = gt(
        () => {
          y({});
        },
        100,
        {
          leading: !0,
          trailing: !0
        }
      ), T = gt(
        () => {
          if (c != null && c.current) {
            const te = c.current.getVisibleIndices();
            Fa(
              te,
              A.current.visibleIndices
            ) || (A.current.visibleIndices = te, b(!1), n == null || n(A.current));
          }
        },
        50,
        { leading: !1, trailing: !0 }
      ), $ = () => {
        S(), p.current === !1 && (p.current = !0, I().then(() => {
          p.current = !1, T();
        }));
      }, j = gt(
        () => {
          $();
        },
        200,
        { trailing: !0 }
      );
      return E.addEventListener("scroll", $), window.addEventListener("resize", j), y({}), () => {
        E.removeEventListener("scroll", $), window.removeEventListener("resize", j), k.current && clearTimeout(k.current);
      };
    }
  }, [I, n, u]);
  const B = H(
    gt(
      () => {
        if (A.current.mounted === !1 && c.current) {
          A.current.mounted = !0;
          const E = c.current.getVisibleIndices();
          A.current.visibleIndices = E, i == null || i(A.current);
        }
      },
      100,
      { trailing: !0, leading: !1 }
    ),
    [i]
  );
  return /* @__PURE__ */ t(
    _a.Provider,
    {
      value: {
        _,
        nextDisabled: v,
        prevDisabled: m,
        isScrolling: h,
        slideListRef: c,
        slideListDomRef: u,
        onNextClick: R,
        onPrevClick: z,
        enableDragging: o ?? !1,
        setNextDisabled: d,
        setPrevDisabled: f,
        visibilityThreshold: s,
        onMounting: B,
        root: g
      },
      children: /* @__PURE__ */ t("div", { ...a, ref: g, children: r })
    }
  );
}, tl = (e) => {
  const { as: r = "button", ...o } = e, { onNextClick: n, nextDisabled: i } = nt();
  return /* @__PURE__ */ t(
    r,
    {
      ...o,
      onClick: () => n(),
      disabled: i
    }
  );
}, rl = (e) => {
  const { as: r = "button", ...o } = e, { onPrevClick: n, prevDisabled: i } = nt();
  return /* @__PURE__ */ t(
    r,
    {
      ...o,
      onClick: () => n(),
      disabled: i
    }
  );
}, Na = ({
  ref: e,
  onNextClick: r,
  onPreviousClick: o,
  getVisibleIndices: n
}) => {
  const { slideListDomRef: i, slideListRef: s } = nt(), a = _i(e, i);
  return v0(
    s,
    () => ({
      goNext: r,
      goPrevious: o,
      getVisibleIndices: n,
      ...e.current
    }),
    [n, r, o, e]
  ), { ref: a };
}, Ma = Na, Ea = ({
  ref: e,
  ...r
}) => {
  const { enableDragging: o } = nt(), [n, i] = V.useState(null), s = Zt((g) => {
    if (e.current && n) {
      const v = g.clientX - n.pointerX;
      e.current.scrollLeft = n.scrollX - v;
    }
  }), a = Zt(() => {
    document.removeEventListener("mousemove", s), document.removeEventListener("mouseup", a), i(null);
  }), c = V.useCallback(
    (g) => {
      g.target instanceof HTMLInputElement || o && g.button === 0 && (document.addEventListener("mousemove", s), document.addEventListener("mouseup", a), i({
        scrollX: g.currentTarget.scrollLeft,
        pointerX: g.clientX
      }));
    },
    [o, s, a]
  ), u = V.useCallback(
    (g) => {
      if (g.target instanceof HTMLInputElement || !o)
        return;
      const v = g.target;
      v.style.userSelect = "none", v.setPointerCapture(g.pointerId);
    },
    [o]
  ), p = V.useCallback(
    (g) => {
      if (g.target instanceof HTMLInputElement || !o)
        return;
      const v = g.target;
      v.style.userSelect = "", v.releasePointerCapture(g.pointerId);
    },
    [o]
  );
  return {
    // ref: newRef,
    onMouseDownCapture: Bt(
      r.onMouseDownCapture,
      c
    ),
    onPointerDown: Bt(r.onPointerDown, u),
    onPointerUp: Bt(r.onPointerUp, p),
    dragStart: n
  };
}, Ia = V.forwardRef(function({ children: r, ...o }, n) {
  const i = ce(null), { setNextDisabled: s, setPrevDisabled: a, visibilityThreshold: c } = nt(), u = ce(100), p = Zt((A) => {
    var z;
    const R = (z = i.current) == null ? void 0 : z.querySelectorAll(
      "[data-slide-intersection-ratio]"
    );
    if (R) {
      const I = Array.from(R);
      return A === 1 && I.reverse(), I.find(
        (B) => Number(B.dataset.slideIntersectionRatio || "0") === 1
      );
    }
  }), g = H(() => {
    var R;
    const A = (R = i.current) == null ? void 0 : R.querySelectorAll(
      "[data-slide-intersection-ratio]"
    );
    return Array.from(A ?? []);
  }, [i]), v = H(() => {
    const A = g();
    return A.filter(
      (z) => Number(z.dataset.slideIntersectionRatio) >= c
    ).map((z) => A.indexOf(z));
  }, [g, c]), d = H(() => g().filter(
    (A) => Number(A.dataset.slideIntersectionRatio ?? "0") === 1
  ).length, [g]), m = H(() => {
    const A = p(1);
    if (A && i.current) {
      const R = g(), { scrollWidth: z, clientWidth: I } = i.current, B = R.indexOf(A), E = B + 1 < R.length ? R[B + 1].offsetLeft : -1;
      if (E === -1)
        return;
      i.current.scrollTo({ left: E, behavior: "smooth" }), a(E <= 0), s(Math.floor(z - E - I) <= 0), u.current = 500;
    }
  }, [p, g, a, s]), f = H(() => {
    const A = p(-1);
    if (A && i.current) {
      const R = g(), z = d(), { scrollWidth: I, clientWidth: B } = i.current, S = R.indexOf(A) - z, T = S > 0 ? R[S].offsetLeft : 0;
      i.current.scrollTo({ left: T, behavior: "smooth" }), a(T <= 0), s(Math.floor(I - T - B) <= 0), u.current = 500;
    }
  }, [
    p,
    g,
    d,
    a,
    s
  ]), { ref: h } = Ma({
    ref: i,
    onNextClick: m,
    onPreviousClick: f,
    getVisibleIndices: v
  });
  v0(n, () => ({
    getAllSlides: g
  }));
  const { dragStart: b, onMouseDownCapture: _, onPointerDown: y, onPointerUp: k } = Ea({ ...o, ref: i }), L = ce();
  return le(() => {
    L.current && clearTimeout(L.current), L.current = setTimeout(() => {
      requestAnimationFrame(() => {
        if (i.current) {
          const { scrollLeft: A, scrollWidth: R, clientWidth: z } = i.current;
          a(A <= 0), s(
            Math.floor(R - A - z) <= 0
          ), u.current = 100;
        }
      });
    }, u.current);
  }), /* @__PURE__ */ t(
    "div",
    {
      ...o,
      ref: h,
      "data-state": b ? "dragging" : void 0,
      onMouseDownCapture: _,
      onPointerDown: y,
      onPointerUp: k,
      className: we(
        "relative grid auto-cols-max grid-flow-col auto-rows-max overflow-x-scroll lg:overflow-hidden",
        "hide-scrollbar",
        o.className
      ),
      children: r
    }
  );
}), ol = Ia, lr = V.createContext(
  void 0
);
function La() {
  const e = V.useContext(lr);
  if (e === void 0)
    throw new Error(
      "useCarouselSliderItemContext must be used within a CarouselSlideItemProvider"
    );
  return e;
}
const Aa = lr, Ba = (e) => {
  const {
    as: r = "div",
    index: o,
    onObserverValueChange: n,
    onClick: i,
    ...s
  } = e, { root: a, onMounting: c, isScrolling: u } = nt(), p = ce(null), [g, v] = J(0), d = ce(!1);
  return le(() => {
    if (p.current) {
      const m = new IntersectionObserver(
        ([f]) => {
          v(f.intersectionRatio), c(), n == null || n(o, f.intersectionRatio);
        },
        {
          root: a.current,
          threshold: [0, 0.5, 0.75, 0.95, 1]
        }
      );
      return m.observe(p.current), () => m.disconnect();
    }
  }, [o, c, n, a]), /* @__PURE__ */ t(
    r,
    {
      ...s,
      ref: p,
      "data-slide-intersection-ratio": g,
      onDragStart: (m) => {
        m.preventDefault(), d.current = !0;
      },
      onClick: (m) => {
        d.current && m.preventDefault(), i == null || i(m);
      },
      children: /* @__PURE__ */ t(
        Aa.Provider,
        {
          value: {
            intersectionRatio: g,
            isScrolling: u
          },
          children: e.children
        }
      )
    }
  );
}, nl = Ba, Ta = ({
  author: e,
  date: r,
  badgeLabel: o,
  className: n,
  variant: i = "NoStack",
  badgeColor: s = "neutral-soft"
}) => /* @__PURE__ */ w(
  "div",
  {
    className: O(
      "flex",
      i === "NoStack" && "flex-col md:flex-row",
      i !== "NoStack" && "flex-col",
      n
    ),
    children: [
      /* @__PURE__ */ w("div", { className: "flex", children: [
        e,
        /* @__PURE__ */ t(
          "span",
          {
            className: O(
              i !== "StackByDate" && "hidden md:block",
              i === "StackByDate" && "hidden",
              "extrabold text-neutral-200 mx-cr-4"
            ),
            children: "|"
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            className: O(
              i !== "StackByDate" && "hidden md:block",
              i === "StackByDate" && "hidden",
              "my-auto"
            ),
            children: /* @__PURE__ */ t(a0, { date: r })
          }
        )
      ] }),
      /* @__PURE__ */ w(
        "div",
        {
          className: O(
            i === "NoStack" ? "mt-cr-2 md:mt-0" : "mt-cr-2",
            "flex"
          ),
          children: [
            /* @__PURE__ */ t(
              "div",
              {
                className: O(
                  i !== "StackByDate" && "block md:hidden",
                  "my-auto"
                ),
                children: /* @__PURE__ */ t(a0, { date: r })
              }
            ),
            o && /* @__PURE__ */ t(
              kt,
              {
                className: O(i !== "StackByBadge" && "ml-cr-4"),
                color: s,
                children: o
              }
            )
          ]
        }
      )
    ]
  }
), il = Ta, g0 = V.forwardRef(
  function({
    as: r,
    active: o,
    className: n,
    ...i
  }, s) {
    return /* @__PURE__ */ t(
      r ?? "li",
      {
        ref: s,
        className: we(
          "w-2 h-2 rounded-full cursor-pointer transition-all",
          o ? "bg-primary-500" : "bg-transparent-dark-30",
          o && "rounded-[100px] w-4",
          n
        ),
        ...i
      }
    );
  }
), Za = V.forwardRef(
  function({
    as: r,
    children: o,
    itemAs: n = g0,
    activeIndex: i,
    items: s,
    renderItem: a,
    onItemSelect: c,
    className: u,
    ...p
  }, g) {
    const v = r ?? "ul", d = n ?? g0, m = (f) => {
      c && c(f);
    };
    return /* @__PURE__ */ w(
      v,
      {
        className: we("flex justify-center items-center gap-1", u),
        ref: g,
        ...p,
        children: [
          (s || []).map((f, h) => {
            if (a)
              return a(f, h, i === h, () => {
                m(h);
              });
            if (n)
              return /* @__PURE__ */ t(
                d,
                {
                  index: h,
                  active: i === h,
                  onClick: () => m(h)
                },
                f
              );
          }),
          o
        ]
      }
    );
  }
), Ra = Za, cr = V.createContext(
  void 0
);
function St() {
  const e = V.useContext(cr);
  if (e === void 0)
    throw new Error("useSliderContext must be used within a SliderProvider");
  return e;
}
const Pa = V.forwardRef(({ children: e, className: r, ...o }, n) => /* @__PURE__ */ t(
  "button",
  {
    ref: n,
    className: we(
      "z-10 outline-non relative m-0 flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-md disabled:opacity-0",
      r
    ),
    ...o,
    children: e
  }
)), b0 = Pa;
function Oa(e, r) {
  switch (r.type) {
    case "SET_ACTIVE_INDEX":
      return e.activeIndex === r.payload ? e : { ...e, activeIndex: r.payload };
    case "SET_PREV_DISABLED":
      return { ...e, prevDisabled: r.payload };
    case "SET_NEXT_DISABLED":
      return { ...e, nextDisabled: r.payload };
    default:
      return e;
  }
}
const Da = {
  sm: 640,
  md: 768,
  lg: 1024
}, $a = (e) => {
  if (e)
    return Object.keys(e).reduce(
      (o, n) => {
        const i = Object.keys(e[n]).reduce(
          (a, c) => ({
            ...a,
            [c]: e[n][c]
          }),
          {}
        ), s = Da[n] || n;
        return { ...o, [s]: i };
      },
      {}
    );
}, ja = ({
  children: e,
  totalSlides: r,
  centeredSlides: o = !1,
  autoPlay: n,
  interval: i = 5e3,
  onSlideChange: s,
  rewind: a = !1,
  pauseOnFocus: c,
  pauseOnHover: u,
  perMove: p,
  perPage: g,
  paddingLeft: v,
  autoWidth: d,
  gap: m,
  onMounted: f,
  responsiveOptions: h
}) => {
  const [b, _] = w0(Oa, {
    activeIndex: 0,
    isCenterMode: o,
    totalSlides: r,
    autoPlay: n,
    nextDisabled: !0,
    prevDisabled: !0
  }), y = ce(null), k = H(() => {
    var S;
    (S = y == null ? void 0 : y.current) == null || S.go(">");
  }, []), L = H(() => {
    var S;
    (S = y == null ? void 0 : y.current) == null || S.go("<");
  }, []), A = H(
    (S) => {
      var T;
      (T = y == null ? void 0 : y.current) == null || T.go(S);
    },
    [y]
  ), R = H((S) => {
    var j, te;
    const T = (j = y.current) == null ? void 0 : j.Components.Controller.getPrev(), $ = (te = y.current) == null ? void 0 : te.Components.Controller.getNext();
    _({
      type: "SET_PREV_DISABLED",
      payload: typeof T > "u" || T < 0 || T === S.index
    }), _({
      type: "SET_NEXT_DISABLED",
      payload: typeof $ > "u" || $ < 0 || $ === S.index
    });
  }, []), z = H(
    (S) => {
      y.current = S, R(S), f == null || f();
    },
    [R, f]
  ), I = H(
    (S) => {
      _({ type: "SET_ACTIVE_INDEX", payload: S.index }), R(S);
    },
    [R]
  ), B = H(
    (S) => {
      b.activeIndex !== S.index && (s == null || s(S.index));
    },
    [s, b]
  ), E = ze(() => {
    const $ = {
      arrows: !1,
      autoplay: n,
      rewind: a,
      rewindByDrag: a,
      pagination: !1,
      pauseOnFocus: c ?? (n ? !0 : void 0),
      pauseOnHover: u ?? (n ? !0 : void 0),
      interval: i,
      focus: b.isCenterMode ? "center" : void 0,
      perMove: p ?? (b.isCenterMode ? 1 : void 0),
      perPage: g ?? (b.isCenterMode ? 1 : void 0),
      padding: v,
      autoWidth: d,
      gap: m,
      mediaQuery: "min",
      breakpoints: $a(h)
    };
    return Object.keys($).forEach((j) => {
      $[j] === void 0 && delete $[j];
    }), $;
  }, [
    c,
    n,
    u,
    a,
    i,
    b.isCenterMode,
    p,
    g,
    v,
    d,
    m,
    h
  ]);
  return /* @__PURE__ */ t(
    cr.Provider,
    {
      value: {
        activeIndex: b.activeIndex,
        totalSlides: b.totalSlides,
        onNextClick: k,
        onPrevClick: L,
        goToSlide: A,
        nextDisabled: b.nextDisabled,
        prevDisabled: b.prevDisabled,
        isCenterMode: b.isCenterMode,
        autoPlay: b.autoPlay,
        rewind: b.rewind
      },
      children: /* @__PURE__ */ t(
        Yr,
        {
          hasTrack: !1,
          options: E,
          onMounted: z,
          onMoved: B,
          onMove: I,
          children: e
        }
      )
    }
  );
}, Va = (e) => {
  const { as: r = "button", ...o } = e, { onNextClick: n, nextDisabled: i } = St();
  return /* @__PURE__ */ t(r, { ...o, onClick: n, disabled: i });
}, Wa = (e) => {
  const { as: r = "button", ...o } = e, { onPrevClick: n, prevDisabled: i } = St();
  return /* @__PURE__ */ t(r, { ...o, onClick: n, disabled: i });
}, Ha = ({
  leftArrowClassName: e,
  rightArrowClassName: r
}) => /* @__PURE__ */ w(Se, { children: [
  /* @__PURE__ */ t("div", { className: "hidden lg:block", children: /* @__PURE__ */ t(
    Wa,
    {
      className: we(
        " absolute left-0 top-[50%] -translate-y-1/2 -translate-x-1/2",
        e
      ),
      "aria-label": "Show previous",
      tabIndex: -1,
      as: b0,
      children: /* @__PURE__ */ t(F0, { height: 16, width: 16 })
    }
  ) }),
  /* @__PURE__ */ t("div", { className: "hidden lg:block", children: /* @__PURE__ */ t(
    Va,
    {
      className: we(
        "absolute right-0 top-[50%] -translate-y-1/2 translate-x-1/2",
        r
      ),
      "aria-label": "Show next",
      tabIndex: -1,
      as: b0,
      children: /* @__PURE__ */ t(_0, { height: 16, width: 16 })
    }
  ) })
] }), za = ({
  index: e,
  enableFadingOnInactiveSlides: r = !0,
  className: o,
  children: n
}) => {
  const { activeIndex: i, isCenterMode: s } = St();
  return /* @__PURE__ */ t(
    Xr,
    {
      className: we(
        s && r && (e === i - 1 || e === i + 1) ? "opacity-30" : "",
        o
      ),
      children: n
    }
  );
}, Ua = za, qa = () => {
  const { activeIndex: e, totalSlides: r, goToSlide: o } = St(), n = (s) => {
    o(s);
  }, i = Array(r).fill(0).map((s, a) => a);
  return /* @__PURE__ */ t("div", { className: "flex justify-center items-center gap-1", children: /* @__PURE__ */ t(
    Ra,
    {
      items: i,
      activeIndex: e,
      onItemSelect: n
    }
  ) });
}, Ga = function({
  children: r,
  className: o
}) {
  return /* @__PURE__ */ t(Kr, { className: we(o), children: r });
}, Ya = ({
  strokecolor: e = "currentColor",
  height: r = "32",
  width: o = "32",
  ...n
}) => /* @__PURE__ */ t(
  "svg",
  {
    width: o,
    height: r,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M4 10L16 22L28 10",
        stroke: e,
        strokeWidth: "1.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Xa = Ya, Ka = V.forwardRef(
  function(r, o) {
    const { type: n, className: i, children: s, ...a } = r, c = a, u = a, p = (v) => {
      var d, m;
      n === "single" ? (d = c.onSelectedValueChange) == null || d.call(c, v) : (m = u.onSelectedValueChange) == null || m.call(u, v);
    }, g = C("text-neutral-500", i);
    return n === "single" ? /* @__PURE__ */ t(
      rt.Root,
      {
        type: n,
        className: g,
        collapsible: !0,
        ref: o,
        onValueChange: p,
        defaultValue: c.defaultValue,
        children: s
      }
    ) : /* @__PURE__ */ t(
      rt.Root,
      {
        type: n,
        className: g,
        ref: o,
        onValueChange: p,
        defaultValue: u.defaultValue,
        children: s
      }
    );
  }
), al = V.forwardRef(function({ className: r, children: o, value: n, ...i }, s) {
  return /* @__PURE__ */ t(
    rt.Item,
    {
      className: C(
        "border-t border-neutral-100 overflow-hidden border-collapse last:border-b",
        r
      ),
      ref: s,
      value: n,
      ...i,
      children: o
    }
  );
}), sl = V.forwardRef(function({ className: r, children: o, size: n = "md", disabled: i, ...s }, a) {
  return /* @__PURE__ */ t(rt.Header, { asChild: !0, children: /* @__PURE__ */ w(
    rt.AccordionTrigger,
    {
      ref: a,
      disabled: i,
      className: C(
        "flex w-full items-center justify-between text-left gap-4 bg-transparent flex-1",
        "px-cr-4",
        n === "lg" && "py-cr-8 ",
        n === "md" && "py-cr-4",
        n === "sm" && "py-cr-1 ",
        !i && " hover:bg-neutral-50",
        i && "text-neutral-200",
        "[&>svg]:data-[state=open]:rotate-180 focus-visible:outline-info-500",
        r
      ),
      ...s,
      children: [
        o,
        /* @__PURE__ */ t(
          Xa,
          {
            height: n == "lg" ? 24 : 16,
            width: n == "lg" ? 24 : 16,
            className: C(
              "transition-transform",
              n === "lg" ? "min-w-6" : "min-w-4"
            )
          }
        )
      ]
    }
  ) });
}), ll = V.forwardRef(function({ className: r, children: o, ...n }, i) {
  return /* @__PURE__ */ t(
    rt.Content,
    {
      className: C(
        'data-[state="open"]:animate-slide-down data-[state="closed"]:animate-slide-up'
      ),
      ref: i,
      style: {
        "--slide-down-content-height": "var(--radix-accordion-content-height)"
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      },
      ...n,
      children: /* @__PURE__ */ t(
        "div",
        {
          className: C(" pt-cr-0 px-cr-4 pb-cr-4 overflow-hidden", r),
          children: o
        }
      )
    }
  );
}), cl = Ka, dr = He(
  ({
    promoButtonColor: e = "lime",
    size: r = "md",
    variant: o = "primary",
    href: n,
    openNewTab: i = !1,
    className: s,
    size: a = "md",
    isRounded: c = !1,
    iconPosition: u,
    icon: p,
    children: g,
    ...v
  }, d) => {
    const m = {
      lime: o === "outline" ? "border border-white bg-transparent hover:bg-white active:bg-white" : "bg-lime-500 focus:bg-lime-500 hover:bg-lime-400 active:bg-lime-600",
      sky: "bg-sky-500 focus:bg-sky-500 hover:bg-sky-400 active:bg-sky-600",
      flamingo: "bg-flamingo-500 focus:bg-flamingo-500 hover:bg-flamingo-400 active:bg-flamingo-600",
      black: o === "outline" ? "border border-neutral-500 bg-transparent hover:bg-neutral-500 active:bg-neutral-900" : "bg-neutral-900 focus:bg-neutral-900 hover:bg-neutral-500 active:bg-neutral-600",
      white: o === "outline" ? "border border-white bg-transparent hover:bg-white active:bg-white" : "bg-white focus:bg-white hover:bg-neutral-100",
      purple: o === "outline" ? "border border-purple-500 bg-transparent hover:bg-purple-400 active:bg-purple-600" : "bg-purple-500 focus:bg-purple-500 hover:bg-purple-400 active:bg-purple-600"
    }, f = {
      lime: o === "outline" ? "text-white hover:text-neutral-500" : "text-neutral-500",
      sky: "text-neutral-500",
      flamingo: "text-white",
      black: o === "outline" ? "text-neutral-500 hover:text-white" : "text-white",
      white: o === "outline" ? "text-white hover:text-neutral-500" : "text-neutral-500",
      purple: o === "outline" ? "text-purple-500 hover:text-white" : "text-white"
    }, h = C(
      m[e] || m.lime,
      // Default to lime if invalid color
      r === "md" ? "h-12" : "h-9",
      c ? r === "md" ? "w-12" : "w-9" : "",
      `text-button-${r}`,
      "focus:ring focus:ring-info-500 focus:outline-none",
      f[e] || f.lime
      // Default text color to lime
    );
    if (n) {
      const b = g ? /* @__PURE__ */ w(Se, { children: [
        u === "left" && p,
        /* @__PURE__ */ t("span", { children: g }),
        u === "right" && p
      ] }) : p;
      return /* @__PURE__ */ t(
        Fe,
        {
          href: n,
          openNewTab: i,
          ref: d,
          className: C(
            "button-base",
            "w-fit",
            //#region  //*=========== Variants ===========
            [
              o === "primary" && ["button-primary"],
              o === "outline" && ["button-outline"]
            ],
            [r === "sm" && ["button-small"]],
            //#endregion  //*======== Variants ===========
            "flex items-center justify-center",
            c && "rounded-cr-full",
            h,
            s
          ),
          size: a,
          ...v,
          children: b
        }
      );
    } else
      return /* @__PURE__ */ t(
        D0,
        {
          ref: d,
          icon: p,
          iconPosition: u,
          ...v,
          size: r,
          isRounded: c,
          className: h,
          children: g
        }
      );
  }
);
dr.displayName = "PromoButton";
const Qa = dr, Ja = (e) => {
  switch (e) {
    case "white":
      return "purple";
    case "grey":
      return "black";
    case "black":
      return "white";
    case "purple":
      return "lime";
    case "purpleDark":
      return "lime";
    default:
      return "purple";
  }
}, es = (e) => ({
  white: "bg-white",
  grey: "bg-neutral-100",
  black: "bg-neutral-900",
  purple: "bg-purple-500",
  purpleDark: "bg-purple-900"
})[e] || "bg-white", tt = (e) => ({
  black: "text-white",
  purple: "text-white",
  purpleDark: "text-white"
})[e] || "", ur = ({
  caption: e,
  h1: r,
  h2: o,
  h3: n,
  subHeader: i,
  description: s,
  cta: a,
  image: c,
  className: u = "",
  backgroundColour: p = "white",
  contentPosition: g = "left",
  customImage: v
}) => {
  const d = g === "right", m = C(
    "inline-flex flex-col items-start justify-center gap-4 grow shrink basis-0",
    d ? "order-2" : "order-1"
  );
  return /* @__PURE__ */ t(
    "div",
    {
      className: C(
        "w-full py-10 px-4 md:px-6 lg:px-[12] xl:px-[126px] justify-start inline-flex flex-col md:flex-row",
        u,
        es(p)
      ),
      children: /* @__PURE__ */ w("div", { className: "w-full max-w-[1536px] flex flex-col md:flex-row self-center gap-8 lg:gap-16 m-auto", children: [
        /* @__PURE__ */ w("div", { className: m, children: [
          e && /* @__PURE__ */ t("div", { className: "inline-flex items-center self-stretch justify-start gap-4", children: /* @__PURE__ */ t(
            "span",
            {
              className: C(
                "text-body-lg-400",
                tt(p)
              ),
              children: e
            }
          ) }),
          r || o || n ? /* @__PURE__ */ w("div", { className: "inline-flex flex-col items-start self-stretch justify-start gap-2", children: [
            r && /* @__PURE__ */ t(
              Ct,
              {
                type: "h1",
                size: "xs",
                className: tt(p),
                children: r
              }
            ),
            o && /* @__PURE__ */ t(
              Ct,
              {
                type: "h2",
                size: "xs",
                className: tt(p),
                children: o
              }
            ),
            n && /* @__PURE__ */ t(
              Ct,
              {
                type: "h3",
                size: "xs",
                className: tt(p),
                children: n
              }
            )
          ] }) : null,
          i && /* @__PURE__ */ t("div", { className: "inline-flex items-start self-stretch justify-start gap-2", children: /* @__PURE__ */ t(
            "h2",
            {
              className: O(
                "text-subheading-md",
                tt(p)
              ),
              children: i
            }
          ) }),
          s && /* @__PURE__ */ t("div", { className: "inline-flex items-start self-stretch justify-start gap-2", children: /* @__PURE__ */ t(
            "div",
            {
              className: O(
                "text-body-xl-400",
                tt(p)
              ),
              children: /* @__PURE__ */ t(Hn, { dirtyHtml: s })
            }
          ) }),
          (a == null ? void 0 : a.length) > 0 && /* @__PURE__ */ t("div", { className: "inline-flex items-start self-stretch justify-start gap-4", children: a.map((f, h) => /* @__PURE__ */ t(
            Qa,
            {
              ...f,
              promoButtonColor: Ja(p),
              children: f.children
            },
            h
          )) })
        ] }),
        (c || v) && /* @__PURE__ */ w(
          "div",
          {
            className: C(
              "inline-flex flex-col items-start self-stretch justify-start grow shrink basis-0 rounded-cr-lg",
              d ? "order-1" : "order-2"
            ),
            children: [
              c && /* @__PURE__ */ t(
                ot,
                {
                  ...c,
                  className: "object-cover w-full h-full rounded-cr-lg"
                }
              ),
              v && !c && v
            ]
          }
        )
      ] })
    }
  );
};
ur.displayName = "PageBlock";
const dl = ur, ts = (e, r) => {
  const o = Qr(r, e, {
    roundingMethod: "ceil"
  });
  if (o <= 0)
    return;
  if (o <= 1)
    return "less than 1 minute";
  if (o < 60)
    return `less than ${o} minutes`;
  const n = C0(r, e, {
    roundingMethod: "ceil"
  });
  if (n <= 12)
    return `less than ${n} hours`;
  const i = x0(r, e);
  if (i < 1)
    return "Today";
  if (i < 2)
    return "Tomorrow";
  if (i <= 30)
    return `${i} days`;
}, rs = (e, r) => {
  if (C0(r, e, {
    roundingMethod: "ceil"
  }) <= 8)
    return "Ends soon";
  const n = x0(r, e);
  if (n < 1)
    return "Ends today";
  if (n < 2)
    return "Ends tomorrow";
  if (n <= 30)
    return `Ends in ${n} days`;
}, os = (e) => (r) => {
  const o = La();
  return /* @__PURE__ */ t(
    e,
    {
      ...r,
      isAdImpressionVisible: (o.intersectionRatio ?? 0) > 0.8 && !o.isScrolling
    }
  );
}, Ot = {
  EXCLUSIVE: { label: "EXCLUSIVE", color: "lime-strong" },
  END_DATE_COUNT: { label: "", color: "flamingo-strong" },
  DOUBLE_CASHBACK: { label: "2X CASHBACK", color: "lime-strong" },
  TRIPLE_CASHBACK: { label: "3X CASHBACK", color: "lime-strong" },
  QUADRUPLE_CASHBACK: { label: "4X CASHBACK", color: "lime-strong" },
  ANZ_PREMIUM_OFFERS: { label: "PREMIUM", color: "lime-strong" },
  NEW_STORE: { label: "NEW STORE", color: "lime-strong" }
}, ul = Object.keys(Ot), fr = ({
  imageUrl: e,
  logoUrl: r,
  onClick: o,
  className: n,
  title: i,
  description: s,
  commissionString: a,
  subComissionString: c,
  endDate: u,
  isFavourite: p,
  aspectRatio: g,
  imageHoverAnimation: v,
  isAdvert: d,
  badgeType: m,
  onFavouriteChange: f,
  href: h,
  terms: b,
  badgeContainerClassName: _,
  adText: y = "AD",
  imageLoading: k = "lazy",
  adImpressionUrl: L,
  isAdImpressionVisible: A,
  hideFavouriteIcon: R,
  cardImageAs: z,
  ...I
}) => {
  const [B, E] = J(u), [S, T] = J();
  le(() => {
    if (u) {
      const j = ts(/* @__PURE__ */ new Date(), new Date(u));
      E(j);
    }
  }, [u]), le(() => {
    var j, te;
    if (m) {
      const U = (j = Ot[m]) == null ? void 0 : j.color;
      let me = (te = Ot[m]) == null ? void 0 : te.label;
      m === "END_DATE_COUNT" && u && (me = rs(/* @__PURE__ */ new Date(), new Date(u)) ?? ""), T({ color: U, label: me });
    }
  }, [m, u]);
  const $ = H(() => {
    f && f(!p);
  }, [p, f]);
  return /* @__PURE__ */ w(
    qt,
    {
      onClick: o,
      href: h || "",
      className: we("w-[256px] text-body-md-400", n),
      "aria-label": `${i} card`,
      ...I,
      children: [
        /* @__PURE__ */ w(Wt, { "data-test-id": "offer-card-header", children: [
          /* @__PURE__ */ t(
            rr,
            {
              as: z,
              "data-test-id": "offer-card-image",
              src: e,
              aspectRatio: g,
              imageHoverAnimation: v,
              alt: `${i} offer background image`,
              loading: k,
              className: "w-full"
            }
          ),
          r && /* @__PURE__ */ t(
            G0,
            {
              src: r,
              alt: `${i} logo`,
              "data-test-id": "offer-card-avatar",
              loading: k
            }
          ),
          (S == null ? void 0 : S.label) && (S == null ? void 0 : S.color) && /* @__PURE__ */ t(
            Y0,
            {
              className: we(_),
              "data-test-id": "offer-card-badge-container",
              children: /* @__PURE__ */ t(
                Ut,
                {
                  color: S.color,
                  size: "md",
                  "data-test-id": "offer-card-badge",
                  children: S.label
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ w(
          Ht,
          {
            "data-test-id": "offer-card-content",
            title: i,
            actionButton: /* @__PURE__ */ w(
              zt,
              {
                "data-test-id": "offer-card-action-button",
                onClick: $,
                "aria-label": `${p ? "Click to unfavourite the store" : "Click to favourite the store"}`,
                children: [
                  !R && /* @__PURE__ */ w(Se, { children: [
                    p && !d && /* @__PURE__ */ t(
                      Dt,
                      {
                        height: 24,
                        width: 24,
                        fillcolor: "#FF3B7A",
                        "data-test-id": "icon-favourite"
                      }
                    ),
                    !p && !d && /* @__PURE__ */ t(
                      $t,
                      {
                        height: 24,
                        width: 24,
                        "data-test-id": "icon-unfavourite"
                      }
                    )
                  ] }),
                  d && /* @__PURE__ */ t(kt, { color: "neutral-soft", size: "md", children: y }),
                  A && L && /* @__PURE__ */ t(
                    "img",
                    {
                      "aria-hidden": "true",
                      alt: "impression url",
                      src: L,
                      loading: "lazy",
                      className: "absolute left-[-1px] top-[-1px] p-0 border-0 whitespace-nowrap overflow-hidden -m-[1px] h-[1px] w-[1px]"
                    }
                  )
                ]
              }
            ),
            children: [
              /* @__PURE__ */ w(
                "div",
                {
                  className: "flex flex-col gap-1",
                  "data-test-id": "offer-card-content-additional",
                  children: [
                    s && /* @__PURE__ */ t(
                      "span",
                      {
                        className: "line-clamp-2",
                        "data-test-id": "offer-card-description",
                        children: s
                      }
                    ),
                    (a || c) && /* @__PURE__ */ w("div", { className: "flex flex-col", children: [
                      a && /* @__PURE__ */ t(
                        "span",
                        {
                          className: "line-clamp-2 text-cr-body-lg-800 text-primary-500 font-primary",
                          "data-test-id": "offer-card-commission",
                          children: a
                        }
                      ),
                      c && /* @__PURE__ */ t(
                        "span",
                        {
                          className: "line-clamp-2 text-primary-500",
                          "data-test-id": "offer-card-sub-commission",
                          children: c
                        }
                      )
                    ] }),
                    b && /* @__PURE__ */ t("span", { "data-test-id": "offer-card-terms", className: "text-primary-500", children: b })
                  ]
                }
              ),
              B && /* @__PURE__ */ w("div", { "data-test-id": "offer-card-end-date", className: "text-neutral-400", children: [
                "Ends: ",
                B
              ] })
            ]
          }
        )
      ]
    }
  );
}, fl = os(fr), pl = fr, ns = ({
  href: e,
  logoUrl: r,
  merchantName: o,
  commissionString: n,
  onFavouriteToggle: i,
  isFavourite: s,
  badgeType: a,
  onClick: c,
  ...u
}) => /* @__PURE__ */ w(
  qt,
  {
    className: "w-[256px] text-cr-body-md-400",
    as: Fe,
    href: e,
    onClick: c,
    ...u,
    children: [
      /* @__PURE__ */ w(Wt, { "data-test-id": "store-card-header", children: [
        /* @__PURE__ */ t(
          q0,
          {
            "data-test-id": "store-card-logo",
            src: r,
            aspectRatio: "16:9",
            imageHoverAnimation: !1,
            alt: `${o} avatar image`
          }
        ),
        /* @__PURE__ */ t(Y0, { children: a !== void 0 && a === "NEW_STORE" && /* @__PURE__ */ t(Ut, { color: "lime-strong", children: "NEW STORE" }) })
      ] }),
      /* @__PURE__ */ t(
        Ht,
        {
          "data-test-id": "store-card-content",
          title: o,
          actionButton: /* @__PURE__ */ t(
            zt,
            {
              "data-test-id": "store-card-favourite-toggle-button",
              onClick: () => i(!s),
              "aria-label": `${s ? "Click to unfavourite the store" : "Click to favourite the store"}`,
              children: s ? /* @__PURE__ */ t(
                Dt,
                {
                  height: 24,
                  width: 24,
                  fillcolor: "#FF3B7A",
                  "data-test-id": "icon-favourite"
                }
              ) : /* @__PURE__ */ t(
                $t,
                {
                  height: 24,
                  width: 24,
                  "data-test-id": "icon-unfavourite"
                }
              )
            }
          ),
          children: /* @__PURE__ */ t("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ t(
            "span",
            {
              "data-test-id": "store-card-commission",
              className: "line-clamp-2 text-cr-body-lg-800 text-primary-500 font-primary",
              children: n
            }
          ) })
        }
      )
    ]
  }
), ml = ns, hl = ({
  children: e,
  totalSlides: r,
  ...o
}) => {
  const n = r <= 5 && r > 1, i = ze(() => {
    if (!n)
      return { lg: { padding: void 0 } };
  }, [n]);
  return /* @__PURE__ */ w(
    ja,
    {
      gap: "8px",
      totalSlides: r,
      ...o,
      responsiveOptions: i,
      paddingLeft: n ? "0px" : "24px",
      children: [
        /* @__PURE__ */ w("div", { className: "relative", children: [
          /* @__PURE__ */ t(Ga, { children: e }),
          r > 1 && /* @__PURE__ */ t(Ha, {}, "nav")
        ] }),
        n && /* @__PURE__ */ t("div", { className: "mt-cr-2", children: /* @__PURE__ */ t(qa, {}) })
      ]
    }
  );
}, gl = ({
  className: e,
  ...r
}) => /* @__PURE__ */ t(
  Ua,
  {
    ...r,
    className: we(
      "flex items-center justify-center max-w-full overflow-hidden object-contain",
      e
    )
  }
), bl = function({
  as: r,
  className: o,
  src: n,
  ...i
}) {
  return /* @__PURE__ */ t(
    r || ot,
    {
      className: we("w-full rounded-cr-lg", o),
      src: n,
      ...i
    }
  );
};
export {
  cl as Accordion,
  ll as AccordionContent,
  sl as AccordionHeader,
  al as AccordionItem,
  bt as ActionButton,
  Ts as AlertBox,
  Rs as AppButton,
  il as ArticleTag,
  Fn as Avatar,
  kt as Badge,
  hl as BannerSlider,
  bl as BannerSliderImage,
  gl as BannerSliderSlideItem,
  Gs as BottomSheet,
  Qs as BrazeContentCards,
  Bs as Breadcrumb,
  Vt as Button,
  B0 as ButtonLink,
  qt as Card,
  G0 as CardAvatar,
  Ut as CardBadge,
  Y0 as CardBadgeContainer,
  Ht as CardContent,
  zt as CardContentActionButton,
  Wt as CardHeader,
  rr as CardImage,
  q0 as CardLogo,
  el as Carousel,
  Js as CarouselArrowButton,
  ol as CarouselHorizontalList,
  tl as CarouselNext,
  rl as CarouselPrevious,
  nl as CarouselSlideItem,
  Es as Checkbox,
  qs as CreditCardInput,
  a0 as DateTime,
  js as Dialog,
  Ct as Heading,
  Y as Icon,
  D0 as IconButton,
  Cn as IconLink,
  ot as Image,
  Ks as ImageBanner,
  Vs as MarqueeCard,
  wa as MarqueeText,
  Hs as MobileInput,
  Zs as NotifierButton,
  Us as OTPInput,
  ul as OfferBadges,
  pl as OfferCard,
  fl as OfferCardWithImpression,
  dl as PageBlock,
  zs as Pagination,
  Qa as PromoButton,
  Ps as SSOButton,
  Hn as SanitizedHtml,
  Ws as SearchResultCard,
  $s as SecondaryTabs,
  Is as Select,
  Ls as SelectGroup,
  As as SelectItem,
  R0 as Skeleton,
  ja as Slider,
  b0 as SliderArrowButton,
  Ga as SliderList,
  Ha as SliderNavigation,
  Va as SliderNext,
  Wa as SliderPrevious,
  Ua as SliderSlideItem,
  qa as SliderStepper,
  Ms as Spinner,
  Ra as Stepper,
  g0 as StepperDot,
  Ys as StickyBanner,
  ml as StoreCard,
  Ds as Tabs,
  Ns as TextLink,
  _t as Textfield,
  Os as Toaster,
  Ss as Toggle,
  L0 as UnderlineLink,
  Fe as UnstyledLink,
  Xs as VideoBanner,
  i0 as VideoPlayer,
  St as useSliderContext
};
//# sourceMappingURL=cr-ui-components.mjs.map
